// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28134, 182.5, 254%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%285.2, 44, 101.2%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../public/images/banner-shape.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../public/images/dotted-line.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../public/images/horizontal-dotted-line.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2710%27 viewBox=%270 0 16 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1.82902 9.14293L0.286121 7.71436L8.00042 0.571499L15.7147 7.71439L14.1719 9.14296L8.00042 3.4287L1.82902 9.14293Z%27 fill=%27%23494949%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2710%27 viewBox=%270 0 16 10%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M14.171 0.857055L15.7139 2.28562L7.99958 9.42849L0.285278 2.2856L1.82814 0.857025L7.99958 6.57128L14.171 0.857055Z%27 fill=%27%23494949%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../public/images/home-blog-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(10.4, 88, 202.4);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 100%;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 100%;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 100%;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1224px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1224px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 226, 254.6);
  --bs-table-border-color: rgb(165.28, 180.8, 203.68);
  --bs-table-striped-bg: rgb(196.27, 214.7, 241.87);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 203.4, 229.14);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 209.05, 235.505);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-border-color: rgb(180.48, 181.92, 183.2);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(209, 231, 220.8);
  --bs-table-border-color: rgb(167.2, 184.8, 176.64);
  --bs-table-striped-bg: rgb(198.55, 219.45, 209.76);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(188.1, 207.9, 198.72);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(193.325, 213.675, 204.24);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 244.4, 252);
  --bs-table-border-color: rgb(165.28, 195.52, 201.6);
  --bs-table-striped-bg: rgb(196.27, 232.18, 239.4);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 219.96, 226.8);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 226.07, 233.1);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 242.6, 205.4);
  --bs-table-border-color: rgb(204, 194.08, 164.32);
  --bs-table-striped-bg: rgb(242.25, 230.47, 195.13);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 218.34, 184.86);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 224.405, 189.995);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(248, 214.6, 217.8);
  --bs-table-border-color: rgb(198.4, 171.68, 174.24);
  --bs-table-striped-bg: rgb(235.6, 203.87, 206.91);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 193.14, 196.02);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 198.505, 201.465);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(198.4, 199.2, 200);
  --bs-table-striped-bg: rgb(235.6, 236.55, 237.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 224.1, 225);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 230.325, 231.25);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(77.4, 80.6, 83.8);
  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(11.05, 93.5, 215.05);
  --bs-btn-hover-border-color: rgb(10.4, 88, 202.4);
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(10.4, 88, 202.4);
  --bs-btn-active-border-color: rgb(9.75, 82.5, 189.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(91.8, 99.45, 106.25);
  --bs-btn-hover-border-color: rgb(86.4, 93.6, 100);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86.4, 93.6, 100);
  --bs-btn-active-border-color: rgb(81, 87.75, 93.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(21.25, 114.75, 71.4);
  --bs-btn-hover-border-color: rgb(20, 108, 67.2);
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(20, 108, 67.2);
  --bs-btn-active-border-color: rgb(18.75, 101.25, 63);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(49.3, 209.95, 242.25);
  --bs-btn-hover-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(61.4, 212.6, 243);
  --bs-btn-active-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 202.3, 44.2);
  --bs-btn-hover-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 205.4, 56.6);
  --bs-btn-active-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(187, 45.05, 58.65);
  --bs-btn-hover-border-color: rgb(176, 42.4, 55.2);
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(176, 42.4, 55.2);
  --bs-btn-active-border-color: rgb(165, 39.75, 51.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(210.8, 211.65, 212.5);
  --bs-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(198.4, 199.2, 200);
  --bs-btn-active-border-color: rgb(186, 186.75, 187.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(66.3, 69.7, 73.1);
  --bs-btn-hover-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(77.4, 80.6, 83.8);
  --bs-btn-active-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
body {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  color: #000;
}

img {
  outline: none;
  border: none;
  max-width: 100%;
}

p {
  margin: 0px;
}

a {
  text-decoration: none;
}

button:focus {
  outline: none;
}

.margin-top-70 {
  margin-top: 70px;
}
@media (max-width: 1024px) {
  .margin-top-70 {
    margin-top: 50px;
  }
}
@media (max-width: 767px) {
  .margin-top-70 {
    margin-top: 40px;
  }
}

.margin-bottom-70 {
  margin-bottom: 70px;
}
@media (max-width: 1024px) {
  .margin-bottom-70 {
    margin-bottom: 50px;
  }
}
@media (max-width: 767px) {
  .margin-bottom-70 {
    margin-bottom: 40px;
  }
}

#root {
  display: inline-block;
  vertical-align: top;
  width: 100%;
}

.navbar-nav {
  gap: 50px;
}
@media (max-width: 991px) {
  .navbar-nav {
    gap: 30px;
  }
}
@media (max-width: 767px) {
  .navbar-nav {
    gap: 0px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.navbar-nav a {
  color: #000;
}
@media (max-width: 767px) {
  .navbar-nav a {
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding: 8px 15px;
  }
}

.default-btn-style {
  background: #FF4103;
  border-radius: 20px;
  padding: 10px 20px;
  line-height: normal;
  letter-spacing: normal;
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
@media (max-width: 767px) {
  .default-btn-style {
    font-size: 15px;
    padding: 9px 18px;
  }
}
@media (max-width: 360px) {
  .default-btn-style {
    font-size: 14px;
  }
}
@media (max-width: 360px) {
  .default-btn-style svg {
    width: 13px;
  }
}
.default-btn-style:hover {
  background: #000;
}
.default-btn-style:active {
  background: #000 !important;
}

.menu {
  height: 75px;
}
@media (max-width: 767px) {
  .menu {
    position: relative;
    height: 65px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}
.menu .navbar-nav a:hover {
  color: #FF4103;
}
.menu .navbar-brand img {
  max-width: 250px;
}

.banner {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat bottom center/100%;
}
.banner h1, .banner .h1 {
  font-size: 54px;
  font-weight: 700;
  margin: 70px 0 0;
  line-height: 113.4%;
}
@media (max-width: 1200px) {
  .banner h1, .banner .h1 {
    font-size: 40px;
  }
}
@media (max-width: 767px) {
  .banner h1, .banner .h1 {
    margin: 40px 0px 0px;
    font-size: 30px;
  }
}
@media (max-width: 575px) {
  .banner h1, .banner .h1 {
    margin-top: 25px;
  }
}
.banner h1 span, .banner .h1 span {
  color: #FF4103;
}
.banner p {
  font-size: 20px;
  color: #968C8C;
  max-width: 490px;
  line-height: 140%;
  margin: 25px 0;
}
@media (max-width: 1200px) {
  .banner p {
    font-size: 18px;
  }
}
@media (max-width: 767px) {
  .banner p {
    max-width: 100%;
    margin: 15px 0;
    font-size: 15px;
  }
}
.banner img {
  margin: 108px 0 0;
}
@media (max-width: 767px) {
  .banner img {
    margin-top: 30px;
  }
}
@media (max-width: 575px) {
  .banner img {
    margin-left: auto;
    margin-right: auto;
    max-width: 250px;
    display: block;
  }
}

.section-title {
  font-size: 40px;
  line-height: 113.4%;
  font-weight: 600;
  color: #000;
}
@media (max-width: 1200px) {
  .section-title {
    font-size: 32px;
  }
}
@media (max-width: 767px) {
  .section-title {
    font-size: 25px;
  }
}
.section-title span {
  color: #FF4103;
}

.section-title-mark {
  margin: 3px 0 47px;
}
@media (max-width: 767px) {
  .section-title-mark {
    margin-bottom: 35px;
  }
}
.section-title-mark::before {
  content: "";
  width: 64px;
  height: 2px;
  background: #000;
}
@media (max-width: 1200px) {
  .section-title-mark::before {
    width: 50px;
  }
}
.section-title-mark::after {
  content: "";
  width: 64px;
  height: 2px;
  background: #000;
}
@media (max-width: 1200px) {
  .section-title-mark::after {
    width: 50px;
  }
}
.section-title-mark span {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #FF4103;
  margin: 0 6px;
}

.steps-items {
  background: #FF4103;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  flex: unset;
}
@media (max-width: 767px) {
  .steps-items {
    width: 60px;
    height: 60px;
    padding: 7px;
  }
}
@media (max-width: 767px) {
  .steps-items {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 767px) {
  .our-process.margin-bottom-70 {
    margin-bottom: 0px;
  }
}
@media (max-width: 767px) {
  .our-process .our-process-img {
    order: 2;
  }
}
@media (max-width: 767px) {
  .our-process .our-process-img img {
    display: block;
    margin: 60px auto 0;
  }
}
.our-process .our-process-right-column {
  max-width: 515px;
  margin: 0 0 0 auto;
  position: relative;
}
@media (max-width: 767px) {
  .our-process .our-process-right-column {
    max-width: 100%;
  }
}
.our-process .our-process-right-column::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  height: 39px;
  width: 2px;
  margin: 0 0 0 35px;
  position: absolute;
  bottom: 0;
}
@media (max-width: 767px) {
  .our-process .our-process-right-column::before {
    display: none;
  }
}
.our-process .our-process-right-column::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  height: 2px;
  width: 108px;
  margin: 37px 0 0 38px;
  vertical-align: top;
  display: inline-block;
}
@media (max-width: 767px) {
  .our-process .our-process-right-column::after {
    display: none;
  }
}
.our-process .accordion {
  width: 100%;
}
.our-process .accordion-item {
  border: none;
  border-radius: 0;
  position: relative;
  padding: 0 0 25px;
}
@media (max-width: 767px) {
  .our-process .accordion-item {
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
    margin-bottom: 15px;
  }
}
.our-process .accordion-item::before {
  content: "";
  position: absolute;
  left: 35px;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  width: 2px;
}
@media (max-width: 767px) {
  .our-process .accordion-item::before {
    display: none;
  }
}
.our-process .accordion-item .accordion-button {
  background: none;
  box-shadow: none;
  border: none;
  padding: 0;
  flex-wrap: wrap;
}
.our-process .accordion-item .accordion-button span {
  color: #000;
}
.our-process .accordion-item .accordion-button::after {
  content: "";
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  width: 15px;
  height: 9px;
  background-size: 100%;
  margin: 0px 22px 0 0;
  transform: unset;
}
@media (max-width: 767px) {
  .our-process .accordion-item .accordion-button::after {
    margin-right: 10px;
  }
}
.our-process .accordion-item .accordion-button.collapsed::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.our-process .accordion-item .accordion-button .steps-title {
  width: calc(100% - 157px);
  margin: 0 10px 0 40px;
  flex: unset;
}
@media (max-width: 991px) {
  .our-process .accordion-item .accordion-button .steps-title {
    width: calc(100% - 142px);
    margin-left: 25px;
  }
}
@media (max-width: 767px) {
  .our-process .accordion-item .accordion-button .steps-title {
    width: calc(100% - 120px);
    font-size: 15px;
    margin-left: 15px;
  }
}
@media (max-width: 575px) {
  .our-process .accordion-item .accordion-button .steps-title {
    font-size: 14px;
  }
}
.our-process .accordion-item .accordion-button label {
  color: #FF4103;
  margin: 0 0 5px;
}
.our-process .accordion-item .accordion-collapse {
  padding: 10px 0 0 110px;
  position: relative;
}
@media (max-width: 991px) {
  .our-process .accordion-item .accordion-collapse {
    padding: 10px 0 0 95px;
  }
}
@media (max-width: 767px) {
  .our-process .accordion-item .accordion-collapse {
    padding: 10px 0 0 75px;
    font-size: 15px;
  }
}
@media (max-width: 575px) {
  .our-process .accordion-item .accordion-collapse {
    font-size: 14px;
  }
}
.our-process .book-consultation {
  margin: 0px;
  gap: 7px;
  display: flex;
  align-items: center;
  position: absolute;
  bottom: -16px;
  left: 161px;
}
@media (max-width: 767px) {
  .our-process .book-consultation {
    position: static;
    margin: 20px auto 0;
  }
}

.section-subtitle {
  line-height: 120%;
  font-size: 14px;
  margin-top: 10px;
  color: #000;
}

.expertise-our-developers {
  background: #F8F8FA;
  padding: 50px 0;
}
@media (max-width: 767px) {
  .expertise-our-developers {
    padding: 40px 0px;
  }
}
.expertise-our-developers .section-subtitle {
  margin-bottom: 84px;
}
@media (max-width: 991px) {
  .expertise-our-developers .section-subtitle {
    margin-bottom: 60px;
  }
}

.square-shape {
  background: #FF4103;
  border-radius: 5px;
  width: 100px;
  height: 100px;
  transform: translate(-50%, 0) rotate(45deg);
  left: 50%;
  position: relative;
  margin: 0 0 -50px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 991px) {
  .square-shape {
    width: 80px;
    height: 80px;
  }
}
.square-shape img, .square-shape svg {
  max-height: 50px;
  transform: rotate(-45deg);
}
@media (max-width: 991px) {
  .square-shape img, .square-shape svg {
    max-height: 42px;
  }
}

.expertise-our-developers-list {
  gap: 76px 0px;
}
@media (max-width: 991px) {
  .expertise-our-developers-list {
    gap: 40px 0px;
  }
}

.developers-list {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 103px 20px 22px;
  height: calc(100% - 50px);
}
@media (max-width: 991px) {
  .developers-list {
    padding: 90px 15px 22px;
    height: calc(100% - 30px);
  }
}
.developers-list .read-more {
  margin-top: auto;
}
.developers-list label {
  font-size: 20px;
  font-weight: 600;
  line-height: 113.4%;
  vertical-align: top;
}
@media (max-width: 991px) {
  .developers-list label {
    font-size: 18px;
  }
}
.developers-list p {
  line-height: 125%;
  margin: 15px 0px;
}
@media (max-width: 991px) {
  .developers-list p {
    font-size: 15px;
  }
}

.read-more {
  color: #FF4103;
  font-size: 15px;
}
@media (max-width: 400px) {
  .read-more {
    font-size: 14px;
  }
}
.read-more svg {
  margin: 0 0 0 7px;
  width: 13px;
  height: auto;
}
@media (max-width: 400px) {
  .read-more svg {
    width: 12px;
  }
}
.read-more:hover {
  color: #000;
}
.read-more:hover path {
  fill: #000;
}

.hire-developer-btn {
  display: inline-flex;
  margin: 50px 0 0;
}

.home-why-choose-inner-content {
  gap: 15px;
}
.home-why-choose-inner-content svg {
  height: 70px;
  width: auto;
}
.home-why-choose-inner-content strong {
  width: 100%;
  line-height: 113.4%;
  margin: 25px 0 6px;
}
.home-why-choose-inner-content p {
  line-height: 113.4%;
  font-size: 14px;
}
.home-why-choose-inner-content > div {
  max-width: 245px;
}

.home-why-choose-us .section-subtitle {
  margin-bottom: 60px;
}
@media (max-width: 767px) {
  .home-why-choose-us .section-subtitle {
    margin-bottom: 45px;
  }
}
.home-why-choose-us .home-why-choose-us-content {
  max-width: 538px;
}
@media (max-width: 767px) {
  .home-why-choose-us .home-why-choose-us-content {
    order: -1;
    max-width: 100%;
  }
}
@media (max-width: 767px) {
  .home-why-choose-us .home-why-chooseus-img img {
    margin: 30px auto 0px;
    display: block;
  }
}

.progress-container {
  gap: 50px;
  margin: 60px 0px 0px;
}
@media (max-width: 991px) {
  .progress-container {
    gap: 30px;
  }
}
@media (max-width: 450px) {
  .progress-container {
    margin-top: 40px;
  }
}
@media (max-width: 400px) {
  .progress-container {
    gap: 20px;
  }
}
.progress-container .circle {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media (max-width: 450px) {
  .progress-container .circle {
    max-width: 100px;
  }
}
@media (max-width: 370px) {
  .progress-container .circle {
    max-width: 80px;
  }
}
@media (max-width: 450px) {
  .progress-container .circle canvas {
    max-width: 100px;
    max-height: 100px;
  }
}
@media (max-width: 370px) {
  .progress-container .circle canvas {
    max-width: 80px;
    max-height: 80px;
  }
}
.progress-container .circle .items-value {
  position: absolute;
  width: 100%;
  height: calc(100% - 36px);
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 450px) {
  .progress-container .circle .items-value {
    height: calc(100% - 28px);
  }
}
.progress-container .circle .items-value strong {
  font-size: 20px;
}
@media (max-width: 400px) {
  .progress-container .circle .items-value strong {
    font-size: 18px;
  }
}
.progress-container span {
  font-weight: 600;
  margin: 12px 0 0;
  color: #000;
}
@media (max-width: 450px) {
  .progress-container span {
    margin: 7px 0 0;
    font-size: 14px;
  }
}
@media (max-width: 370px) {
  .progress-container span {
    font-size: 12px;
  }
}

.our-testimonial .section-subtitle {
  max-width: 498px;
  margin-bottom: 60px;
}

.our-testimonial .testimonial-top-portion .client-logo {
  max-height: 25px;
  max-width: 200px;
}
@media (max-width: 991px) {
  .our-testimonial .testimonial-top-portion .client-logo {
    max-height: 22px;
  }
}
.our-testimonial .testimonial-top-portion .client-quotes {
  max-height: 30px;
}
@media (max-width: 1200px) {
  .our-testimonial .testimonial-top-portion .client-quotes {
    max-height: 25px;
  }
}
.our-testimonial .slick-track {
  display: flex;
}
.our-testimonial .slick-list {
  margin: 0 -12px;
}
.our-testimonial .slick-slide {
  padding: 0 12px;
  height: unset;
  display: flex;
}
.our-testimonial .slide-item {
  background: #F8F8FA;
  border-radius: 20px;
  padding: 20px;
  height: 100%;
  min-height: 350px;
}
@media (max-width: 991px) {
  .our-testimonial .slide-item {
    padding: 15px;
  }
}
@media (max-width: 575px) {
  .our-testimonial .slide-item {
    min-height: 280px;
  }
}
.our-testimonial .slide-item p {
  line-height: 140%;
  margin: 28px 0 15px;
}
@media (max-width: 1200px) {
  .our-testimonial .slide-item p {
    font-size: 15px;
  }
}
.our-testimonial .client {
  margin: auto 0 0;
}
.our-testimonial .client-image {
  width: 49px;
  height: 49px;
  border-radius: 50%;
}
.our-testimonial .client-image img {
  border-radius: 100%;
}
.our-testimonial .client-info {
  width: calc(100% - 64px);
  margin: 0 0 0 15px;
}
.our-testimonial .client-info label {
  font-size: 20px;
  vertical-align: top;
  font-weight: 600;
  width: 100%;
  color: #000;
  line-height: 120%;
}
@media (max-width: 1200px) {
  .our-testimonial .client-info label {
    font-size: 18px;
  }
}
@media (max-width: 991px) {
  .our-testimonial .client-info label {
    font-size: 17px;
  }
}
.our-testimonial .client-info span {
  line-height: 120%;
  color: #8E8E8E;
}
@media (max-width: 1200px) {
  .our-testimonial .client-info span {
    font-size: 15px;
  }
}
.our-testimonial .slick-dots {
  bottom: -40px;
  height: 10px;
}
.our-testimonial .slick-dots li {
  width: 10px;
  height: 10px;
  background: #D9D9D9;
  border-radius: 50%;
  margin: 0 2.5px;
  vertical-align: top;
}
.our-testimonial .slick-dots li.slick-active {
  background: #FF4103;
}
.our-testimonial .slick-dots li button {
  width: 100%;
  height: 100%;
  padding: 0px;
}
.our-testimonial .slick-dots li button::before {
  display: none;
}

.home-blogbg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) no-repeat center bottom/100%;
  padding: 40px 0 0;
  margin: 50px 0 0;
}
.home-blogbg .section-title {
  margin-bottom: 40px;
}
@media (max-width: 767px) {
  .home-blogbg .section-title {
    margin-bottom: 30px;
  }
}
.home-blogbg .home-latest-blog {
  position: relative;
}
.home-blogbg .home-latest-blog .home-latest-blog-info {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  justify-content: end;
  color: #fff;
  padding: 0 30px 30px;
}
@media (max-width: 991px) {
  .home-blogbg .home-latest-blog .home-latest-blog-info {
    padding: 0 20px 20px;
  }
}
.home-blogbg .home-latest-blog .home-latest-blog-info > span {
  line-height: 140%;
  display: block;
  margin: 0 0 10px;
  width: 100%;
}
.home-blogbg .home-latest-blog .home-latest-blog-info label {
  font-size: 30px;
  vertical-align: top;
  font-weight: 600;
  line-height: 140%;
  margin: 0 0 14px;
}
@media (max-width: 1024px) {
  .home-blogbg .home-latest-blog .home-latest-blog-info label {
    font-size: 26px;
    line-height: 130%;
  }
}
@media (max-width: 400px) {
  .home-blogbg .home-latest-blog .home-latest-blog-info label {
    font-size: 20px;
  }
}
.home-blogbg .home-latest-blog .home-latest-blog-info .read-more {
  color: #fff;
}
.home-blogbg .home-latest-blog .home-latest-blog-info .read-more:hover {
  color: #FF4103;
}
.home-blogbg .home-latest-blog .home-latest-blog-info .read-more:hover path {
  fill: #FF4103;
}
.home-blogbg .home-latest-blog .home-latest-blog-img {
  height: 536px;
}
@media (max-width: 767px) {
  .home-blogbg .home-latest-blog .home-latest-blog-img {
    height: auto;
  }
}
.home-blogbg .home-latest-blog .home-latest-blog-img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.home-blogbg .home-latest-blog-left-column {
  max-width: 524px;
}
@media (max-width: 767px) {
  .home-blogbg .home-latest-blog-left-column {
    flex: 1 0 100%;
    max-width: 100%;
  }
}
@media (max-width: 767px) {
  .home-blogbg .home-latest-blog-right-column {
    margin-top: 40px;
  }
}
.home-blogbg .home-latest-blog-right-column .home-latest-blog-right-column-list {
  max-width: 650px;
  margin-left: auto;
  border-bottom: 1px solid #D9D9D9;
  padding: 0 0 25px;
  margin-bottom: 25px;
  flex-wrap: wrap;
  flex-direction: row;
}
@media (max-width: 767px) {
  .home-blogbg .home-latest-blog-right-column .home-latest-blog-right-column-list {
    max-width: 100%;
  }
}
.home-blogbg .home-latest-blog-right-column-list-content {
  width: calc(100% - 220px);
  align-content: flex-start;
  margin-right: 20px;
  flex-direction: row;
  flex-wrap: wrap;
}
@media (max-width: 340px) {
  .home-blogbg .home-latest-blog-right-column-list-content {
    margin-right: 10px;
  }
}
.home-blogbg .home-latest-blog-right-column-list-content > span {
  color: #696969;
  display: block;
  margin: 0 0 10px;
  font-size: 14px;
}
.home-blogbg .home-latest-blog-right-column-list-content label {
  font-size: 20px;
  line-height: 120%;
  color: #000;
  font-weight: 600;
  vertical-align: top;
  margin: 0 0 25px;
}
@media (max-width: 1024px) {
  .home-blogbg .home-latest-blog-right-column-list-content label {
    font-size: 18px;
  }
}
@media (max-width: 767px) {
  .home-blogbg .home-latest-blog-right-column-list-content label {
    margin: 0 0 18px;
  }
}
@media (max-width: 400px) {
  .home-blogbg .home-latest-blog-right-column-list-content label {
    font-size: 16px;
    margin-bottom: 10px;
  }
}
@media (max-width: 340px) {
  .home-blogbg .home-latest-blog-right-column-list-content label {
    font-size: 14px;
  }
}
.home-blogbg .home-latest-blog-right-column-list-content .read-more:hover {
  color: #FF4103;
}
.home-blogbg .home-latest-blog-right-column-list-content .read-more:hover path {
  fill: #FF4103;
}
.home-blogbg .home-latest-blog-right-image {
  width: 200px;
  flex: unset;
}
@media (max-width: 991px) {
  .home-blogbg .home-latest-blog-right-image {
    width: 150px;
  }
}
@media (max-width: 400px) {
  .home-blogbg .home-latest-blog-right-image {
    width: 130px;
  }
}
.home-blogbg .read-more {
  color: #000;
}
.home-blogbg .home-blog-viewall {
  margin: 20px 0 50px;
}
@media (max-width: 767px) {
  .home-blogbg .home-blog-viewall {
    margin: 0px 0 40px;
  }
}

.work-enquirybg {
  background: #304097;
  padding: 50px 0px;
}
.work-enquirybg .section-title {
  color: #fff;
}
.work-enquirybg .section-subtitle {
  color: #fff;
  margin-bottom: 55px;
}
@media (max-width: 991px) {
  .work-enquirybg .section-subtitle {
    margin-bottom: 40px;
  }
}
.work-enquirybg .work-enquiry-contact {
  max-width: 300px;
  margin: 0 0 30px;
}
.work-enquirybg .work-enquiry-contact-icon {
  width: 28px;
  flex: unset;
}
@media (max-width: 991px) {
  .work-enquirybg .work-enquiry-contact-icon {
    width: 22px;
  }
}
.work-enquirybg .work-enquiry-contact-icon svg {
  width: 100%;
}
.work-enquirybg .work-enquiry-contact-info {
  width: calc(100% - 57px);
  margin-left: 25px;
}
@media (max-width: 991px) {
  .work-enquirybg .work-enquiry-contact-info {
    width: calc(100% - 37px);
    margin-left: 15px;
  }
}
.work-enquirybg .work-enquiry-contact-info span {
  display: block;
  margin: 0 0 5px;
}
.work-enquirybg .work-enquiry-contact-info a {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}
@media (max-width: 991px) {
  .work-enquirybg .work-enquiry-contact-info a {
    font-size: 18px;
  }
}
.work-enquirybg .quiry-form-bg {
  background: #EAEAEA;
  border-radius: 15px;
  padding: 27px 20px 20px;
  max-width: 500px;
}
@media (max-width: 575px) {
  .work-enquirybg .quiry-form-bg {
    max-width: 100%;
  }
}
.work-enquirybg .quiry-form-bg label {
  font-size: 24px;
  font-weight: 600;
  line-height: 140%;
}
@media (max-width: 991px) {
  .work-enquirybg .quiry-form-bg label {
    font-size: 20px;
  }
}
.work-enquirybg .quiry-form-bg .section-subtitle {
  color: #000;
  margin-bottom: 30px;
}
.work-enquirybg .quiry-form-bg form {
  display: flex;
  flex-direction: row;
  gap: 15px;
  flex-wrap: wrap;
}
.work-enquirybg .quiry-form-bg form .btn {
  border-radius: 5px;
}
.work-enquirybg .quiry-form-bg .form-field {
  width: 100%;
}
.work-enquirybg .quiry-form-bg .form-control {
  height: 45px;
  border-radius: 5px;
  color: #000;
  border: none;
  font-size: 15px;
  padding: 10px 15px;
}
.work-enquirybg .quiry-form-bg .form-control.is-invalid {
  border: 1px solid var(--bs-form-invalid-border-color);
}
.work-enquirybg .quiry-form-bg .form-control:focus {
  box-shadow: none;
}
.work-enquirybg .quiry-form-bg .form-control::-webkit-input-placeholder {
  color: #696969;
}
.work-enquirybg .quiry-form-bg .form-control::-moz-input-placeholder {
  color: #696969;
}
.work-enquirybg .quiry-form-bg .form-control::-ms-input-placeholder {
  color: #696969;
}
.work-enquirybg .quiry-form-bg .form-control.messge {
  height: 90px;
}

.footer-column-first {
  max-width: 277px;
}
@media (max-width: 850px) {
  .footer-column-first {
    max-width: 170px;
  }
}
@media (max-width: 767px) {
  .footer-column-first {
    max-width: 100%;
  }
}
@media (max-width: 575px) {
  .footer-column-first {
    flex: 1 0 50%;
  }
}
@media (max-width: 400px) {
  .footer-column-first {
    flex: 1 0 100%;
  }
}
.footer-column-first p {
  margin-top: 20px;
  color: #fff;
  line-height: 120%;
  font-size: 14px;
}
@media (max-width: 850px) {
  .footer-column-first p {
    font-size: 15px;
  }
}
@media (max-width: 400px) {
  .footer-column-first p {
    margin-bottom: 20px;
  }
}
.footer-column-first p a {
  color: #fff;
  text-decoration: underline;
}

.footer-column-second {
  max-width: 160px;
}
@media (max-width: 767px) {
  .footer-column-second {
    max-width: 100%;
  }
}
@media (max-width: 575px) {
  .footer-column-second {
    flex: 1 0 50%;
  }
}

.footer-column-third {
  width: 212px;
  flex: unset;
}
@media (max-width: 991px) {
  .footer-column-third {
    width: 200px;
  }
}
@media (max-width: 767px) {
  .footer-column-third {
    max-width: 100%;
    flex: 1 0;
    width: auto;
  }
}
@media (max-width: 400px) {
  .footer-column-third {
    flex: 1 0 50%;
  }
}

.footer-column-menu label {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 10px;
  line-height: normal;
}
@media (max-width: 991px) {
  .footer-column-menu label {
    font-size: 18px;
  }
}
.footer-column-menu ul {
  margin: 0px;
  padding: 0;
}
.footer-column-menu ul li {
  list-style: none;
  margin: 0px 0 10px;
  padding: 0px;
}
.footer-column-menu ul li a {
  color: #fff;
}
@media (max-width: 991px) {
  .footer-column-menu ul li a {
    font-size: 15px;
    line-height: 100%;
  }
}

@media (max-width: 767px) {
  .footer-column-four {
    max-width: 100%;
    flex: 1 0 100%;
  }
}
.footer-column-four .form-field {
  background: #fff;
  padding: 5px 10px 5px 0;
  border-radius: 10px;
  display: flex;
}
.footer-column-four .form-field .form-control {
  background: none;
  border: none;
  padding: 0 17px;
}
.footer-column-four .form-field .form-control:focus {
  box-shadow: none;
}
.footer-column-four .form-field .form-control::-webkit-input-placeholder {
  color: #696969;
}
.footer-column-four .form-field .form-control::-moz-input-placeholder {
  color: #696969;
}
.footer-column-four .form-field .form-control::-ms-input-placeholder {
  color: #696969;
}
@media (max-width: 991px) {
  .footer-column-four .form-field .form-control {
    font-size: 14px;
  }
}
.footer-column-four .form-field .form-select {
  height: 45px;
  font-size: 14px;
}
.footer-column-four .form-field .form-select:focus {
  box-shadow: none;
  border-color: #dee2e6;
}
.footer-column-four .subscribe-form {
  width: 443px;
  max-width: 100%;
}
@media (max-width: 1200px) {
  .footer-column-four .subscribe-form {
    width: 370px;
  }
}
@media (max-width: 1024px) {
  .footer-column-four .subscribe-form {
    width: 330px;
  }
}
@media (max-width: 991px) {
  .footer-column-four .subscribe-form {
    width: 280px;
  }
}
@media (max-width: 850px) {
  .footer-column-four .subscribe-form {
    width: 260px;
  }
}
@media (max-width: 767px) {
  .footer-column-four .subscribe-form {
    margin-top: 15px;
    width: 100%;
  }
}
.footer-column-four .subscribe-form label {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin: 0 0 10px;
}
@media (max-width: 991px) {
  .footer-column-four .subscribe-form label {
    font-size: 18px;
  }
}
.footer-column-four .subscribe-form .btn {
  border-radius: 5px;
}
@media (max-width: 991px) {
  .footer-column-four .subscribe-form .btn {
    font-size: 14px;
    padding: 10px;
  }
}
.footer-column-four .social-icons {
  gap: 5px;
}
.footer-column-four .social-icons label {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  width: 100%;
  margin: 0px 0 10px;
  line-height: 24px;
}
@media (max-width: 991px) {
  .footer-column-four .social-icons label {
    font-size: 18px;
  }
}
.footer-column-four .social-icons-list {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 991px) {
  .footer-column-four .social-icons-list {
    width: 32px;
    height: 32px;
    padding: 7px;
  }
}

.footer-top {
  gap: 36px;
}
@media (max-width: 1100px) {
  .footer-top {
    gap: 25px;
  }
}
@media (max-width: 991px) {
  .footer-top {
    gap: 0px;
  }
}

.footer-bottom {
  background: #D9D9D9;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 12px;
}
@media (max-width: 991px) {
  .footer-bottom {
    font-size: 15px;
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
@media (max-width: 400px) {
  .footer-bottom {
    font-size: 14px;
    line-height: normal;
    padding-top: 12px;
    padding-bottom: 12px;
  }
}
.footer-bottom a {
  color: #000;
  text-decoration: underline;
  margin: 0 0 0 4px;
}

@media (max-width: 767px) {
  .navbar-collapse {
    background: #fff;
    position: absolute;
    left: 0;
    width: 100%;
    top: 100%;
    z-index: 1;
  }
}

@media (max-width: 767px) {
  .navbar-toggler {
    padding: 4px 8px;
  }
}
.navbar-toggler:focus {
  box-shadow: none;
}

.headingone {
  font-size: 54px;
  font-weight: 600;
  color: #000;
  line-height: 100%;
}
@media (max-width: 1200px) {
  .headingone {
    font-size: 40px;
  }
}
@media (max-width: 767px) {
  .headingone {
    font-size: 30px;
  }
}

.pageHeader {
  position: relative;
}
.pageHeader .headingone {
  margin-bottom: 10px;
  color: #fff;
}
.pageHeader-Image img {
  max-height: 450px;
  object-fit: cover;
}
@media (max-width: 767px) {
  .pageHeader-Image img {
    height: 230px;
    object-fit: cover;
  }
}
.pageHeader-Bg {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
}
.pageHeader .breadcrumb {
  margin: 0px;
}
.pageHeader .breadcrumb .breadcrumb-item {
  font-size: 18px;
}
@media (max-width: 767px) {
  .pageHeader .breadcrumb .breadcrumb-item {
    font-size: 16px;
  }
}
.pageHeader .breadcrumb .breadcrumb-item::before {
  display: none;
}
.pageHeader .breadcrumb .breadcrumb-item a {
  font-size: 18px;
  color: #fff;
}
@media (max-width: 767px) {
  .pageHeader .breadcrumb .breadcrumb-item a {
    font-size: 16px;
  }
}
.pageHeader .breadcrumb .breadcrumb-item a:hover {
  color: #FF4103;
}
.pageHeader .breadcrumb .breadcrumb-item.active {
  color: #fff;
}
.pageHeader .breadcrumb .pie {
  color: #fff;
  line-height: normal;
  display: flex;
  align-items: center;
}

@media (max-width: 767px) {
  .who-we-are-img {
    margin-top: 20px;
  }
}
@media (max-width: 767px) {
  .who-we-are img {
    width: 100%;
  }
}
.who-we-are-content {
  margin-left: 26px;
}
@media (max-width: 767px) {
  .who-we-are-content {
    margin-left: 0;
  }
}
.who-we-are .section-title {
  margin-bottom: 10px;
}
.who-we-are p {
  line-height: 160%;
  margin: 0 0 15px;
}
@media (max-width: 991px) {
  .who-we-are p {
    font-size: 15px;
  }
}
@media (max-width: 767px) {
  .who-we-are-column-right {
    order: -1;
  }
}

.about-why-choose-us .section-subtitle {
  margin-bottom: 70px;
}
@media (max-width: 1024px) {
  .about-why-choose-us .section-subtitle {
    margin-bottom: 50px;
  }
}
@media (max-width: 767px) {
  .about-why-choose-us .section-subtitle {
    margin-bottom: 40px;
  }
}
.about-why-choose-us .about-why-choose-us-content {
  gap: 30px;
  margin-bottom: 25px;
  border-bottom: 1px solid #D9D9D9;
  padding-bottom: 25px;
}
@media (max-width: 1024px) {
  .about-why-choose-us .about-why-choose-us-content {
    gap: 20px;
  }
}
.about-why-choose-us .about-why-choose-us-content img {
  width: 40px;
  height: auto;
}
.about-why-choose-us .about-why-choose-us-content-list {
  width: calc(100% - 70px);
}
.about-why-choose-us .about-why-choose-us-content-list label {
  font-size: 20px;
  font-weight: 600;
  color: #000;
  vertical-align: top;
  line-height: 120%;
  margin: 0 0 10px;
}
@media (max-width: 1024px) {
  .about-why-choose-us .about-why-choose-us-content-list label {
    font-size: 18px;
  }
}
@media (max-width: 1024px) {
  .about-why-choose-us .about-why-choose-us-content-list p {
    font-size: 15px;
  }
}
@media (max-width: 767px) {
  .about-why-choose-us .about-why-choose-us-content-list p {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  .about-why-choose-us-img {
    margin-top: 20px;
  }
}
@media (max-width: 767px) {
  .about-why-choose-us-img img {
    width: 100%;
  }
}

.company-fun-fact {
  background: #020626;
  padding: 110px 0px;
}
@media (max-width: 767px) {
  .company-fun-fact {
    padding: 50px 0px;
  }
}
@media (max-width: 767px) {
  .company-fun-fact-column-left {
    margin-bottom: 40px;
  }
}
.company-fun-fact-column-left span {
  font-size: 20px;
  color: #FF4103;
  margin-bottom: 10px;
  display: block;
}
@media (max-width: 991px) {
  .company-fun-fact-column-left span {
    font-size: 18px;
  }
}
.company-fun-fact-column-left h4, .company-fun-fact-column-left .h4 {
  font-size: 50px;
  color: #fff;
  max-width: 502px;
  font-weight: 700;
  max-width: 500px;
}
@media (max-width: 1200px) {
  .company-fun-fact-column-left h4, .company-fun-fact-column-left .h4 {
    font-size: 40px;
  }
}
@media (max-width: 1100px) {
  .company-fun-fact-column-left h4, .company-fun-fact-column-left .h4 {
    max-width: 380px;
  }
}
@media (max-width: 991px) {
  .company-fun-fact-column-left h4, .company-fun-fact-column-left .h4 {
    font-size: 35px;
    max-width: 350px;
  }
}
@media (max-width: 820px) {
  .company-fun-fact-column-left h4, .company-fun-fact-column-left .h4 {
    font-size: 30px;
    max-width: 300px;
  }
}
.company-fun-fact-column-right {
  gap: 65px;
}
@media (max-width: 1200px) {
  .company-fun-fact-column-right {
    gap: 45px;
  }
}
@media (max-width: 991px) {
  .company-fun-fact-column-right {
    gap: 30px;
  }
}
@media (max-width: 850px) {
  .company-fun-fact-column-right {
    gap: 20px;
  }
}
.company-fun-fact-column-right img {
  max-height: 68px;
  margin: 0 0 20px;
}
.company-fun-fact-status {
  align-items: center;
}
.company-fun-fact-status label {
  font-size: 50px;
  color: #fff;
  font-weight: 700;
  line-height: 100%;
  margin: 0 0 10px;
}
@media (max-width: 1200px) {
  .company-fun-fact-status label {
    font-size: 40px;
  }
}
@media (max-width: 991px) {
  .company-fun-fact-status label {
    font-size: 35px;
  }
}
@media (max-width: 820px) {
  .company-fun-fact-status label {
    font-size: 30px;
  }
}
.company-fun-fact-status span {
  font-size: 20px;
  color: #8E8F8F;
}
@media (max-width: 1200px) {
  .company-fun-fact-status span {
    font-size: 18px;
  }
}
@media (max-width: 991px) {
  .company-fun-fact-status span {
    font-size: 16px;
  }
}

.our-team {
  margin-bottom: 122px;
}
@media (max-width: 1200px) {
  .our-team {
    padding: 0px;
  }
}
@media (max-width: 767px) {
  .our-team {
    margin-bottom: 100px;
  }
}
@media (max-width: 1200px) {
  .our-team .row {
    margin-left: 0;
    margin-right: 0px;
  }
}
.our-team .section-subtitle {
  margin-bottom: 50px;
}
@media (max-width: 767px) {
  .our-team .section-subtitle {
    margin-bottom: 40px;
  }
}
.our-team-list {
  margin: 0 15px;
  max-width: calc(100% - 30px);
}
@media (max-width: 767px) {
  .our-team-list {
    margin: 0 10px;
    max-width: calc(100% - 20px);
  }
}
.our-team-list img {
  width: 100%;
  border-radius: 5px;
}
.our-team-list label {
  font-size: 20px;
  font-weight: 600;
  margin: 20px 0px 0px;
  line-height: 120%;
}
@media (max-width: 991px) {
  .our-team-list label {
    font-size: 18px;
    margin-top: 15px;
  }
}
.our-team-list span {
  display: block;
  color: #000;
  line-height: 120%;
  margin: 10px 0 0;
}
@media (max-width: 991px) {
  .our-team-list span {
    font-size: 15px;
  }
}
.our-team .slick-dots {
  bottom: -52px;
  height: 10px;
}
.our-team .slick-dots li {
  width: 10px;
  height: 10px;
  background: #D9D9D9;
  border-radius: 50%;
  vertical-align: top;
  margin: 0 2.5px;
}
.our-team .slick-dots li button {
  padding: 0px;
  width: 100%;
  height: 100%;
}
.our-team .slick-dots li button::before {
  display: none;
}
.our-team .slick-dots li.slick-active {
  background: #FF4103;
}

.our-blog .section-subtitle {
  margin-bottom: 50px;
}
@media (max-width: 991px) {
  .our-blog .section-subtitle {
    margin-bottom: 40px;
  }
}
@media (max-width: 991px) {
  .our-blog .section-subtitle {
    margin-bottom: 30px;
  }
}
.our-blog > .row:nth-child(2) {
  gap: 24px 0px;
}
@media (max-width: 767px) {
  .our-blog > .row:nth-child(2) {
    gap: 12px 0px;
  }
}
.our-blog-list {
  box-shadow: 0 0 14px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.our-blog-list-content {
  padding: 15px 15px 20px;
}
.our-blog-list-content label {
  font-weight: 600;
  vertical-align: top;
  line-height: 120%;
  margin: 0 0 10px;
}
@media (max-width: 991px) {
  .our-blog-list-content label {
    font-size: 15px;
  }
}
.our-blog-list-content p {
  line-height: 107%;
  margin: 0px;
}
@media (max-width: 991px) {
  .our-blog-list-content p {
    font-size: 15px;
  }
}
.our-blog-list-content a {
  font-size: 14px;
  color: #FF4103;
}
.our-blog-list-content a svg {
  width: 7px;
}

.get-in-touch {
  margin-top: 80px;
  margin-bottom: 80px;
}
@media (max-width: 991px) {
  .get-in-touch {
    margin-top: 50px;
    margin-bottom: 50px;
  }
}
.get-in-touch-bg {
  background: #111539;
  padding: 40px;
}
@media (max-width: 991px) {
  .get-in-touch-bg {
    padding: 40px 30px;
  }
}
@media (max-width: 767px) {
  .get-in-touch-bg {
    padding: 30px;
  }
}
@media (max-width: 400px) {
  .get-in-touch-bg {
    padding: 30px 20px;
  }
}
.get-in-touch-bg .section-title {
  color: #FF4103;
  margin: 0px 0 38px;
}
.get-in-touch-list {
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .get-in-touch-list {
    margin-bottom: 20px;
  }
}
.get-in-touch-list svg {
  width: 25px;
}
.get-in-touch-list-content {
  max-width: calc(100% - 46px);
}
.get-in-touch-list-content label {
  color: #FF4103;
  font-size: 20px;
  line-height: 120%;
}
@media (max-width: 991px) {
  .get-in-touch-list-content label {
    font-size: 18px;
  }
}
.get-in-touch-list-content span {
  display: block;
  font-size: 18px;
  line-height: 120%;
  margin: 10px 0 0;
  color: #fff;
}
@media (max-width: 991px) {
  .get-in-touch-list-content span {
    font-size: 16px;
  }
}
.get-in-touch-formbg {
  background: #E5E5E5;
  padding: 50px;
}
@media (max-width: 991px) {
  .get-in-touch-formbg {
    padding: 50px 30px;
  }
}
@media (max-width: 767px) {
  .get-in-touch-formbg {
    padding: 40px 30px;
  }
}
@media (max-width: 400px) {
  .get-in-touch-formbg {
    padding: 30px 20px;
  }
}
.get-in-touch-formbg form {
  gap: 15px;
}
.get-in-touch-formbg .form-control {
  height: 45px;
  border: none;
  font-size: 15px;
  padding: 10px 15px;
  border-radius: 4px;
}
.get-in-touch-formbg .form-control:focus {
  box-shadow: none;
}
.get-in-touch-formbg .form-control::-webkit-input-placeholder {
  color: #696969;
}
.get-in-touch-formbg .form-control::-moz-input-placeholder {
  color: #696969;
}
.get-in-touch-formbg .form-control::-ms-input-placeholder {
  color: #696969;
}
.get-in-touch-formbg .form-select {
  height: 45px;
  font-size: 14px;
}
.get-in-touch-formbg .form-select:focus {
  box-shadow: none;
  border-color: #dee2e6;
}
.get-in-touch-formbg .message {
  height: 85px;
  padding: 10px 15px;
}
.get-in-touch-formbg .btn {
  border-radius: 5px;
  border: none;
  align-self: flex-start;
  font-size: 16px;
}

.service .section-subtitle {
  margin-bottom: 87px;
}
.service-row-bottom {
  gap: 81px 0px;
}
@media (max-width: 767px) {
  .service-row-bottom {
    gap: 60px 0px;
  }
}
.service-list {
  border: 1px solid #000;
  border-radius: 10px;
  height: 100%;
}
.service-list-content {
  text-align: center;
  padding: 0 20px;
}
.service-list-content label {
  font-weight: 600;
  font-size: 20px;
  vertical-align: top;
  line-height: 120%;
  margin: 0 0 20px;
}
@media (max-width: 991px) {
  .service-list-content label {
    font-size: 18px;
    margin-bottom: 15px;
  }
}
.service-list-content p {
  line-height: 160%;
  margin-bottom: 20px;
}
@media (max-width: 991px) {
  .service-list-content p {
    font-size: 15px;
    line-height: 150%;
  }
}
.service-list-icon {
  width: 75px;
  height: 75px;
  border-radius: 8px;
  background: #000000;
  align-items: center;
  justify-content: center;
  margin: -37.5px auto 30px;
  flex: unset;
}
.service .read-more {
  margin-top: auto;
  margin-bottom: 20px;
  display: inline-flex;
  align-items: center;
}
.service .read-more svg {
  width: 8px;
}

.service-request .service-form {
  background: #E1E1E1;
  padding: 40px 95px;
  margin-bottom: 50px;
}
@media (max-width: 991px) {
  .service-request .service-form {
    padding: 30px 15px;
  }
}
.service-request .service-form h2, .service-request .service-form .h2 {
  font-size: 30px;
  color: #FF4103;
  text-align: center;
  font-weight: 600;
  margin: 0 0 34px;
}
@media (max-width: 767px) {
  .service-request .service-form h2, .service-request .service-form .h2 {
    font-size: 25px;
    margin: 0 0 20px;
  }
}
.service-request .service-form .form-control {
  height: 45px;
  border: none;
  font-size: 15px;
  padding: 10px 15px;
  border-radius: 6px;
}
.service-request .service-form .form-control:focus {
  box-shadow: none;
}
.service-request .service-form .form-control::-webkit-input-placeholder {
  color: #696969;
}
.service-request .service-form .form-control::-moz-input-placeholder {
  color: #696969;
}
.service-request .service-form .form-control::-ms-input-placeholder {
  color: #696969;
}
.service-request .service-form .form-select {
  height: 45px;
  font-size: 14px;
}
.service-request .service-form .form-select:focus {
  box-shadow: none;
  border-color: #dee2e6;
}
.service-request .service-form .form-field {
  max-width: calc(50% - 10px);
}
@media (max-width: 450px) {
  .service-request .service-form .form-field {
    max-width: 100%;
  }
}
.service-request .service-form .message {
  height: 85px;
}
.service-request .service-form .btn {
  border-radius: 5px;
  border: none;
  align-self: flex-start;
  font-size: 16px;
  width: auto;
  margin-top: 16px;
}

.hire-dedicated-developer p {
  margin-top: 20px;
}
.hire-dedicated-developer .btn {
  border-radius: 30px;
  margin: 20px 0 0;
}
.hire-dedicated-developer .btn svg {
  width: 15px;
  animation: arrowMoving 1.4s infinite;
}
@keyframes arrowMoving {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(10px, 0, 0);
  }
}

.get-in-touch .form-label {
  font-size: 14px;
  margin-bottom: 4px;
}
.get-in-touch .form-control {
  height: 45px;
  font-size: 14px;
  padding: 10px 15px;
  border-radius: 6px;
}
.get-in-touch .form-control:focus {
  box-shadow: none;
}
.get-in-touch .form-control::-webkit-input-placeholder {
  color: #696969;
}
.get-in-touch .form-control::-moz-input-placeholder {
  color: #696969;
}
.get-in-touch .form-control::-ms-input-placeholder {
  color: #696969;
}
.get-in-touch .form-control:focus {
  border-color: #dee2e6;
}
.get-in-touch .form-select {
  height: 45px;
  font-size: 14px;
}
.get-in-touch .form-select:focus {
  box-shadow: none;
  border-color: #dee2e6;
}
.get-in-touch .form-control {
  height: 45px;
  font-size: 14px;
}
.get-in-touch textarea.form-control {
  height: 85px;
}

.trusted-companies h2, .trusted-companies .h2 {
  margin-bottom: 40px;
  position: relative;
}
.trusted-companies h2::before, .trusted-companies .h2::before {
  content: "";
  width: 100px;
  height: 0.5px;
  display: inline-block;
  background: rgba(0, 0, 0, 0.4);
  vertical-align: middle;
  position: absolute;
  top: 50%;
  transform: translate(calc(-50% - 140px), -50%);
  left: 50%;
}
.trusted-companies h2::after, .trusted-companies .h2::after {
  content: "";
  width: 100px;
  height: 0.5px;
  display: inline-block;
  background: rgba(0, 0, 0, 0.4);
  vertical-align: middle;
  position: absolute;
  top: 50%;
  transform: translate(calc(20% - 5px), -50%);
}
.trusted-companies .slick-slide > div:focus-visible {
  outline: none;
}
.trusted-companies .partners-logo img {
  max-height: 100px;
  margin: 0 auto;
}
.trusted-companies .partners-logo img:focus {
  outline: none;
}

.why-hire-dedicated-developers h2, .why-hire-dedicated-developers .h2 {
  margin-bottom: 25px;
}
.why-hire-dedicated-developers p {
  margin: 0 0 25px;
}
.why-hire-dedicated-developers ul {
  margin: 0px;
}
.why-hire-dedicated-developers ul li {
  margin: 0 0 20px;
}

.dream-team-bg {
  background: rgb(32, 47, 63);
  padding: 60px 0px;
  margin-bottom: 50px;
}
.dream-team-bg p {
  margin-bottom: 40px;
}
.dream-team-bg .nav-tabs {
  border: none;
  justify-content: center;
  margin-bottom: 50px;
}
.dream-team-bg .nav-tabs .nav-item {
  flex-grow: 0;
  flex-basis: auto;
}
.dream-team-bg .nav-tabs .nav-item .nav-link {
  font-size: 18px;
  color: #fff;
  border: none;
  border-radius: 0;
  padding: 8px 25px;
}
.dream-team-bg .nav-tabs .nav-item .nav-link.active {
  background: #0b1a2b;
  border-radius: 6px;
}
.dream-team-bg .hire-developers-teams {
  gap: 15px;
  justify-content: center;
}
.dream-team-bg .hire-developers-teams-list {
  width: calc(25.05% - 12px);
  flex-grow: unset;
}
.dream-team-bg .hire-developers-teams-list a {
  width: 100%;
  background: rgb(11, 26, 43);
  flex: unset;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.dream-team-bg .hire-developers-teams-list img {
  max-width: 55px;
}
.dream-team-bg .hire-developers-teams-list span {
  color: #fff;
  margin: 15px 0 0;
}
.dream-team-bg .default-btn-style {
  margin-top: 30px;
}

.faq-section h2, .faq-section .h2 {
  font-weight: 600;
}
.faq-section p {
  text-align: center;
  margin: 0 0 20px;
}
.faq-section .accordion {
  display: flex;
  gap: 20px;
  flex-direction: column;
}
.faq-section .accordion .accordion-item {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
}
.faq-section .accordion .accordion-item:first-of-type {
  border-radius: 10px;
}
.faq-section .accordion .accordion-item .accordion-button {
  border-radius: 10px 10px 0 0;
  font-weight: 600;
  font-size: 20px;
  box-shadow: none;
  background: none;
  color: #000;
  padding: 20px;
}
.faq-section .accordion .accordion-item .accordion-button::before {
  content: "";
  clear: both;
  display: block;
  background: #FF4103;
  height: 3px;
  width: 18px;
  border-radius: 3px;
  position: absolute;
  right: 20px;
}
.faq-section .accordion .accordion-item .accordion-button::after {
  content: "";
  clear: both;
  display: block;
  background: #FF4103;
  height: 18px;
  width: 3px;
  border-radius: 3px;
  position: absolute;
  right: 27px;
  display: none;
}
.faq-section .accordion .accordion-item .accordion-button.collapsed::after {
  display: block;
}
.faq-section .accordion .accordion-body {
  padding: 20px;
  font-size: 16px;
  line-height: 160%;
  margin: 0 20px;
  border-top: 1px solid #e4e4e4;
}
.faq-section .accordion .accordion-body ul {
  margin: 0px;
}

.our-testimonial-gap {
  margin-bottom: 120px;
}

.expertise-angular-developer {
  margin-top: 50px;
}
.expertise-angular-developer-top-portion p {
  margin: 0 auto 50px;
  max-width: 800px;
}
.expertise-angular-developer-bottom-portion {
  gap: 24px 0px;
}
.expertise-angular-developer-bottom-portion-list {
  background: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-radius: 10px;
  height: 100%;
}
.expertise-angular-developer-bottom-portion-list img {
  max-width: 50px;
  margin: 0 auto;
}
.expertise-angular-developer-bottom-portion-list label {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin: 20px 0 10px;
}
.expertise-angular-developer-bottom-portion-list p {
  text-align: center;
}

.back-to-site {
  gap: 15px;
  margin: 25px 0 0;
}

.notfound {
  max-width: 600px;
  margin: 50px auto;
}
.notfound img {
  margin: 0 auto;
}
.notfound h1, .notfound .h1 {
  font-size: 30px;
  margin: 20px 0 15px;
  font-weight: 600;
}

.hire-content-container {
  margin-bottom: 70px;
}

.hire-content-info {
  margin-top: 30px;
}
.hire-content-info h2, .hire-content-info .h2 {
  font-size: 30px;
  font-weight: 600;
  margin: 0 0 10px;
}
.hire-content-info p {
  color: #645a5a;
}
.hire-content-info ul {
  display: flex;
  gap: 10px;
  flex-direction: column;
  margin: 0;
}
.hire-content-info ul li {
  color: #645a5a;
}

.footer-top-bg {
  background: #000;
  padding: 50px 0;
}

.modal-content .modal-header .btn-close {
  box-shadow: none;
  padding: 0px;
  border-radius: 0;
  margin: 0 0 0 auto;
}

.our-blog-post h2, .our-blog-post .h2 {
  font-size: 26px;
  font-weight: 600;
  margin: 30px 0 20px;
}
.our-blog-post-list {
  gap: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0 0 20px;
}
.our-blog-post-list-content {
  width: calc(100% - 220px);
}
.our-blog-post-list-content span {
  font-size: 14px;
  margin: 0 0 7px;
}
.our-blog-post-list:last-child {
  border: none;
  padding: 0;
}
.our-blog-post-list label {
  font-weight: 600;
  font-size: 18px;
  margin: 0px;
  line-height: normal;
}
.our-blog-post-list p {
  font-size: 15px;
  line-height: normal;
  margin: 0 0 5px;
}
.our-blog-post-list a {
  margin-right: auto;
  color: #FF4103;
  font-size: 14px;
  margin-top: auto;
}
.our-blog-post-list a svg {
  margin-left: 5px;
}
.our-blog-post-column {
  padding: 15px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  gap: 20px;
  margin: 0 0 40px;
}
.our-blog-post-right-column .blog-post-img {
  width: 100px;
  height: 80px;
}
.our-blog-post-right-column .our-blog-post-list {
  gap: 12px;
}
.our-blog-post-right-column .our-blog-post-list label {
  font-size: 16px;
}
.our-blog-post-right-column .our-blog-post-list-content {
  width: calc(100% - 120px);
}

.blog-post-img {
  width: 200px;
  height: 130px;
}
.blog-post-img img {
  border-radius: 5px;
  height: 100%;
  object-fit: cover;
}

.our-blog-post-right-column h2, .our-blog-post-right-column .h2 {
  margin: 81px 0 20px;
  font-size: 20px;
}
.our-blog-post-right-column .our-blog-post-list {
  margin: 0 0 20px;
}

.blog-detail-content {
  margin: 20px 0 50px;
  gap: 20px;
}
.blog-detail-content p {
  font-size: 15px;
  color: #696969;
}

.our-blog-post-detail {
  margin-top: 60px;
}
.our-blog-post-detail .our-blog-post-right-column h2, .our-blog-post-detail .our-blog-post-right-column .h2 {
  margin-top: 0px;
}

.contact-items-img {
  width: 50px;
  height: 50px;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  padding: 12px;
  flex: unset;
}

.contact-items {
  gap: 15px;
  align-items: center;
  margin: 0 0 20px;
}
.contact-items span {
  width: calc(100% - 100px);
}

.contact-content h2, .contact-content .h2 {
  margin: 50px 0 20px;
  text-align: center;
}
.contact-content a {
  color: #000;
  text-decoration: underline;
}

.contact-content .form-container {
  background: #fff;
  box-shadow: 0 0 20px hsla(0, 0%, 62%, 0.16);
  padding: 30px;
  margin: 0px 0 50px;
}
.contact-content .form-container .form-control {
  height: 45px;
}
.contact-content .form-container .form-control:focus {
  box-shadow: none;
  border-color: #dee2e6;
}

.contactmap {
  vertical-align: top;
}`, "",{"version":3,"sources":["webpack://./src/styles/custom-bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,2CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFDF;;AI/GI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AFDJ;;AKvKA;;;EAGE,sBAAA;AL0KF;;AK3JI;EANJ;IAOM,uBAAA;EL+JJ;AACF;;AKlJA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ALqJF;;AK5IA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AN1e9B;;AKrIA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;ALsIF;;AKnIA;EFuMQ,iCAAA;AHhER;AG5FI;EE3CJ;IF8MQ,iBAAA;EHnEN;AACF;;AKvIA;EFkMQ,iCAAA;AHvDR;AGrGI;EEtCJ;IFyMQ,eAAA;EH1DN;AACF;;AK3IA;EF6LQ,+BAAA;AH9CR;AG9GI;EEjCJ;IFoMQ,kBAAA;EHjDN;AACF;;AK/IA;EFwLQ,iCAAA;AHrCR;AGvHI;EE5BJ;IF+LQ,iBAAA;EHxCN;AACF;;AKnJA;EF+KM,kBALI;AHnBV;;AKlJA;EF0KM,eALI;AHfV;;AK3IA;EACE,aAAA;EACA,mBCwV0B;AN1M5B;;AKpIA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;ALuIF;;AKjIA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALoIF;;AK9HA;;EAEE,kBAAA;ALiIF;;AK9HA;;;EAGE,aAAA;EACA,mBAAA;ALiIF;;AK9HA;;;;EAIE,gBAAA;ALiIF;;AK9HA;EACE,gBC6b4B;AN5T9B;;AK5HA;EACE,qBAAA;EACA,cAAA;AL+HF;;AKzHA;EACE,gBAAA;AL4HF;;AKpHA;;EAEE,mBCsa4B;AN/S9B;;AK/GA;EF6EM,kBALI;AH2CV;;AK5GA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;AL+GF;;AKtGA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ALyGF;;AKtGA;EAAM,eAAA;AL0GN;;AKzGA;EAAM,WAAA;AL6GN;;AKxGA;EACE,gEAAA;EACA,0BCgNwC;ANrG1C;AKzGE;EACE,mDAAA;AL2GJ;;AKhGE;EAEE,cAAA;EACA,qBAAA;ALkGJ;;AK3FA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AHsFV;;AKvFA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AH8FV;AKtFE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ALwFJ;;AKpFA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ALuFF;AKpFE;EACE,cAAA;ALsFJ;;AKlFA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBCy5CkC;EDx5ClC,sCCy5CkC;EC9rDhC,sBAAA;AP2XJ;AKnFE;EACE,UAAA;EF7BE,cALI;AHwHV;;AK3EA;EACE,gBAAA;AL8EF;;AKxEA;;EAEE,sBAAA;AL2EF;;AKnEA;EACE,oBAAA;EACA,yBAAA;ALsEF;;AKnEA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;ALsEF;;AK/DA;EAEE,mBAAA;EACA,gCAAA;ALiEF;;AK9DA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ALiEF;;AKzDA;EACE,qBAAA;AL4DF;;AKtDA;EAEE,gBAAA;ALwDF;;AKhDA;EACE,UAAA;ALmDF;;AK9CA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ALiDF;;AK7CA;;EAEE,oBAAA;ALgDF;;AK3CA;EACE,eAAA;AL8CF;;AK3CA;EAGE,iBAAA;AL4CF;AKzCE;EACE,UAAA;AL2CJ;;AKpCA;EACE,wBAAA;ALuCF;;AK/BA;;;;EAIE,0BAAA;ALkCF;AK/BI;;;;EACE,eAAA;ALoCN;;AK7BA;EACE,UAAA;EACA,kBAAA;ALgCF;;AK3BA;EACE,gBAAA;AL8BF;;AKpBA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALuBF;;AKfA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EHpatB,iCAAA;EEoNN,oBAAA;ALiBF;AGjYI;EEyWJ;IFtMQ,iBAAA;EHkON;AACF;AKpBE;EACE,WAAA;ALsBJ;;AKfA;;;;;;;EAOE,UAAA;ALkBF;;AKfA;EACE,YAAA;ALkBF;;AKTA;EACE,6BAAA;EACA,oBAAA;ALYF;;AKJA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALIF;;AKCA;EACE,UAAA;ALEF;;AKKA;EACE,aAAA;EACA,0BAAA;ALFF;;AKOA;EACE,qBAAA;ALJF;;AKSA;EACE,SAAA;ALNF;;AKaA;EACE,kBAAA;EACA,eAAA;ALVF;;AKkBA;EACE,wBAAA;ALfF;;AKuBA;EACE,wBAAA;ALpBF;;AQjjBA;ELmQM,kBALI;EK5PR,gBFwoB4B;ANpF9B;;AQ/iBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANxD9B;AGjdI;EKpGF;ILuQM,eAAA;EHkTN;AACF;;AQ1jBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AN7C9B;AG5dI;EKpGF;ILuQM,iBAAA;EH6TN;AACF;;AQrkBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANlC9B;AGveI;EKpGF;ILuQM,eAAA;EHwUN;AACF;;AQhlBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANvB9B;AGlfI;EKpGF;ILuQM,iBAAA;EHmVN;AACF;;AQ3lBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANZ9B;AG7fI;EKpGF;ILuQM,eAAA;EH8VN;AACF;;AQtmBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AND9B;AGxgBI;EKpGF;ILuQM,iBAAA;EHyWN;AACF;;AQzlBA;ECvDE,eAAA;EACA,gBAAA;ATopBF;;AQzlBA;EC5DE,eAAA;EACA,gBAAA;ATypBF;;AQ3lBA;EACE,qBAAA;AR8lBF;AQ5lBE;EACE,oBFsoB0B;ANxC9B;;AQplBA;EL8MM,kBALI;EKvMR,yBAAA;ARulBF;;AQnlBA;EACE,mBFiUO;EH1HH,kBALI;AHqZV;AQplBE;EACE,gBAAA;ARslBJ;;AQllBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;AN2qBX;AQnlBE;EACE,aAAA;ARqlBJ;;AUrrBA;ECIE,eAAA;EAGA,YAAA;AXmrBF;;AUprBA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AX4rBF;;AU9qBA;EAEE,qBAAA;AVgrBF;;AU7qBA;EACE,qBAAA;EACA,cAAA;AVgrBF;;AU7qBA;EPyPM,kBALI;EOlPR,gCJkjDkC;ANl4BpC;;AYltBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Ab+tBF;;AczqBI;EF5CE;IACE,eZhBe;EAyuBrB;AACF;Ac/qBI;EF5CE;IACE,eZhBe;EA8uBrB;AACF;AcprBI;EF5CE;IACE,eZhBe;EAmvBrB;AACF;AczrBI;EF5CE;IACE,iBZhBe;EAwvBrB;AACF;Ac9rBI;EF5CE;IACE,iBZhBe;EA6vBrB;AACF;Ae9vBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AfowBJ;;Ae/vBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhBwwBF;AetwBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhBkwBF;;AgBntBM;EACE,SAAA;AhBstBR;;AgBntBM;EApCJ,cAAA;EACA,WAAA;AhB2vBF;;AgB7uBE;EACE,cAAA;EACA,WAAA;AhBgvBJ;;AgBlvBE;EACE,cAAA;EACA,UAAA;AhBqvBJ;;AgBvvBE;EACE,cAAA;EACA,mBAAA;AhB0vBJ;;AgB5vBE;EACE,cAAA;EACA,UAAA;AhB+vBJ;;AgBjwBE;EACE,cAAA;EACA,UAAA;AhBowBJ;;AgBtwBE;EACE,cAAA;EACA,mBAAA;AhBywBJ;;AgB1uBM;EAhDJ,cAAA;EACA,WAAA;AhB8xBF;;AgBzuBU;EAhEN,cAAA;EACA,kBAAA;AhB6yBJ;;AgB9uBU;EAhEN,cAAA;EACA,mBAAA;AhBkzBJ;;AgBnvBU;EAhEN,cAAA;EACA,UAAA;AhBuzBJ;;AgBxvBU;EAhEN,cAAA;EACA,mBAAA;AhB4zBJ;;AgB7vBU;EAhEN,cAAA;EACA,mBAAA;AhBi0BJ;;AgBlwBU;EAhEN,cAAA;EACA,UAAA;AhBs0BJ;;AgBvwBU;EAhEN,cAAA;EACA,mBAAA;AhB20BJ;;AgB5wBU;EAhEN,cAAA;EACA,mBAAA;AhBg1BJ;;AgBjxBU;EAhEN,cAAA;EACA,UAAA;AhBq1BJ;;AgBtxBU;EAhEN,cAAA;EACA,mBAAA;AhB01BJ;;AgB3xBU;EAhEN,cAAA;EACA,mBAAA;AhB+1BJ;;AgBhyBU;EAhEN,cAAA;EACA,WAAA;AhBo2BJ;;AgB7xBY;EAxDV,wBAAA;AhBy1BF;;AgBjyBY;EAxDV,yBAAA;AhB61BF;;AgBryBY;EAxDV,gBAAA;AhBi2BF;;AgBzyBY;EAxDV,yBAAA;AhBq2BF;;AgB7yBY;EAxDV,yBAAA;AhBy2BF;;AgBjzBY;EAxDV,gBAAA;AhB62BF;;AgBrzBY;EAxDV,yBAAA;AhBi3BF;;AgBzzBY;EAxDV,yBAAA;AhBq3BF;;AgB7zBY;EAxDV,gBAAA;AhBy3BF;;AgBj0BY;EAxDV,yBAAA;AhB63BF;;AgBr0BY;EAxDV,yBAAA;AhBi4BF;;AgB9zBQ;;EAEE,gBAAA;AhBi0BV;;AgB9zBQ;;EAEE,gBAAA;AhBi0BV;;AgBx0BQ;;EAEE,sBAAA;AhB20BV;;AgBx0BQ;;EAEE,sBAAA;AhB20BV;;AgBl1BQ;;EAEE,qBAAA;AhBq1BV;;AgBl1BQ;;EAEE,qBAAA;AhBq1BV;;AgB51BQ;;EAEE,mBAAA;AhB+1BV;;AgB51BQ;;EAEE,mBAAA;AhB+1BV;;AgBt2BQ;;EAEE,qBAAA;AhBy2BV;;AgBt2BQ;;EAEE,qBAAA;AhBy2BV;;AgBh3BQ;;EAEE,mBAAA;AhBm3BV;;AgBh3BQ;;EAEE,mBAAA;AhBm3BV;;Ac76BI;EEUE;IACE,SAAA;EhBu6BN;EgBp6BI;IApCJ,cAAA;IACA,WAAA;EhB28BA;EgB77BA;IACE,cAAA;IACA,WAAA;EhB+7BF;EgBj8BA;IACE,cAAA;IACA,UAAA;EhBm8BF;EgBr8BA;IACE,cAAA;IACA,mBAAA;EhBu8BF;EgBz8BA;IACE,cAAA;IACA,UAAA;EhB28BF;EgB78BA;IACE,cAAA;IACA,UAAA;EhB+8BF;EgBj9BA;IACE,cAAA;IACA,mBAAA;EhBm9BF;EgBp7BI;IAhDJ,cAAA;IACA,WAAA;EhBu+BA;EgBl7BQ;IAhEN,cAAA;IACA,kBAAA;EhBq/BF;EgBt7BQ;IAhEN,cAAA;IACA,mBAAA;EhBy/BF;EgB17BQ;IAhEN,cAAA;IACA,UAAA;EhB6/BF;EgB97BQ;IAhEN,cAAA;IACA,mBAAA;EhBigCF;EgBl8BQ;IAhEN,cAAA;IACA,mBAAA;EhBqgCF;EgBt8BQ;IAhEN,cAAA;IACA,UAAA;EhBygCF;EgB18BQ;IAhEN,cAAA;IACA,mBAAA;EhB6gCF;EgB98BQ;IAhEN,cAAA;IACA,mBAAA;EhBihCF;EgBl9BQ;IAhEN,cAAA;IACA,UAAA;EhBqhCF;EgBt9BQ;IAhEN,cAAA;IACA,mBAAA;EhByhCF;EgB19BQ;IAhEN,cAAA;IACA,mBAAA;EhB6hCF;EgB99BQ;IAhEN,cAAA;IACA,WAAA;EhBiiCF;EgB19BU;IAxDV,cAAA;EhBqhCA;EgB79BU;IAxDV,wBAAA;EhBwhCA;EgBh+BU;IAxDV,yBAAA;EhB2hCA;EgBn+BU;IAxDV,gBAAA;EhB8hCA;EgBt+BU;IAxDV,yBAAA;EhBiiCA;EgBz+BU;IAxDV,yBAAA;EhBoiCA;EgB5+BU;IAxDV,gBAAA;EhBuiCA;EgB/+BU;IAxDV,yBAAA;EhB0iCA;EgBl/BU;IAxDV,yBAAA;EhB6iCA;EgBr/BU;IAxDV,gBAAA;EhBgjCA;EgBx/BU;IAxDV,yBAAA;EhBmjCA;EgB3/BU;IAxDV,yBAAA;EhBsjCA;EgBn/BM;;IAEE,gBAAA;EhBq/BR;EgBl/BM;;IAEE,gBAAA;EhBo/BR;EgB3/BM;;IAEE,sBAAA;EhB6/BR;EgB1/BM;;IAEE,sBAAA;EhB4/BR;EgBngCM;;IAEE,qBAAA;EhBqgCR;EgBlgCM;;IAEE,qBAAA;EhBogCR;EgB3gCM;;IAEE,mBAAA;EhB6gCR;EgB1gCM;;IAEE,mBAAA;EhB4gCR;EgBnhCM;;IAEE,qBAAA;EhBqhCR;EgBlhCM;;IAEE,qBAAA;EhBohCR;EgB3hCM;;IAEE,mBAAA;EhB6hCR;EgB1hCM;;IAEE,mBAAA;EhB4hCR;AACF;AcvlCI;EEUE;IACE,SAAA;EhBglCN;EgB7kCI;IApCJ,cAAA;IACA,WAAA;EhBonCA;EgBtmCA;IACE,cAAA;IACA,WAAA;EhBwmCF;EgB1mCA;IACE,cAAA;IACA,UAAA;EhB4mCF;EgB9mCA;IACE,cAAA;IACA,mBAAA;EhBgnCF;EgBlnCA;IACE,cAAA;IACA,UAAA;EhBonCF;EgBtnCA;IACE,cAAA;IACA,UAAA;EhBwnCF;EgB1nCA;IACE,cAAA;IACA,mBAAA;EhB4nCF;EgB7lCI;IAhDJ,cAAA;IACA,WAAA;EhBgpCA;EgB3lCQ;IAhEN,cAAA;IACA,kBAAA;EhB8pCF;EgB/lCQ;IAhEN,cAAA;IACA,mBAAA;EhBkqCF;EgBnmCQ;IAhEN,cAAA;IACA,UAAA;EhBsqCF;EgBvmCQ;IAhEN,cAAA;IACA,mBAAA;EhB0qCF;EgB3mCQ;IAhEN,cAAA;IACA,mBAAA;EhB8qCF;EgB/mCQ;IAhEN,cAAA;IACA,UAAA;EhBkrCF;EgBnnCQ;IAhEN,cAAA;IACA,mBAAA;EhBsrCF;EgBvnCQ;IAhEN,cAAA;IACA,mBAAA;EhB0rCF;EgB3nCQ;IAhEN,cAAA;IACA,UAAA;EhB8rCF;EgB/nCQ;IAhEN,cAAA;IACA,mBAAA;EhBksCF;EgBnoCQ;IAhEN,cAAA;IACA,mBAAA;EhBssCF;EgBvoCQ;IAhEN,cAAA;IACA,WAAA;EhB0sCF;EgBnoCU;IAxDV,cAAA;EhB8rCA;EgBtoCU;IAxDV,wBAAA;EhBisCA;EgBzoCU;IAxDV,yBAAA;EhBosCA;EgB5oCU;IAxDV,gBAAA;EhBusCA;EgB/oCU;IAxDV,yBAAA;EhB0sCA;EgBlpCU;IAxDV,yBAAA;EhB6sCA;EgBrpCU;IAxDV,gBAAA;EhBgtCA;EgBxpCU;IAxDV,yBAAA;EhBmtCA;EgB3pCU;IAxDV,yBAAA;EhBstCA;EgB9pCU;IAxDV,gBAAA;EhBytCA;EgBjqCU;IAxDV,yBAAA;EhB4tCA;EgBpqCU;IAxDV,yBAAA;EhB+tCA;EgB5pCM;;IAEE,gBAAA;EhB8pCR;EgB3pCM;;IAEE,gBAAA;EhB6pCR;EgBpqCM;;IAEE,sBAAA;EhBsqCR;EgBnqCM;;IAEE,sBAAA;EhBqqCR;EgB5qCM;;IAEE,qBAAA;EhB8qCR;EgB3qCM;;IAEE,qBAAA;EhB6qCR;EgBprCM;;IAEE,mBAAA;EhBsrCR;EgBnrCM;;IAEE,mBAAA;EhBqrCR;EgB5rCM;;IAEE,qBAAA;EhB8rCR;EgB3rCM;;IAEE,qBAAA;EhB6rCR;EgBpsCM;;IAEE,mBAAA;EhBssCR;EgBnsCM;;IAEE,mBAAA;EhBqsCR;AACF;AchwCI;EEUE;IACE,SAAA;EhByvCN;EgBtvCI;IApCJ,cAAA;IACA,WAAA;EhB6xCA;EgB/wCA;IACE,cAAA;IACA,WAAA;EhBixCF;EgBnxCA;IACE,cAAA;IACA,UAAA;EhBqxCF;EgBvxCA;IACE,cAAA;IACA,mBAAA;EhByxCF;EgB3xCA;IACE,cAAA;IACA,UAAA;EhB6xCF;EgB/xCA;IACE,cAAA;IACA,UAAA;EhBiyCF;EgBnyCA;IACE,cAAA;IACA,mBAAA;EhBqyCF;EgBtwCI;IAhDJ,cAAA;IACA,WAAA;EhByzCA;EgBpwCQ;IAhEN,cAAA;IACA,kBAAA;EhBu0CF;EgBxwCQ;IAhEN,cAAA;IACA,mBAAA;EhB20CF;EgB5wCQ;IAhEN,cAAA;IACA,UAAA;EhB+0CF;EgBhxCQ;IAhEN,cAAA;IACA,mBAAA;EhBm1CF;EgBpxCQ;IAhEN,cAAA;IACA,mBAAA;EhBu1CF;EgBxxCQ;IAhEN,cAAA;IACA,UAAA;EhB21CF;EgB5xCQ;IAhEN,cAAA;IACA,mBAAA;EhB+1CF;EgBhyCQ;IAhEN,cAAA;IACA,mBAAA;EhBm2CF;EgBpyCQ;IAhEN,cAAA;IACA,UAAA;EhBu2CF;EgBxyCQ;IAhEN,cAAA;IACA,mBAAA;EhB22CF;EgB5yCQ;IAhEN,cAAA;IACA,mBAAA;EhB+2CF;EgBhzCQ;IAhEN,cAAA;IACA,WAAA;EhBm3CF;EgB5yCU;IAxDV,cAAA;EhBu2CA;EgB/yCU;IAxDV,wBAAA;EhB02CA;EgBlzCU;IAxDV,yBAAA;EhB62CA;EgBrzCU;IAxDV,gBAAA;EhBg3CA;EgBxzCU;IAxDV,yBAAA;EhBm3CA;EgB3zCU;IAxDV,yBAAA;EhBs3CA;EgB9zCU;IAxDV,gBAAA;EhBy3CA;EgBj0CU;IAxDV,yBAAA;EhB43CA;EgBp0CU;IAxDV,yBAAA;EhB+3CA;EgBv0CU;IAxDV,gBAAA;EhBk4CA;EgB10CU;IAxDV,yBAAA;EhBq4CA;EgB70CU;IAxDV,yBAAA;EhBw4CA;EgBr0CM;;IAEE,gBAAA;EhBu0CR;EgBp0CM;;IAEE,gBAAA;EhBs0CR;EgB70CM;;IAEE,sBAAA;EhB+0CR;EgB50CM;;IAEE,sBAAA;EhB80CR;EgBr1CM;;IAEE,qBAAA;EhBu1CR;EgBp1CM;;IAEE,qBAAA;EhBs1CR;EgB71CM;;IAEE,mBAAA;EhB+1CR;EgB51CM;;IAEE,mBAAA;EhB81CR;EgBr2CM;;IAEE,qBAAA;EhBu2CR;EgBp2CM;;IAEE,qBAAA;EhBs2CR;EgB72CM;;IAEE,mBAAA;EhB+2CR;EgB52CM;;IAEE,mBAAA;EhB82CR;AACF;Acz6CI;EEUE;IACE,SAAA;EhBk6CN;EgB/5CI;IApCJ,cAAA;IACA,WAAA;EhBs8CA;EgBx7CA;IACE,cAAA;IACA,WAAA;EhB07CF;EgB57CA;IACE,cAAA;IACA,UAAA;EhB87CF;EgBh8CA;IACE,cAAA;IACA,mBAAA;EhBk8CF;EgBp8CA;IACE,cAAA;IACA,UAAA;EhBs8CF;EgBx8CA;IACE,cAAA;IACA,UAAA;EhB08CF;EgB58CA;IACE,cAAA;IACA,mBAAA;EhB88CF;EgB/6CI;IAhDJ,cAAA;IACA,WAAA;EhBk+CA;EgB76CQ;IAhEN,cAAA;IACA,kBAAA;EhBg/CF;EgBj7CQ;IAhEN,cAAA;IACA,mBAAA;EhBo/CF;EgBr7CQ;IAhEN,cAAA;IACA,UAAA;EhBw/CF;EgBz7CQ;IAhEN,cAAA;IACA,mBAAA;EhB4/CF;EgB77CQ;IAhEN,cAAA;IACA,mBAAA;EhBggDF;EgBj8CQ;IAhEN,cAAA;IACA,UAAA;EhBogDF;EgBr8CQ;IAhEN,cAAA;IACA,mBAAA;EhBwgDF;EgBz8CQ;IAhEN,cAAA;IACA,mBAAA;EhB4gDF;EgB78CQ;IAhEN,cAAA;IACA,UAAA;EhBghDF;EgBj9CQ;IAhEN,cAAA;IACA,mBAAA;EhBohDF;EgBr9CQ;IAhEN,cAAA;IACA,mBAAA;EhBwhDF;EgBz9CQ;IAhEN,cAAA;IACA,WAAA;EhB4hDF;EgBr9CU;IAxDV,cAAA;EhBghDA;EgBx9CU;IAxDV,wBAAA;EhBmhDA;EgB39CU;IAxDV,yBAAA;EhBshDA;EgB99CU;IAxDV,gBAAA;EhByhDA;EgBj+CU;IAxDV,yBAAA;EhB4hDA;EgBp+CU;IAxDV,yBAAA;EhB+hDA;EgBv+CU;IAxDV,gBAAA;EhBkiDA;EgB1+CU;IAxDV,yBAAA;EhBqiDA;EgB7+CU;IAxDV,yBAAA;EhBwiDA;EgBh/CU;IAxDV,gBAAA;EhB2iDA;EgBn/CU;IAxDV,yBAAA;EhB8iDA;EgBt/CU;IAxDV,yBAAA;EhBijDA;EgB9+CM;;IAEE,gBAAA;EhBg/CR;EgB7+CM;;IAEE,gBAAA;EhB++CR;EgBt/CM;;IAEE,sBAAA;EhBw/CR;EgBr/CM;;IAEE,sBAAA;EhBu/CR;EgB9/CM;;IAEE,qBAAA;EhBggDR;EgB7/CM;;IAEE,qBAAA;EhB+/CR;EgBtgDM;;IAEE,mBAAA;EhBwgDR;EgBrgDM;;IAEE,mBAAA;EhBugDR;EgB9gDM;;IAEE,qBAAA;EhBghDR;EgB7gDM;;IAEE,qBAAA;EhB+gDR;EgBthDM;;IAEE,mBAAA;EhBwhDR;EgBrhDM;;IAEE,mBAAA;EhBuhDR;AACF;AcllDI;EEUE;IACE,SAAA;EhB2kDN;EgBxkDI;IApCJ,cAAA;IACA,WAAA;EhB+mDA;EgBjmDA;IACE,cAAA;IACA,WAAA;EhBmmDF;EgBrmDA;IACE,cAAA;IACA,UAAA;EhBumDF;EgBzmDA;IACE,cAAA;IACA,mBAAA;EhB2mDF;EgB7mDA;IACE,cAAA;IACA,UAAA;EhB+mDF;EgBjnDA;IACE,cAAA;IACA,UAAA;EhBmnDF;EgBrnDA;IACE,cAAA;IACA,mBAAA;EhBunDF;EgBxlDI;IAhDJ,cAAA;IACA,WAAA;EhB2oDA;EgBtlDQ;IAhEN,cAAA;IACA,kBAAA;EhBypDF;EgB1lDQ;IAhEN,cAAA;IACA,mBAAA;EhB6pDF;EgB9lDQ;IAhEN,cAAA;IACA,UAAA;EhBiqDF;EgBlmDQ;IAhEN,cAAA;IACA,mBAAA;EhBqqDF;EgBtmDQ;IAhEN,cAAA;IACA,mBAAA;EhByqDF;EgB1mDQ;IAhEN,cAAA;IACA,UAAA;EhB6qDF;EgB9mDQ;IAhEN,cAAA;IACA,mBAAA;EhBirDF;EgBlnDQ;IAhEN,cAAA;IACA,mBAAA;EhBqrDF;EgBtnDQ;IAhEN,cAAA;IACA,UAAA;EhByrDF;EgB1nDQ;IAhEN,cAAA;IACA,mBAAA;EhB6rDF;EgB9nDQ;IAhEN,cAAA;IACA,mBAAA;EhBisDF;EgBloDQ;IAhEN,cAAA;IACA,WAAA;EhBqsDF;EgB9nDU;IAxDV,cAAA;EhByrDA;EgBjoDU;IAxDV,wBAAA;EhB4rDA;EgBpoDU;IAxDV,yBAAA;EhB+rDA;EgBvoDU;IAxDV,gBAAA;EhBksDA;EgB1oDU;IAxDV,yBAAA;EhBqsDA;EgB7oDU;IAxDV,yBAAA;EhBwsDA;EgBhpDU;IAxDV,gBAAA;EhB2sDA;EgBnpDU;IAxDV,yBAAA;EhB8sDA;EgBtpDU;IAxDV,yBAAA;EhBitDA;EgBzpDU;IAxDV,gBAAA;EhBotDA;EgB5pDU;IAxDV,yBAAA;EhButDA;EgB/pDU;IAxDV,yBAAA;EhB0tDA;EgBvpDM;;IAEE,gBAAA;EhBypDR;EgBtpDM;;IAEE,gBAAA;EhBwpDR;EgB/pDM;;IAEE,sBAAA;EhBiqDR;EgB9pDM;;IAEE,sBAAA;EhBgqDR;EgBvqDM;;IAEE,qBAAA;EhByqDR;EgBtqDM;;IAEE,qBAAA;EhBwqDR;EgB/qDM;;IAEE,mBAAA;EhBirDR;EgB9qDM;;IAEE,mBAAA;EhBgrDR;EgBvrDM;;IAEE,qBAAA;EhByrDR;EgBtrDM;;IAEE,qBAAA;EhBwrDR;EgB/rDM;;IAEE,mBAAA;EhBisDR;EgB9rDM;;IAEE,mBAAA;EhBgsDR;AACF;AiBtzDA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AjBqzDF;AiB9yDE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AjB+yDJ;AiB5yDE;EACE,uBAAA;AjB8yDJ;AiB3yDE;EACE,sBAAA;AjB6yDJ;;AiBzyDA;EACE,+DAAA;AjB4yDF;;AiBryDA;EACE,iBAAA;AjBwyDF;;AiB9xDE;EACE,wBAAA;AjBiyDJ;;AiBlxDE;EACE,sCAAA;AjBqxDJ;AiBlxDI;EACE,sCAAA;AjBoxDN;;AiB7wDE;EACE,sBAAA;AjBgxDJ;AiB7wDE;EACE,mBAAA;AjB+wDJ;;AiBrwDE;EACE,oDAAA;EACA,8CAAA;AjBwwDJ;;AiBlwDE;EACE,oDAAA;EACA,8CAAA;AjBqwDJ;;AiB7vDA;EACE,oDAAA;EACA,8CAAA;AjBgwDF;;AiBxvDE;EACE,mDAAA;EACA,6CAAA;AjB2vDJ;;AkBv4DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBm4DJ;;AkBr5DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBi5DJ;;AkBn6DE;EAOE,sBAAA;EACA,mCAAA;EACA,kDAAA;EACA,kDAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB+5DJ;;AkBj7DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB66DJ;;AkB/7DE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,mDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB27DJ;;AkB78DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBy8DJ;;AkB39DE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBu9DJ;;AkBz+DE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,4CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,6CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBq+DJ;;AiBp1DI;EACE,gBAAA;EACA,iCAAA;AjBu1DN;;Acl7DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB61DJ;AACF;Acz7DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBm2DJ;AACF;Ac/7DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBy2DJ;AACF;Acr8DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB+2DJ;AACF;Ac38DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBq3DJ;AACF;AmBzhEA;EACE,qBbu2BsC;ANorCxC;;AmBlhEA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;ANo7C9B;;AmB/gEA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AHoxDV;;AmB/gEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AH0xDV;;AoBhjEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;ANktCxC;;AqBtjEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;ArBojEF;AsBtjEM;EDhBN;ICiBQ,gBAAA;EtByjEN;AACF;AqBvjEE;EACE,gBAAA;ArByjEJ;AqBvjEI;EACE,eAAA;ArByjEN;AqBpjEE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,kCf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;ANgiDxB;AqB9iEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArBkiEJ;AqB7hEE;EACE,cAAA;EACA,UAAA;ArB+hEJ;AqB3hEE;EACE,gCf40BoC;Ee10BpC,UAAA;ArB4hEJ;AqBphEE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;ArBmhEJ;AqB/gEE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;ArBihEJ;AsBvmEM;ED0EJ;ICzEM,gBAAA;EtB0mEN;AACF;AqBnhEE;EACE,wCf47B8B;ANylClC;;AqB5gEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;ArB+gEF;AqB7gEE;EACE,UAAA;ArB+gEJ;AqB5gEE;EAEE,gBAAA;EACA,eAAA;ArB6gEJ;;AqBlgEA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;AP0oEJ;AqBngEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;ANi4C9B;;AqBjgEA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;APspEJ;AqBlgEE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;ANy4C9B;;AqB5/DE;EACE,oEf6uBoC;ANkxCxC;AqB5/DE;EACE,mEf0uBoC;ANoxCxC;AqB3/DE;EACE,iEfuuBoC;ANsxCxC;;AqBx/DA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AN06C9B;AqBz/DE;EACE,eAAA;ArB2/DJ;AqBx/DE;EACE,oBAAA;EdvLA,sCAAA;APkrEJ;AqBv/DE;EACE,oBAAA;Ed5LA,sCAAA;APsrEJ;AqBt/DE;EAAoB,+Df8sBkB;AN2yCxC;AqBx/DE;EAAoB,6Df8sBkB;AN6yCxC;;AwB1sEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AxB0sEF;AsB/sEM;EEfN;IFgBQ,gBAAA;EtBktEN;AACF;AwB7sEE;EACE,kClBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AN0uClC;AwBvsEE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AxBwsEJ;AwBrsEE;EAEE,wClBu1BoC;AN+2CxC;AwBjsEE;EACE,kBAAA;EACA,uCAAA;AxBmsEJ;;AwB/rEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;AP6uEJ;;AwB/rEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;APqvEJ;;AwB7rEI;EACE,gEAAA;AxBgsEN;;AyBxwEA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;ANs2C1C;AyBzwEE;EACE,WAAA;EACA,mBAAA;AzB2wEJ;;AyBvwEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AzB0wEF;AyBxwEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AzB0wEJ;;AyBtwEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,iCAAA;UAAA,yBAAA;AzBwwEF;AyBrwEE;ElB3BE,qBAAA;APmyEJ;AyBpwEE;EAEE,kBnBm4BsC;ANk4C1C;AyBlwEE;EACE,uBnB03BsC;AN04C1C;AyBjwEE;EACE,kCnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;ANqwDxB;AyBhwEE;EACE,yBnB5BM;EmB6BN,qBnB7BM;AN+xEV;AyBhwEI;EAII,iEAAA;AzB+vER;AyB3vEI;EAII,iEAAA;AzB0vER;AyBrvEE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,iEAAA;AzBmvEN;AyB/uEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;AN+4C3C;AyB1uEI;EACE,eAAA;EACA,YnBy1BqC;ANm5C3C;;AyB9tEA;EACE,mBnBo1BgC;AN64ClC;AyB/tEE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AzBguEJ;AsBl1EM;EG0GJ;IHzGM,gBAAA;EtBq1EN;AACF;AyBnuEI;EACE,4DAAA;AzBquEN;AyBluEI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;AzBguER;AyB3tEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AzB6tEJ;AyB3tEI;EACE,oBAAA;EACA,cAAA;AzB6tEN;;AyBxtEA;EACE,qBAAA;EACA,kBnBsyBgC;ANq7ClC;;AyBxtEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzB2tEF;AyBvtEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;ANmkD9B;;AyBltEI;EACE,4DAAA;AzBqtEN;;A0Bx4EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A1B24EF;A0Bz4EE;EACE,UAAA;A1B24EJ;A0Bv4EI;EAA0B,kEpB8gCa;AN43C3C;A0Bz4EI;EAA0B,kEpB6gCa;AN+3C3C;A0Bz4EE;EACE,SAAA;A1B24EJ;A0Bx4EE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A1By4EJ;AsBx5EM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EtB25EN;AACF;A0B54EI;EHjCF,0CjB8hCyC;ANk5C3C;A0B14EE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;AP06EJ;A0Bx4EE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A1By4EJ;AsBl7EM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EtBq7EN;AACF;A0B54EI;EH3DF,0CjB8hCyC;AN46C3C;A0B14EE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;APo8EJ;A0Bx4EE;EACE,oBAAA;A1B04EJ;A0Bx4EI;EACE,2CpBg9BqC;AN07C3C;A0Bv4EI;EACE,2CpB48BqC;AN67C3C;;A2Bh+EA;EACE,kBAAA;A3Bm+EF;A2Bj+EE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;AN47CxC;A2Bh+EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;A3Bk+EJ;AsBv+EM;EKTJ;ILUM,gBAAA;EtB0+EN;AACF;A2Bp+EE;;EAEE,qBAAA;A3Bs+EJ;A2Bp+EI;;EACE,kBAAA;A3Bu+EN;A2Bp+EI;;;EAEE,qBrB4gCkC;EqB3gClC,wBrB4gCkC;AN29CxC;A2Bp+EI;;EACE,qBrBugCkC;EqBtgClC,wBrBugCkC;ANg+CxC;A2Bn+EE;EACE,qBrBigCoC;EqBhgCpC,wBrBigCoC;ANo+CxC;A2B99EI;;;;EACE,2CAAA;EACA,8DrB2/BkC;ANw+CxC;A2Bj+EM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBm/BgC;EqBl/BhC,WAAA;EACA,mCrBg0BgC;ECh3BpC,sCAAA;APuhFJ;A2Bh+EI;EACE,2CAAA;EACA,8DrB0+BkC;ANw/CxC;A2B79EI;EACE,sCAAA;A3B+9EN;A2B39EE;;EAEE,crB1EO;ANuiFX;A2B39EI;;EACE,wCrB0yBkC;ANorDxC;;A4BrjFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5BwjFF;A4BtjFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5BwjFJ;A4BpjFE;;;EAGE,UAAA;A5BsjFJ;A4BhjFE;EACE,kBAAA;EACA,UAAA;A5BkjFJ;A4BhjFI;EACE,UAAA;A5BkjFN;;A4BviFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;APilFJ;;A4BjiFA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;AP0lFJ;;A4BjiFA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;APmmFJ;;A4BjiFA;;EAEE,mBAAA;A5BoiFF;;A4BvhFI;;;;ErBjEA,0BAAA;EACA,6BAAA;AP+lFJ;A4BthFI;;;;ErB1EA,0BAAA;EACA,6BAAA;APsmFJ;A4BhhFE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AP6lFJ;A4BhhFE;;ErB9EE,yBAAA;EACA,4BAAA;APkmFJ;;A6B1nFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;AN0kDzB;;A6BznFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;APupFJ;;A6BvnFI;;;;EAEE,cAAA;A7B4nFN;;A6B3qFI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BwnFR;A6BrnFM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;AN4mDzB;;A6BxrFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7B6mFR;;A6B7rFI;EAuFE,+CvBq/BmB;ANqnDzB;A6BvmFQ;EAEE,iEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7BwmFV;A6BpmFM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;AN+nDzB;;A6B3sFI;EAkHI,yCAAA;A7B6lFR;;A6B/sFI;EAyHE,+CvBm9BmB;ANuoDzB;A6BxlFM;EACE,4CvBg9BiB;AN0oDzB;A6BvlFM;EACE,2DvB48BiB;AN6oDzB;A6BtlFM;EACE,iCvBw8BiB;ANgpDzB;;A6BnlFI;EACE,kBAAA;A7BslFN;;A6BhuFI;;;;;EAoJM,UAAA;A7BolFV;;A6BptFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;ANoqDzB;;A6BntFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;APivFJ;;A6BjtFI;;;;EAEE,cAAA;A7BstFN;;A6BrwFI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BktFR;A6B/sFM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;ANssDzB;;A6BlxFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7BusFR;;A6BvxFI;EAuFE,iDvBq/BmB;AN+sDzB;A6BjsFQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7BksFV;A6B9rFM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;ANytDzB;;A6BryFI;EAkHI,yCAAA;A7BurFR;;A6BzyFI;EAyHE,iDvBm9BmB;ANiuDzB;A6BlrFM;EACE,8CvBg9BiB;ANouDzB;A6BjrFM;EACE,0DvB48BiB;ANuuDzB;A6BhrFM;EACE,mCvBw8BiB;AN0uDzB;;A6B7qFI;EACE,kBAAA;A7BgrFN;;A6B1zFI;;;;;EAsJM,UAAA;A7B4qFV;;A8Bp0FA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A9Bk0FF;AsBt1FM;EQhBN;IRiBQ,gBAAA;EtBy1FN;AACF;A8Br0FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A9Bs0FJ;A8Bn0FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A9Bo0FJ;A8Bj0FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A9B+zFN;A8B3zFE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A9ByzFN;A8BrzFE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A9BizFJ;A8B9yFI;EAKI,0CAAA;A9B4yFR;A8BvyFE;EAKI,0CAAA;A9BqyFN;A8BjyFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A9BgyFJ;;A8BpxFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bu4FF;;A8BryFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bw5FF;;A8BtzFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,+CAAA;EACA,uCAAA;EACA,2BAAA;EACA,sCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/By6FF;;A8Bv0FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B07FF;;A8Bx1FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B28FF;;A8Bz2FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,sCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B49FF;;A8B13FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B6+FF;;A8B34FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B8/FF;;A8Bl4FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/Bs/FF;;A8Bn5FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BugGF;;A8Bp6FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BwhGF;;A8Br7FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/ByiGF;;A8Bt8FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B0jGF;;A8Bv9FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B2kGF;;A8Bx+FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B4lGF;;A8Bz/FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B6mGF;;A8B9/FA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;ANkvF1C;A8Bt/FE;EACE,0BAAA;A9Bw/FJ;A8Br/FE;EACE,gCAAA;A9Bu/FJ;;A8B5+FA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;A/BioGF;;A8B/+FA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A/BwoGF;;AgC3sGA;EVgBM,gCUfJ;AhC8sGF;AsB3rGM;EUpBN;IVqBQ,gBAAA;EtB8rGN;AACF;AgCjtGE;EACE,UAAA;AhCmtGJ;;AgC7sGE;EACE,aAAA;AhCgtGJ;;AgC5sGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhC+sGF;AsB7sGM;EULN;IVMQ,gBAAA;EtBgtGN;AACF;AgCltGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhCotGJ;AsBvtGM;EUAJ;IVCM,gBAAA;EtB0tGN;AACF;;AiC/uGA;;;;;;EAME,kBAAA;AjCkvGF;;AiC/uGA;EACE,mBAAA;AjCkvGF;AkC1tGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlCkwGF;AkCxsGI;EACE,cAAA;AlC0sGN;;AiCxvGA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;APkyGJ;AiCrvGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AjCuvGJ;;AiC/tGI;EACE,oBAAA;AjCkuGN;AiChuGM;EACE,WAAA;EACA,OAAA;AjCkuGR;;AiC9tGI;EACE,kBAAA;AjCiuGN;AiC/tGM;EACE,QAAA;EACA,UAAA;AjCiuGR;;Ac3wGI;EmB4BA;IACE,oBAAA;EjCmvGJ;EiCjvGI;IACE,WAAA;IACA,OAAA;EjCmvGN;EiC/uGE;IACE,kBAAA;EjCivGJ;EiC/uGI;IACE,QAAA;IACA,UAAA;EjCivGN;AACF;Ac5xGI;EmB4BA;IACE,oBAAA;EjCmwGJ;EiCjwGI;IACE,WAAA;IACA,OAAA;EjCmwGN;EiC/vGE;IACE,kBAAA;EjCiwGJ;EiC/vGI;IACE,QAAA;IACA,UAAA;EjCiwGN;AACF;Ac5yGI;EmB4BA;IACE,oBAAA;EjCmxGJ;EiCjxGI;IACE,WAAA;IACA,OAAA;EjCmxGN;EiC/wGE;IACE,kBAAA;EjCixGJ;EiC/wGI;IACE,QAAA;IACA,UAAA;EjCixGN;AACF;Ac5zGI;EmB4BA;IACE,oBAAA;EjCmyGJ;EiCjyGI;IACE,WAAA;IACA,OAAA;EjCmyGN;EiC/xGE;IACE,kBAAA;EjCiyGJ;EiC/xGI;IACE,QAAA;IACA,UAAA;EjCiyGN;AACF;Ac50GI;EmB4BA;IACE,oBAAA;EjCmzGJ;EiCjzGI;IACE,WAAA;IACA,OAAA;EjCmzGN;EiC/yGE;IACE,kBAAA;EjCizGJ;EiC/yGI;IACE,QAAA;IACA,UAAA;EjCizGN;AACF;AiCxyGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AjC0yGJ;AkC93GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlC+5GF;AkC52GI;EACE,cAAA;AlC82GN;;AiC9yGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AjCizGJ;AkCn5GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlC66GF;AkCj4GI;EACE,cAAA;AlCm4GN;AiCzzGI;EACE,iBAAA;AjC2zGN;;AiCrzGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AjCwzGJ;AkC36GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AlC66GN;AkCl6GM;EACE,aAAA;AlCo6GR;AkCj6GM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlCu8GF;AkCj6GI;EACE,cAAA;AlCm6GN;AiCx0GI;EACE,iBAAA;AjC00GN;;AiCn0GA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AjCs0GF;;AiCh0GA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AP0+GJ;AiCj0GE;EAEE,0CAAA;EV1LF,kDU4LuB;AjCi0GzB;AiC9zGE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AjC+zGzB;AiC5zGE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AjC6zGJ;;AiCvzGA;EACE,cAAA;AjC0zGF;;AiCtzGA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AjCyzGF;;AiCrzGA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AjCwzGF;;AiCpzGA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AjCszGF;;AmC5iHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnC+iHF;AmC7iHE;;EACE,kBAAA;EACA,cAAA;AnCgjHJ;AmC3iHE;;;;;;;;;;;;EAME,UAAA;AnCmjHJ;;AmC9iHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnCijHF;AmC/iHE;EACE,WAAA;AnCijHJ;;AmC7iHA;E5BhBI,sCAAA;APikHJ;AmC7iHE;;EAEE,8CAAA;AnC+iHJ;AmC3iHE;;;E5BVE,0BAAA;EACA,6BAAA;AP0jHJ;AmCviHE;;;E5BNE,yBAAA;EACA,4BAAA;APkjHJ;;AmC1hHA;EACE,wBAAA;EACA,uBAAA;AnC6hHF;AmC3hHE;EAGE,cAAA;AnC2hHJ;AmCxhHE;EACE,eAAA;AnC0hHJ;;AmCthHA;EACE,uBAAA;EACA,sBAAA;AnCyhHF;;AmCthHA;EACE,sBAAA;EACA,qBAAA;AnCyhHF;;AmCrgHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnCwgHF;AmCtgHE;;EAEE,WAAA;AnCwgHJ;AmCrgHE;;EAEE,6CAAA;AnCugHJ;AmCngHE;;E5B1FE,6BAAA;EACA,4BAAA;APimHJ;AmCngHE;;E5B7GE,yBAAA;EACA,0BAAA;APonHJ;;AoC5oHA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApC2oHF;;AoCxoHA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApC2oHF;AsBvpHM;EcGN;IdFQ,gBAAA;EtB0pHN;AACF;AoC9oHE;EAEE,qCAAA;ApC+oHJ;AoC3oHE;EACE,UAAA;EACA,kD9BkhBoB;AN2nGxB;AoCzoHE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ApC0oHJ;;AoCloHA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ApCkoHF;AoChoHE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;APgrHJ;AoCjoHI;EAGE,kBAAA;EACA,wDAAA;ApCioHN;AoC7nHE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApC+nHJ;AoC5nHE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AP+rHJ;;AoCpnHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApCsnHF;AoCnnHE;E7B5FE,gDAAA;APktHJ;AoClnHE;;EAEE,4CAAA;EbjHF,oDakHuB;ApConHzB;;AoC3mHA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ApC2mHF;AoCzmHE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ApC2mHJ;AoCzmHI;EAEE,iCAAA;ApC0mHN;AoCtmHE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ApCwmHJ;;AoC9lHE;;EAEE,cAAA;EACA,kBAAA;ApCimHJ;;AoC5lHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ApC+lHJ;;AoCzlHE;;EACE,WAAA;ApC6lHJ;;AoCnlHE;EACE,aAAA;ApCslHJ;AoCplHE;EACE,cAAA;ApCslHJ;;AqCnxHA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArCmxHF;AqC7wHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArCqxHJ;AqCjwHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ArCmwHF;AqCjwHE;EAEE,yCAAA;ArCkwHJ;;AqCxvHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArCuvHF;AqCpvHI;EAEE,oCAAA;ArCqvHN;AqCjvHE;EACE,gBAAA;ArCmvHJ;;AqC1uHA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ArC6uHF;AqC3uHE;;;EAGE,oCAAA;ArC6uHJ;;AqChuHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ArCiuHF;;AqC7tHA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ArCguHF;AsBz2HM;EeiIN;IfhIQ,gBAAA;EtB42HN;AACF;AqCnuHE;EACE,qBAAA;ArCquHJ;AqCluHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArCouHJ;;AqC9tHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArCiuHF;;AqC9tHA;EACE,yCAAA;EACA,gBAAA;ArCiuHF;;Ac31HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCwtHN;EqCttHM;IACE,mBAAA;ErCwtHR;EqCttHQ;IACE,kBAAA;ErCwtHV;EqCrtHQ;IACE,kDAAA;IACA,iDAAA;ErCutHV;EqCntHM;IACE,iBAAA;ErCqtHR;EqCltHM;IACE,wBAAA;IACA,gBAAA;ErCotHR;EqCjtHM;IACE,aAAA;ErCmtHR;EqChtHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCgtHR;EqC7sHQ;IACE,aAAA;ErC+sHV;EqC5sHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC8sHV;AACF;Ac34HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCuwHN;EqCrwHM;IACE,mBAAA;ErCuwHR;EqCrwHQ;IACE,kBAAA;ErCuwHV;EqCpwHQ;IACE,kDAAA;IACA,iDAAA;ErCswHV;EqClwHM;IACE,iBAAA;ErCowHR;EqCjwHM;IACE,wBAAA;IACA,gBAAA;ErCmwHR;EqChwHM;IACE,aAAA;ErCkwHR;EqC/vHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC+vHR;EqC5vHQ;IACE,aAAA;ErC8vHV;EqC3vHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC6vHV;AACF;Ac17HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCszHN;EqCpzHM;IACE,mBAAA;ErCszHR;EqCpzHQ;IACE,kBAAA;ErCszHV;EqCnzHQ;IACE,kDAAA;IACA,iDAAA;ErCqzHV;EqCjzHM;IACE,iBAAA;ErCmzHR;EqChzHM;IACE,wBAAA;IACA,gBAAA;ErCkzHR;EqC/yHM;IACE,aAAA;ErCizHR;EqC9yHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC8yHR;EqC3yHQ;IACE,aAAA;ErC6yHV;EqC1yHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC4yHV;AACF;Acz+HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCq2HN;EqCn2HM;IACE,mBAAA;ErCq2HR;EqCn2HQ;IACE,kBAAA;ErCq2HV;EqCl2HQ;IACE,kDAAA;IACA,iDAAA;ErCo2HV;EqCh2HM;IACE,iBAAA;ErCk2HR;EqC/1HM;IACE,wBAAA;IACA,gBAAA;ErCi2HR;EqC91HM;IACE,aAAA;ErCg2HR;EqC71HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC61HR;EqC11HQ;IACE,aAAA;ErC41HV;EqCz1HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC21HV;AACF;AcxhII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCo5HN;EqCl5HM;IACE,mBAAA;ErCo5HR;EqCl5HQ;IACE,kBAAA;ErCo5HV;EqCj5HQ;IACE,kDAAA;IACA,iDAAA;ErCm5HV;EqC/4HM;IACE,iBAAA;ErCi5HR;EqC94HM;IACE,wBAAA;IACA,gBAAA;ErCg5HR;EqC74HM;IACE,aAAA;ErC+4HR;EqC54HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC44HR;EqCz4HQ;IACE,aAAA;ErC24HV;EqCx4HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC04HV;AACF;AqCj8HI;EAEI,iBAAA;EACA,2BAAA;ArCk8HR;AqCh8HQ;EACE,mBAAA;ArCk8HV;AqCh8HU;EACE,kBAAA;ArCk8HZ;AqC/7HU;EACE,kDAAA;EACA,iDAAA;ArCi8HZ;AqC77HQ;EACE,iBAAA;ArC+7HV;AqC57HQ;EACE,wBAAA;EACA,gBAAA;ArC87HV;AqC37HQ;EACE,aAAA;ArC67HV;AqC17HQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ArC07HV;AqCv7HU;EACE,aAAA;ArCy7HZ;AqCt7HU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArCw7HZ;;AqCv6HA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArCy6HF;;AqCn6HI;EACE,qEAAA;ArCs6HN;;AsC/rIA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;APitIJ;AsC5rIE;EACE,eAAA;EACA,cAAA;AtC8rIJ;AsC3rIE;EACE,mBAAA;EACA,sBAAA;AtC6rIJ;AsC3rII;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;APotIJ;AsC3rII;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AP2sIJ;AsCxrIE;;EAEE,aAAA;AtC0rIJ;;AsCtrIA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtCurIF;;AsCprIA;EACE,4CAAA;EACA,iCAAA;AtCurIF;;AsCprIA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtCurIF;;AsCprIA;EACE,gBAAA;AtCurIF;;AsC/qIE;EACE,oCAAA;AtCkrIJ;;AsC1qIA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtC6qIF;AsC3qIE;E/B7FE,wFAAA;AP2wIJ;;AsCzqIA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtC4qIF;AsC1qIE;E/BxGE,wFAAA;APqxIJ;;AsCnqIA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtCsqIF;AsCpqIE;EACE,mCAAA;EACA,sCAAA;AtCsqIJ;;AsClqIA;EACE,uDAAA;EACA,sDAAA;AtCqqIF;;AsCjqIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AP+yIJ;;AsCjqIA;;;EAGE,WAAA;AtCoqIF;;AsCjqIA;;E/B3II,0DAAA;EACA,2DAAA;APizIJ;;AsClqIA;;E/BlII,8DAAA;EACA,6DAAA;APyyIJ;;AsC3pIE;EACE,0CAAA;AtC8pIJ;AczxII;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtC8pIF;EsC3pIE;IAEE,SAAA;IACA,gBAAA;EtC4pIJ;EsC1pII;IACE,cAAA;IACA,cAAA;EtC4pIN;EsCvpIM;I/B3KJ,0BAAA;IACA,6BAAA;EPq0IF;EsCxpIQ;;IAGE,0BAAA;EtCypIV;EsCvpIQ;;IAGE,6BAAA;EtCwpIV;EsCppIM;I/B5KJ,yBAAA;IACA,4BAAA;EPm0IF;EsCrpIQ;;IAGE,yBAAA;EtCspIV;EsCppIQ;;IAGE,4BAAA;EtCqpIV;AACF;;AuC13IA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AvC43IF;;AuCx3IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AvC23IF;AsBl5IM;EiBUN;IjBTQ,gBAAA;EtBq5IN;AACF;AuC93IE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvCg4IJ;AuC93II;EACE,qDAAA;EACA,iDAAA;AvCg4IN;AuC33IE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AvC63IJ;AsB36IM;EiBqCJ;IjBpCM,gBAAA;EtB86IN;AACF;AuC/3IE;EACE,UAAA;AvCi4IJ;AuC93IE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AvCg4IJ;;AuC53IA;EACE,gBAAA;AvC+3IF;;AuC53IA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvC+3IF;AuC73IE;EhC7DE,yDAAA;EACA,0DAAA;AP67IJ;AuC93II;EhChEA,+DAAA;EACA,gEAAA;APi8IJ;AuC73IE;EACE,aAAA;AvC+3IJ;AuC33IE;EhC5DE,6DAAA;EACA,4DAAA;AP07IJ;AuC33IM;EhChEF,mEAAA;EACA,kEAAA;AP87IJ;AuC13II;EhCrEA,6DAAA;EACA,4DAAA;APk8IJ;;AuCx3IA;EACE,8EAAA;AvC23IF;;AuCl3IE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;APo+IJ;AuCn3II;EAAgB,aAAA;AvCs3IpB;AuCr3II;EAAe,gBAAA;AvCw3InB;AuCp3IM;EhCtHF,gBAAA;AP6+IJ;AuCh3II;EhC7HA,gBAAA;APg/IJ;;AuC32II;EACE,iEAAA;EACA,wEAAA;AvC82IN;;AwCxgJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;APwgJJ;;AwClgJE;EACE,iDAAA;AxCqgJJ;AwCngJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AxCqgJN;AwCjgJE;EACE,6CAAA;AxCmgJJ;;AyCxiJA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AT6jJF;;AyCtiJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AzCyiJF;AsB1jJM;EmBQN;InBPQ,gBAAA;EtB6jJN;AACF;AyC5iJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzC6iJJ;AyC1iJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AzC4iJJ;AyCziJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AzC0iJJ;AyCviJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzCwiJJ;;AyCniJE;EACE,8CnC8sCgC;ANw1GpC;AyCjiJM;ElC9BF,0DAAA;EACA,6DAAA;APkkJJ;AyC/hJM;ElClDF,2DAAA;EACA,8DAAA;APolJJ;;AyClhJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;A1CwnJF;;AyCrhJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A1C+nJF;;A2CjoJA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;APsoJJ;A2C7nJE;EACE,aAAA;A3C+nJJ;;A2C1nJA;EACE,kBAAA;EACA,SAAA;A3C6nJF;;A4C7pJA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;APiqJJ;;A4CzpJA;EAEE,cAAA;A5C2pJF;;A4CvpJA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A5C0pJF;;A4ClpJA;EACE,mBtCs+C8B;AN+qGhC;A4ClpJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A5CopJJ;;A4C5oJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C+oJJ;;A4CnpJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5CspJJ;;A4C1pJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C6pJJ;;A4CjqJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CoqJJ;;A4CxqJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C2qJJ;;A4C/qJE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5CkrJJ;;A4CtrJE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5CyrJJ;;A4C7rJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CgsJJ;;A6C5vJE;EACE;IAAK,2BvCyhD2B;ENuuGlC;AACF;A6C5vJA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;APowJJ;;A6CvvJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A7C0vJF;AsB/wJM;EuBYN;IvBXQ,gBAAA;EtBkxJN;AACF;;A6C5vJA;EtBAE,qMAAA;EsBEA,oEAAA;A7C+vJF;;A6C5vJA;EACE,iBAAA;A7C+vJF;;A6C5vJA;EACE,WAAA;A7C+vJF;;A6C3vJE;EACE,kDAAA;A7C8vJJ;A6C3vJM;EAJJ;IAKM,eAAA;E7C8vJN;AACF;;A8C1zJA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;APo0JJ;;A8CrzJA;EACE,qBAAA;EACA,sBAAA;A9CwzJF;A8CtzJE;EAEE,oCAAA;EACA,0BAAA;A9CuzJJ;;A8C9yJA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9CizJF;A8C9yJE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9C+yJJ;A8C5yJE;EACE,+CAAA;EACA,uDAAA;A9C8yJJ;;A8CtyJA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9CyyJF;A8CvyJE;EvCvDE,+BAAA;EACA,gCAAA;APi2JJ;A8CvyJE;EvC7CE,mCAAA;EACA,kCAAA;APu1JJ;A8CvyJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9CwyJJ;A8CpyJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9CsyJJ;A8ClyJE;EACE,mBAAA;A9CoyJJ;A8ClyJI;EACE,wDAAA;EACA,mDAAA;A9CoyJN;;A8CvxJI;EACE,mBAAA;A9C0xJN;A8CvxJQ;EvCvDJ,6DAAA;EAZA,0BAAA;AP81JJ;A8CtxJQ;EvCxEJ,2DAAA;EAYA,4BAAA;APs1JJ;A8CrxJQ;EACE,aAAA;A9CuxJV;A8CpxJQ;EACE,mDAAA;EACA,oBAAA;A9CsxJV;A8CpxJU;EACE,yDAAA;EACA,oDAAA;A9CsxJZ;;Ac52JI;EgC8DA;IACE,mBAAA;E9CkzJJ;E8C/yJM;IvCvDJ,6DAAA;IAZA,0BAAA;EPs3JF;E8C9yJM;IvCxEJ,2DAAA;IAYA,4BAAA;EP82JF;E8C7yJM;IACE,aAAA;E9C+yJR;E8C5yJM;IACE,mDAAA;IACA,oBAAA;E9C8yJR;E8C5yJQ;IACE,yDAAA;IACA,oDAAA;E9C8yJV;AACF;Acr4JI;EgC8DA;IACE,mBAAA;E9C00JJ;E8Cv0JM;IvCvDJ,6DAAA;IAZA,0BAAA;EP84JF;E8Ct0JM;IvCxEJ,2DAAA;IAYA,4BAAA;EPs4JF;E8Cr0JM;IACE,aAAA;E9Cu0JR;E8Cp0JM;IACE,mDAAA;IACA,oBAAA;E9Cs0JR;E8Cp0JQ;IACE,yDAAA;IACA,oDAAA;E9Cs0JV;AACF;Ac75JI;EgC8DA;IACE,mBAAA;E9Ck2JJ;E8C/1JM;IvCvDJ,6DAAA;IAZA,0BAAA;EPs6JF;E8C91JM;IvCxEJ,2DAAA;IAYA,4BAAA;EP85JF;E8C71JM;IACE,aAAA;E9C+1JR;E8C51JM;IACE,mDAAA;IACA,oBAAA;E9C81JR;E8C51JQ;IACE,yDAAA;IACA,oDAAA;E9C81JV;AACF;Acr7JI;EgC8DA;IACE,mBAAA;E9C03JJ;E8Cv3JM;IvCvDJ,6DAAA;IAZA,0BAAA;EP87JF;E8Ct3JM;IvCxEJ,2DAAA;IAYA,4BAAA;EPs7JF;E8Cr3JM;IACE,aAAA;E9Cu3JR;E8Cp3JM;IACE,mDAAA;IACA,oBAAA;E9Cs3JR;E8Cp3JQ;IACE,yDAAA;IACA,oDAAA;E9Cs3JV;AACF;Ac78JI;EgC8DA;IACE,mBAAA;E9Ck5JJ;E8C/4JM;IvCvDJ,6DAAA;IAZA,0BAAA;EPs9JF;E8C94JM;IvCxEJ,2DAAA;IAYA,4BAAA;EP88JF;E8C74JM;IACE,aAAA;E9C+4JR;E8C54JM;IACE,mDAAA;IACA,oBAAA;E9C84JR;E8C54JQ;IACE,yDAAA;IACA,oDAAA;E9C84JV;AACF;A8Cj4JA;EvChJI,gBAAA;APohKJ;A8Cj4JE;EACE,mDAAA;A9Cm4JJ;A8Cj4JI;EACE,sBAAA;A9Cm4JN;;A8Ct3JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Cy3JJ;;A8Cn4JE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9Cs4JJ;;A8Ch5JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Cm5JJ;;A8C75JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9Cg6JJ;;A8C16JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9C66JJ;;A8Cv7JE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9C07JJ;;A8Cp8JE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9Cu8JJ;;A8Cj9JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9Co9JJ;;A+ChpKA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,UzCqpD2B;EyCppD3B,WzCopD2B;EyCnpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A/CgpKF;A+C7oKE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/C+oKJ;A+C5oKE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/C8oKJ;A+C3oKE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;A/C4oKJ;;A+CpoKA;EAHE,wCAAA;A/C2oKF;;A+CloKI;EATF,wCAAA;A/C+oKF;;AgDhsKA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;APysKJ;AgD9rKE;EACE,UAAA;AhDgsKJ;AgD7rKE;EACE,aAAA;AhD+rKJ;;AgD3rKA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AhD6rKF;AgD3rKE;EACE,sCAAA;AhD6rKJ;;AgDzrKA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;AP6tKJ;AgD3rKE;EACE,oDAAA;EACA,sCAAA;AhD6rKJ;;AgDzrKA;EACE,kCAAA;EACA,qBAAA;AhD4rKF;;AiD1vKA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjDwvKF;;AiDjvKA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjDmvKF;AiDhvKE;E3B5CI,mC2B6CF;EACA,8B3Ck8CgC;ANgzHpC;AsB5xKM;E2BwCJ;I3BvCM,gBAAA;EtB+xKN;AACF;AiDrvKE;EACE,e3Cg8CgC;ANuzHpC;AiDnvKE;EACE,sB3C67CgC;ANwzHpC;;AiDjvKA;EACE,+CAAA;AjDovKF;AiDlvKE;EACE,gBAAA;EACA,gBAAA;AjDovKJ;AiDjvKE;EACE,gBAAA;AjDmvKJ;;AiD/uKA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjDkvKF;;AiD9uKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AjD8uKF;;AiD1uKA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjDgvK9D;AkD51KE;EAAS,UAAA;AlD+1KX;AkD91KE;EAAS,mCD2GiF;AjDsvK5F;;AiDjvKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;AP01KJ;AiDnvKE;EACE,kGAAA;EACA,sJAAA;AjDqvKJ;;AiDhvKA;EACE,gBAAA;EACA,8CAAA;AjDmvKF;;AiD9uKA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjD+uKF;;AiD3uKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1CzHE,+DAAA;EACA,8DAAA;APw2KJ;AiD1uKE;EACE,8CAAA;AjD4uKJ;;Acv1KI;EmCiHF;IACE,0BAAA;IACA,2CAAA;EjD0uKF;EiDtuKA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjDwuKF;EiDruKA;IACE,uBAAA;EjDuuKF;AACF;Act2KI;EmCmIF;;IAEE,uBAAA;EjDsuKF;AACF;Ac52KI;EmC0IF;IACE,wBAAA;EjDquKF;AACF;AiD5tKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjD8tKN;AiD5tKM;EACE,YAAA;EACA,SAAA;E1CzMJ,gBAAA;APw6KJ;AiD3tKM;;E1C7MF,gBAAA;AP46KJ;AiD1tKM;EACE,gBAAA;AjD4tKR;;Act3KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDkvKJ;EiDhvKI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EP47KF;EiD/uKI;;I1C7MF,gBAAA;EPg8KF;EiD9uKI;IACE,gBAAA;EjDgvKN;AACF;Ac34KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDswKJ;EiDpwKI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EPg9KF;EiDnwKI;;I1C7MF,gBAAA;EPo9KF;EiDlwKI;IACE,gBAAA;EjDowKN;AACF;Ac/5KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD0xKJ;EiDxxKI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EPo+KF;EiDvxKI;;I1C7MF,gBAAA;EPw+KF;EiDtxKI;IACE,gBAAA;EjDwxKN;AACF;Acn7KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD8yKJ;EiD5yKI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EPw/KF;EiD3yKI;;I1C7MF,gBAAA;EP4/KF;EiD1yKI;IACE,gBAAA;EjD4yKN;AACF;Acv8KI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDk0KJ;EiDh0KI;IACE,YAAA;IACA,SAAA;I1CzMJ,gBAAA;EP4gLF;EiD/zKI;;I1C7MF,gBAAA;EPghLF;EiD9zKI;IACE,gBAAA;EjDg0KN;AACF;AmDtiLA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AnD8iLF;AmD5iLE;EAAS,kCAAA;AnD+iLX;AmD7iLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnD+iLJ;AmD7iLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnD+iLN;;AmD1iLA;EACE,iDAAA;AnD6iLF;AmD3iLE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnD6iLJ;;AmDziLA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnD4iLF;AmD1iLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnD4iLJ;;AmDxiLA,mBAAA;AAEA;EACE,8CAAA;AnD0iLF;AmDxiLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnD0iLJ;;AmDtiLA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnDyiLF;AmDviLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnDyiLJ;;AmDriLA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;APynLJ;;AqD5oLA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;APuqLJ;AqDnpLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArDqpLJ;AqDnpLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArDopLN;;AqD9oLE;EACE,oFAAA;ArDipLJ;AqD/oLI;EAEE,wFAAA;ArDgpLN;AqD7oLI;EACE,SAAA;EACA,gDAAA;ArD+oLN;AqD5oLI;EACE,sCAAA;EACA,sCAAA;ArD8oLN;;AqDzoLA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArD2oLJ;AqDzoLI;EAEE,kIAAA;ArD0oLN;AqDvoLI;EACE,OAAA;EACA,kDAAA;ArDyoLN;AqDtoLI;EACE,oCAAA;EACA,wCAAA;ArDwoLN;;AqDnoLA,mBAAA;AAGE;EACE,iFAAA;ArDooLJ;AqDloLI;EAEE,wFAAA;ArDmoLN;AqDhoLI;EACE,MAAA;EACA,mDAAA;ArDkoLN;AqD/nLI;EACE,mCAAA;EACA,yCAAA;ArDioLN;AqD5nLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArD8nLJ;;AqD1nLA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArD4nLJ;AqD1nLI;EAEE,kIAAA;ArD2nLN;AqDxnLI;EACE,QAAA;EACA,iDAAA;ArD0nLN;AqDvnLI;EACE,qCAAA;EACA,uCAAA;ArDynLN;;AqDpnLA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;APmwLJ;AqDrmLE;EACE,aAAA;ArDumLJ;;AqDnmLA;EACE,0EAAA;EACA,mCAAA;ArDsmLF;;AsD3xLA;EACE,kBAAA;AtD8xLF;;AsD3xLA;EACE,mBAAA;AtD8xLF;;AsD3xLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtD8xLF;AuDpzLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDszLJ;;AsD/xLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AtDkyLF;AsBjzLM;EgCQN;IhCPQ,gBAAA;EtBozLN;AACF;;AsDpyLA;;;EAGE,cAAA;AtDuyLF;;AsDpyLA;;EAEE,2BAAA;AtDuyLF;;AsDpyLA;;EAEE,4BAAA;AtDuyLF;;AsD9xLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtDiyLJ;AsD9xLE;;;EAGE,UAAA;EACA,UAAA;AtDgyLJ;AsD7xLE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtD+xLJ;AsBx1LM;EgCqDJ;;IhCpDM,gBAAA;EtB41LN;AACF;;AsD5xLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhD6gDmC;EgBnmD/B,8BgCuFJ;AtD8xLF;AsBj3LM;EgCkEN;;IhCjEQ,gBAAA;EtBq3LN;AACF;AsDjyLE;;;EAEE,WhDpGO;EgDqGP,qBAAA;EACA,UAAA;EACA,YhDqgDiC;AN+xIrC;;AsDjyLA;EACE,OAAA;AtDoyLF;;AsDjyLA;EACE,QAAA;AtDoyLF;;AsD/xLA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtDkyLF;;AsD/xLA;EACE,2TAAA;AtDkyLF;;AsDhyLA;EACE,0TAAA;AtDmyLF;;AsD3xLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDs9CmC;EgDr9CnC,mBAAA;EACA,gBhDo9CmC;ANy0IrC;AsD3xLE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,sBhDlKO;EgDmKP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB3mD/B,6BgCiKF;AtD4xLJ;AsBz7LM;EgC4IJ;IhC3IM,gBAAA;EtB47LN;AACF;AsD9xLE;EACE,UhDw8CiC;ANw1IrC;;AsDvxLA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,WhD7LS;EgD8LT,kBAAA;AtD0xLF;;AsDpxLE;;EAEE,gChDm8CiC;ANo1IrC;AsDpxLE;EACE,sBhDhMO;ANs9LX;AsDnxLE;EACE,WhDpMO;ANy9LX;;AsD/xLE;;;EAEE,gChDm8CiC;ANg2IrC;AsDhyLE;EACE,sBhDhMO;ANk+LX;AsD/xLE;EACE,WhDpMO;ANq+LX;;AwDn/LA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxDq/LF;;AwDj/LA;EACE;IAAK,0CAAA;ExDq/LL;AACF;AwDl/LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxDi/LF;;AwD9+LA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxDg/LF;;AwDv+LA;EACE;IACE,mBAAA;ExD0+LF;EwDx+LA;IACE,UAAA;IACA,eAAA;ExD0+LF;AACF;AwDt+LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxDq+LF;;AwDl+LA;EACE,wBAAA;EACA,yBAAA;AxDq+LF;;AwDj+LE;EACE;;IAEE,kCAAA;ExDo+LJ;AACF;AyDpjMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzDqjMF;;Acx/LI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDsiMJ;AACF;AsBjkMM;EmCYJ;InCXM,gBAAA;EtBokMN;AACF;Ac9gMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD6iMN;EyD1iMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD4iMN;EyDziMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD2iMN;EyDxiMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD0iMN;EyDviMI;IAEE,eAAA;EzDwiMN;EyDriMI;IAGE,mBAAA;EzDqiMN;AACF;AclkMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDoiMN;EyDliMM;IACE,aAAA;EzDoiMR;EyDjiMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDkiMR;AACF;;ActkMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDonMJ;AACF;AsB/oMM;EmCYJ;InCXM,gBAAA;EtBkpMN;AACF;Ac5lMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD2nMN;EyDxnMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD0nMN;EyDvnMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDynMN;EyDtnMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDwnMN;EyDrnMI;IAEE,eAAA;EzDsnMN;EyDnnMI;IAGE,mBAAA;EzDmnMN;AACF;AchpMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDknMN;EyDhnMM;IACE,aAAA;EzDknMR;EyD/mMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDgnMR;AACF;;AcppMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDksMJ;AACF;AsB7tMM;EmCYJ;InCXM,gBAAA;EtBguMN;AACF;Ac1qMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDysMN;EyDtsMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDwsMN;EyDrsMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDusMN;EyDpsMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDssMN;EyDnsMI;IAEE,eAAA;EzDosMN;EyDjsMI;IAGE,mBAAA;EzDisMN;AACF;Ac9tMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDgsMN;EyD9rMM;IACE,aAAA;EzDgsMR;EyD7rMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzD8rMR;AACF;;AcluMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDgxMJ;AACF;AsB3yMM;EmCYJ;InCXM,gBAAA;EtB8yMN;AACF;AcxvMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDuxMN;EyDpxMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDsxMN;EyDnxMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDqxMN;EyDlxMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDoxMN;EyDjxMI;IAEE,eAAA;EzDkxMN;EyD/wMI;IAGE,mBAAA;EzD+wMN;AACF;Ac5yMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD8wMN;EyD5wMM;IACE,aAAA;EzD8wMR;EyD3wMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzD4wMR;AACF;;AchzMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD81MJ;AACF;AsBz3MM;EmCYJ;InCXM,gBAAA;EtB43MN;AACF;Act0MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDq2MN;EyDl2MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDo2MN;EyDj2MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDm2MN;EyDh2MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDk2MN;EyD/1MI;IAEE,eAAA;EzDg2MN;EyD71MI;IAGE,mBAAA;EzD61MN;AACF;Ac13MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD41MN;EyD11MM;IACE,aAAA;EzD41MR;EyDz1MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzD01MR;AACF;;AyD16ME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AzD26MN;AsBr8MM;EmCYJ;InCXM,gBAAA;EtBw8MN;AACF;AyD96MM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzDg7MR;AyD76MM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzD+6MR;AyD56MM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzD86MR;AyD36MM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzD66MR;AyD16MM;EAEE,eAAA;AzD26MR;AyDx6MM;EAGE,mBAAA;AzDw6MR;;AyD74MA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;AN2/MX;AkDlgNE;EAAS,UAAA;AlDqgNX;AkDpgNE;EAAS,Y5Cm+CyB;ANoiKpC;;AyDz5MA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AzD45MF;AyD15ME;EACE,4FAAA;EACA,6IAAA;AzD45MJ;;AyDx5MA;EACE,gBAAA;EACA,kDAAA;AzD25MF;;AyDx5MA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzD25MF;;A0DxiNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;AN2vKpC;A0DziNE;EACE,qBAAA;EACA,WAAA;A1D2iNJ;;A0DtiNA;EACE,iBAAA;A1DyiNF;;A0DtiNA;EACE,iBAAA;A1DyiNF;;A0DtiNA;EACE,iBAAA;A1DyiNF;;A0DpiNE;EACE,mDAAA;A1DuiNJ;;A0DniNA;EACE;IACE,YpDmxCgC;ENmxKlC;AACF;A0DniNA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A1DqiNF;;A0DliNA;EACE;IACE,uBAAA;E1DqiNF;AACF;AuDplNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDslNJ;;A2DzlNE;EACE,sBAAA;EACA,iFAAA;A3D4lNJ;;A2D9lNE;EACE,sBAAA;EACA,mFAAA;A3DimNJ;;A2DnmNE;EACE,sBAAA;EACA,iFAAA;A3DsmNJ;;A2DxmNE;EACE,sBAAA;EACA,8EAAA;A3D2mNJ;;A2D7mNE;EACE,sBAAA;EACA,iFAAA;A3DgnNJ;;A2DlnNE;EACE,sBAAA;EACA,gFAAA;A3DqnNJ;;A2DvnNE;EACE,sBAAA;EACA,+EAAA;A3D0nNJ;;A2D5nNE;EACE,sBAAA;EACA,8EAAA;A3D+nNJ;;A4DjoNE;EACE,wEAAA;EACA,kGAAA;A5DooNJ;A4DjoNM;EAGE,8DAAA;EACA,wFAAA;A5DioNR;;A4D1oNE;EACE,0EAAA;EACA,oGAAA;A5D6oNJ;A4D1oNM;EAGE,8DAAA;EACA,wFAAA;A5D0oNR;;A4DnpNE;EACE,wEAAA;EACA,kGAAA;A5DspNJ;A4DnpNM;EAGE,8DAAA;EACA,wFAAA;A5DmpNR;;A4D5pNE;EACE,qEAAA;EACA,+FAAA;A5D+pNJ;A4D5pNM;EAGE,+DAAA;EACA,yFAAA;A5D4pNR;;A4DrqNE;EACE,wEAAA;EACA,kGAAA;A5DwqNJ;A4DrqNM;EAGE,+DAAA;EACA,yFAAA;A5DqqNR;;A4D9qNE;EACE,uEAAA;EACA,iGAAA;A5DirNJ;A4D9qNM;EAGE,8DAAA;EACA,wFAAA;A5D8qNR;;A4DvrNE;EACE,sEAAA;EACA,gGAAA;A5D0rNJ;A4DvrNM;EAGE,gEAAA;EACA,0FAAA;A5DurNR;;A4DhsNE;EACE,qEAAA;EACA,+FAAA;A5DmsNJ;A4DhsNM;EAGE,6DAAA;EACA,uFAAA;A5DgsNR;;A4DzrNA;EACE,+EAAA;EACA,yGAAA;A5D4rNF;A4DzrNI;EAEE,kFAAA;EACA,4GAAA;A5D0rNN;;A6DptNA;EACE,UAAA;EAEA,kJAAA;A7DstNF;;A8DztNA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A9D4tNF;A8D1tNE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A9D4tNJ;AsBrtNM;EwCZJ;IxCaM,gBAAA;EtBwtNN;AACF;;A8D1tNI;EACE,mEAAA;A9D6tNN;;A+DhvNA;EACE,kBAAA;EACA,WAAA;A/DmvNF;A+DjvNE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/DmvNJ;A+DhvNE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/DkvNJ;;A+D7uNE;EACE,uBAAA;A/DgvNJ;;A+DjvNE;EACE,sBAAA;A/DovNJ;;A+DrvNE;EACE,yBAAA;A/DwvNJ;;A+DzvNE;EACE,iCAAA;A/D4vNJ;;AgEjxNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;AN6qLpC;;AgEjxNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;ANqrLpC;;AgE5wNI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;AN4rLpC;;AgE5wNI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;ANksLpC;;AchvNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENysLlC;EgEzxNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN8sLlC;AACF;Ac7vNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENqtLlC;EgEryNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN0tLlC;AACF;AczwNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENiuLlC;EgEjzNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENsuLlC;AACF;AcrxNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN6uLlC;EgE7zNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENkvLlC;AACF;AcjyNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENyvLlC;EgEz0NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN8vLlC;AACF;AiE32NA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjE62NF;;AiE12NA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjE62NF;;AkEr3NA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnEs3NF;AmEn3NE;;EACE,6BAAA;AnEs3NJ;;AoEp4NE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ApEu4NJ;;AqE/4NA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtEm5NF;;AuEz5NA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;ANiuM9B;;AwEh2NQ;EAOI,mCAAA;AxE61NZ;;AwEp2NQ;EAOI,8BAAA;AxEi2NZ;;AwEx2NQ;EAOI,iCAAA;AxEq2NZ;;AwE52NQ;EAOI,iCAAA;AxEy2NZ;;AwEh3NQ;EAOI,sCAAA;AxE62NZ;;AwEp3NQ;EAOI,mCAAA;AxEi3NZ;;AwEx3NQ;EAOI,sBAAA;AxEq3NZ;;AwE53NQ;EAOI,uBAAA;AxEy3NZ;;AwEh4NQ;EAOI,sBAAA;AxE63NZ;;AwEp4NQ;EAOI,8BAAA;AxEi4NZ;;AwEx4NQ;EAOI,4BAAA;AxEq4NZ;;AwE54NQ;EAOI,2BAAA;AxEy4NZ;;AwEh5NQ;EAOI,iCAAA;AxE64NZ;;AwEp5NQ;EAOI,2BAAA;AxEi5NZ;;AwEx5NQ;EAOI,qBAAA;AxEq5NZ;;AwE55NQ;EAOI,wBAAA;AxEy5NZ;;AwEh6NQ;EAOI,uBAAA;AxE65NZ;;AwEp6NQ;EAOI,wBAAA;AxEi6NZ;;AwEx6NQ;EAOI,qBAAA;AxEq6NZ;;AwE56NQ;EAOI,yBAAA;AxEy6NZ;;AwEh7NQ;EAOI,2BAAA;AxE66NZ;;AwEp7NQ;EAOI,4BAAA;AxEi7NZ;;AwEx7NQ;EAOI,2BAAA;AxEq7NZ;;AwE57NQ;EAOI,2BAAA;AxEy7NZ;;AwEh8NQ;EAOI,6BAAA;AxE67NZ;;AwEp8NQ;EAOI,8BAAA;AxEi8NZ;;AwEx8NQ;EAOI,6BAAA;AxEq8NZ;;AwE58NQ;EAOI,2BAAA;AxEy8NZ;;AwEh9NQ;EAOI,6BAAA;AxE68NZ;;AwEp9NQ;EAOI,8BAAA;AxEi9NZ;;AwEx9NQ;EAOI,6BAAA;AxEq9NZ;;AwE59NQ;EAOI,0BAAA;AxEy9NZ;;AwEh+NQ;EAOI,gCAAA;AxE69NZ;;AwEp+NQ;EAOI,yBAAA;AxEi+NZ;;AwEx+NQ;EAOI,wBAAA;AxEq+NZ;;AwE5+NQ;EAOI,+BAAA;AxEy+NZ;;AwEh/NQ;EAOI,yBAAA;AxE6+NZ;;AwEp/NQ;EAOI,6BAAA;AxEi/NZ;;AwEx/NQ;EAOI,8BAAA;AxEq/NZ;;AwE5/NQ;EAOI,wBAAA;AxEy/NZ;;AwEhgOQ;EAOI,+BAAA;AxE6/NZ;;AwEpgOQ;EAOI,wBAAA;AxEigOZ;;AwExgOQ;EAOI,2CAAA;AxEqgOZ;;AwE5gOQ;EAOI,8CAAA;AxEygOZ;;AwEhhOQ;EAOI,8CAAA;AxE6gOZ;;AwEphOQ;EAOI,2BAAA;AxEihOZ;;AwEliOQ;EACE,gFAAA;AxEqiOV;;AwEtiOQ;EACE,kFAAA;AxEyiOV;;AwE1iOQ;EACE,gFAAA;AxE6iOV;;AwE9iOQ;EACE,6EAAA;AxEijOV;;AwEljOQ;EACE,gFAAA;AxEqjOV;;AwEtjOQ;EACE,+EAAA;AxEyjOV;;AwE1jOQ;EACE,8EAAA;AxE6jOV;;AwE9jOQ;EACE,6EAAA;AxEikOV;;AwExjOQ;EAOI,2BAAA;AxEqjOZ;;AwE5jOQ;EAOI,6BAAA;AxEyjOZ;;AwEhkOQ;EAOI,6BAAA;AxE6jOZ;;AwEpkOQ;EAOI,0BAAA;AxEikOZ;;AwExkOQ;EAOI,2BAAA;AxEqkOZ;;AwE5kOQ;EAOI,iBAAA;AxEykOZ;;AwEhlOQ;EAOI,mBAAA;AxE6kOZ;;AwEplOQ;EAOI,oBAAA;AxEilOZ;;AwExlOQ;EAOI,oBAAA;AxEqlOZ;;AwE5lOQ;EAOI,sBAAA;AxEylOZ;;AwEhmOQ;EAOI,uBAAA;AxE6lOZ;;AwEpmOQ;EAOI,kBAAA;AxEimOZ;;AwExmOQ;EAOI,oBAAA;AxEqmOZ;;AwE5mOQ;EAOI,qBAAA;AxEymOZ;;AwEhnOQ;EAOI,mBAAA;AxE6mOZ;;AwEpnOQ;EAOI,qBAAA;AxEinOZ;;AwExnOQ;EAOI,sBAAA;AxEqnOZ;;AwE5nOQ;EAOI,2CAAA;AxEynOZ;;AwEhoOQ;EAOI,sCAAA;AxE6nOZ;;AwEpoOQ;EAOI,sCAAA;AxEioOZ;;AwExoOQ;EAOI,uFAAA;AxEqoOZ;;AwE5oOQ;EAOI,oBAAA;AxEyoOZ;;AwEhpOQ;EAOI,2FAAA;AxE6oOZ;;AwEppOQ;EAOI,wBAAA;AxEipOZ;;AwExpOQ;EAOI,6FAAA;AxEqpOZ;;AwE5pOQ;EAOI,0BAAA;AxEypOZ;;AwEhqOQ;EAOI,8FAAA;AxE6pOZ;;AwEpqOQ;EAOI,2BAAA;AxEiqOZ;;AwExqOQ;EAOI,4FAAA;AxEqqOZ;;AwE5qOQ;EAOI,yBAAA;AxEyqOZ;;AwEhrOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxE8qOZ;;AwErrOQ;EAIQ,sBAAA;EAGJ,gFAAA;AxEmrOZ;;AwE1rOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEwrOZ;;AwE/rOQ;EAIQ,sBAAA;EAGJ,2EAAA;AxE6rOZ;;AwEpsOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEksOZ;;AwEzsOQ;EAIQ,sBAAA;EAGJ,6EAAA;AxEusOZ;;AwE9sOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxE4sOZ;;AwEntOQ;EAIQ,sBAAA;EAGJ,2EAAA;AxEitOZ;;AwExtOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEstOZ;;AwE7tOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxE2tOZ;;AwEluOQ;EAOI,wDAAA;AxE+tOZ;;AwEtuOQ;EAOI,0DAAA;AxEmuOZ;;AwE1uOQ;EAOI,wDAAA;AxEuuOZ;;AwE9uOQ;EAOI,qDAAA;AxE2uOZ;;AwElvOQ;EAOI,wDAAA;AxE+uOZ;;AwEtvOQ;EAOI,uDAAA;AxEmvOZ;;AwE1vOQ;EAOI,sDAAA;AxEuvOZ;;AwE9vOQ;EAOI,qDAAA;AxE2vOZ;;AwElwOQ;EAOI,4BAAA;AxE+vOZ;;AwEtwOQ;EAOI,4BAAA;AxEmwOZ;;AwE1wOQ;EAOI,4BAAA;AxEuwOZ;;AwE9wOQ;EAOI,4BAAA;AxE2wOZ;;AwElxOQ;EAOI,4BAAA;AxE+wOZ;;AwEhyOQ;EACE,wBAAA;AxEmyOV;;AwEpyOQ;EACE,yBAAA;AxEuyOV;;AwExyOQ;EACE,wBAAA;AxE2yOV;;AwE5yOQ;EACE,yBAAA;AxE+yOV;;AwEhzOQ;EACE,sBAAA;AxEmzOV;;AwE1yOQ;EAOI,qBAAA;AxEuyOZ;;AwE9yOQ;EAOI,qBAAA;AxE2yOZ;;AwElzOQ;EAOI,qBAAA;AxE+yOZ;;AwEtzOQ;EAOI,sBAAA;AxEmzOZ;;AwE1zOQ;EAOI,sBAAA;AxEuzOZ;;AwE9zOQ;EAOI,0BAAA;AxE2zOZ;;AwEl0OQ;EAOI,uBAAA;AxE+zOZ;;AwEt0OQ;EAOI,2BAAA;AxEm0OZ;;AwE10OQ;EAOI,sBAAA;AxEu0OZ;;AwE90OQ;EAOI,sBAAA;AxE20OZ;;AwEl1OQ;EAOI,sBAAA;AxE+0OZ;;AwEt1OQ;EAOI,uBAAA;AxEm1OZ;;AwE11OQ;EAOI,uBAAA;AxEu1OZ;;AwE91OQ;EAOI,2BAAA;AxE21OZ;;AwEl2OQ;EAOI,wBAAA;AxE+1OZ;;AwEt2OQ;EAOI,4BAAA;AxEm2OZ;;AwE12OQ;EAOI,yBAAA;AxEu2OZ;;AwE92OQ;EAOI,8BAAA;AxE22OZ;;AwEl3OQ;EAOI,iCAAA;AxE+2OZ;;AwEt3OQ;EAOI,sCAAA;AxEm3OZ;;AwE13OQ;EAOI,yCAAA;AxEu3OZ;;AwE93OQ;EAOI,uBAAA;AxE23OZ;;AwEl4OQ;EAOI,uBAAA;AxE+3OZ;;AwEt4OQ;EAOI,yBAAA;AxEm4OZ;;AwE14OQ;EAOI,yBAAA;AxEu4OZ;;AwE94OQ;EAOI,0BAAA;AxE24OZ;;AwEl5OQ;EAOI,4BAAA;AxE+4OZ;;AwEt5OQ;EAOI,kCAAA;AxEm5OZ;;AwE15OQ;EAOI,sCAAA;AxEu5OZ;;AwE95OQ;EAOI,oCAAA;AxE25OZ;;AwEl6OQ;EAOI,kCAAA;AxE+5OZ;;AwEt6OQ;EAOI,yCAAA;AxEm6OZ;;AwE16OQ;EAOI,wCAAA;AxEu6OZ;;AwE96OQ;EAOI,wCAAA;AxE26OZ;;AwEl7OQ;EAOI,kCAAA;AxE+6OZ;;AwEt7OQ;EAOI,gCAAA;AxEm7OZ;;AwE17OQ;EAOI,8BAAA;AxEu7OZ;;AwE97OQ;EAOI,gCAAA;AxE27OZ;;AwEl8OQ;EAOI,+BAAA;AxE+7OZ;;AwEt8OQ;EAOI,oCAAA;AxEm8OZ;;AwE18OQ;EAOI,kCAAA;AxEu8OZ;;AwE98OQ;EAOI,gCAAA;AxE28OZ;;AwEl9OQ;EAOI,uCAAA;AxE+8OZ;;AwEt9OQ;EAOI,sCAAA;AxEm9OZ;;AwE19OQ;EAOI,iCAAA;AxEu9OZ;;AwE99OQ;EAOI,2BAAA;AxE29OZ;;AwEl+OQ;EAOI,iCAAA;AxE+9OZ;;AwEt+OQ;EAOI,+BAAA;AxEm+OZ;;AwE1+OQ;EAOI,6BAAA;AxEu+OZ;;AwE9+OQ;EAOI,+BAAA;AxE2+OZ;;AwEl/OQ;EAOI,8BAAA;AxE++OZ;;AwEt/OQ;EAOI,oBAAA;AxEm/OZ;;AwE1/OQ;EAOI,mBAAA;AxEu/OZ;;AwE9/OQ;EAOI,mBAAA;AxE2/OZ;;AwElgPQ;EAOI,mBAAA;AxE+/OZ;;AwEtgPQ;EAOI,mBAAA;AxEmgPZ;;AwE1gPQ;EAOI,mBAAA;AxEugPZ;;AwE9gPQ;EAOI,mBAAA;AxE2gPZ;;AwElhPQ;EAOI,mBAAA;AxE+gPZ;;AwEthPQ;EAOI,oBAAA;AxEmhPZ;;AwE1hPQ;EAOI,0BAAA;AxEuhPZ;;AwE9hPQ;EAOI,yBAAA;AxE2hPZ;;AwEliPQ;EAOI,uBAAA;AxE+hPZ;;AwEtiPQ;EAOI,yBAAA;AxEmiPZ;;AwE1iPQ;EAOI,uBAAA;AxEuiPZ;;AwE9iPQ;EAOI,uBAAA;AxE2iPZ;;AwEljPQ;EAOI,0BAAA;EAAA,yBAAA;AxEgjPZ;;AwEvjPQ;EAOI,gCAAA;EAAA,+BAAA;AxEqjPZ;;AwE5jPQ;EAOI,+BAAA;EAAA,8BAAA;AxE0jPZ;;AwEjkPQ;EAOI,6BAAA;EAAA,4BAAA;AxE+jPZ;;AwEtkPQ;EAOI,+BAAA;EAAA,8BAAA;AxEokPZ;;AwE3kPQ;EAOI,6BAAA;EAAA,4BAAA;AxEykPZ;;AwEhlPQ;EAOI,6BAAA;EAAA,4BAAA;AxE8kPZ;;AwErlPQ;EAOI,wBAAA;EAAA,2BAAA;AxEmlPZ;;AwE1lPQ;EAOI,8BAAA;EAAA,iCAAA;AxEwlPZ;;AwE/lPQ;EAOI,6BAAA;EAAA,gCAAA;AxE6lPZ;;AwEpmPQ;EAOI,2BAAA;EAAA,8BAAA;AxEkmPZ;;AwEzmPQ;EAOI,6BAAA;EAAA,gCAAA;AxEumPZ;;AwE9mPQ;EAOI,2BAAA;EAAA,8BAAA;AxE4mPZ;;AwEnnPQ;EAOI,2BAAA;EAAA,8BAAA;AxEinPZ;;AwExnPQ;EAOI,wBAAA;AxEqnPZ;;AwE5nPQ;EAOI,8BAAA;AxEynPZ;;AwEhoPQ;EAOI,6BAAA;AxE6nPZ;;AwEpoPQ;EAOI,2BAAA;AxEioPZ;;AwExoPQ;EAOI,6BAAA;AxEqoPZ;;AwE5oPQ;EAOI,2BAAA;AxEyoPZ;;AwEhpPQ;EAOI,2BAAA;AxE6oPZ;;AwEppPQ;EAOI,0BAAA;AxEipPZ;;AwExpPQ;EAOI,gCAAA;AxEqpPZ;;AwE5pPQ;EAOI,+BAAA;AxEypPZ;;AwEhqPQ;EAOI,6BAAA;AxE6pPZ;;AwEpqPQ;EAOI,+BAAA;AxEiqPZ;;AwExqPQ;EAOI,6BAAA;AxEqqPZ;;AwE5qPQ;EAOI,6BAAA;AxEyqPZ;;AwEhrPQ;EAOI,2BAAA;AxE6qPZ;;AwEprPQ;EAOI,iCAAA;AxEirPZ;;AwExrPQ;EAOI,gCAAA;AxEqrPZ;;AwE5rPQ;EAOI,8BAAA;AxEyrPZ;;AwEhsPQ;EAOI,gCAAA;AxE6rPZ;;AwEpsPQ;EAOI,8BAAA;AxEisPZ;;AwExsPQ;EAOI,8BAAA;AxEqsPZ;;AwE5sPQ;EAOI,yBAAA;AxEysPZ;;AwEhtPQ;EAOI,+BAAA;AxE6sPZ;;AwEptPQ;EAOI,8BAAA;AxEitPZ;;AwExtPQ;EAOI,4BAAA;AxEqtPZ;;AwE5tPQ;EAOI,8BAAA;AxEytPZ;;AwEhuPQ;EAOI,4BAAA;AxE6tPZ;;AwEpuPQ;EAOI,4BAAA;AxEiuPZ;;AwExuPQ;EAOI,qBAAA;AxEquPZ;;AwE5uPQ;EAOI,2BAAA;AxEyuPZ;;AwEhvPQ;EAOI,0BAAA;AxE6uPZ;;AwEpvPQ;EAOI,wBAAA;AxEivPZ;;AwExvPQ;EAOI,0BAAA;AxEqvPZ;;AwE5vPQ;EAOI,wBAAA;AxEyvPZ;;AwEhwPQ;EAOI,2BAAA;EAAA,0BAAA;AxE8vPZ;;AwErwPQ;EAOI,iCAAA;EAAA,gCAAA;AxEmwPZ;;AwE1wPQ;EAOI,gCAAA;EAAA,+BAAA;AxEwwPZ;;AwE/wPQ;EAOI,8BAAA;EAAA,6BAAA;AxE6wPZ;;AwEpxPQ;EAOI,gCAAA;EAAA,+BAAA;AxEkxPZ;;AwEzxPQ;EAOI,8BAAA;EAAA,6BAAA;AxEuxPZ;;AwE9xPQ;EAOI,yBAAA;EAAA,4BAAA;AxE4xPZ;;AwEnyPQ;EAOI,+BAAA;EAAA,kCAAA;AxEiyPZ;;AwExyPQ;EAOI,8BAAA;EAAA,iCAAA;AxEsyPZ;;AwE7yPQ;EAOI,4BAAA;EAAA,+BAAA;AxE2yPZ;;AwElzPQ;EAOI,8BAAA;EAAA,iCAAA;AxEgzPZ;;AwEvzPQ;EAOI,4BAAA;EAAA,+BAAA;AxEqzPZ;;AwE5zPQ;EAOI,yBAAA;AxEyzPZ;;AwEh0PQ;EAOI,+BAAA;AxE6zPZ;;AwEp0PQ;EAOI,8BAAA;AxEi0PZ;;AwEx0PQ;EAOI,4BAAA;AxEq0PZ;;AwE50PQ;EAOI,8BAAA;AxEy0PZ;;AwEh1PQ;EAOI,4BAAA;AxE60PZ;;AwEp1PQ;EAOI,2BAAA;AxEi1PZ;;AwEx1PQ;EAOI,iCAAA;AxEq1PZ;;AwE51PQ;EAOI,gCAAA;AxEy1PZ;;AwEh2PQ;EAOI,8BAAA;AxE61PZ;;AwEp2PQ;EAOI,gCAAA;AxEi2PZ;;AwEx2PQ;EAOI,8BAAA;AxEq2PZ;;AwE52PQ;EAOI,4BAAA;AxEy2PZ;;AwEh3PQ;EAOI,kCAAA;AxE62PZ;;AwEp3PQ;EAOI,iCAAA;AxEi3PZ;;AwEx3PQ;EAOI,+BAAA;AxEq3PZ;;AwE53PQ;EAOI,iCAAA;AxEy3PZ;;AwEh4PQ;EAOI,+BAAA;AxE63PZ;;AwEp4PQ;EAOI,0BAAA;AxEi4PZ;;AwEx4PQ;EAOI,gCAAA;AxEq4PZ;;AwE54PQ;EAOI,+BAAA;AxEy4PZ;;AwEh5PQ;EAOI,6BAAA;AxE64PZ;;AwEp5PQ;EAOI,+BAAA;AxEi5PZ;;AwEx5PQ;EAOI,6BAAA;AxEq5PZ;;AwE55PQ;EAOI,iBAAA;AxEy5PZ;;AwEh6PQ;EAOI,uBAAA;AxE65PZ;;AwEp6PQ;EAOI,sBAAA;AxEi6PZ;;AwEx6PQ;EAOI,oBAAA;AxEq6PZ;;AwE56PQ;EAOI,sBAAA;AxEy6PZ;;AwEh7PQ;EAOI,oBAAA;AxE66PZ;;AwEp7PQ;EAOI,qBAAA;AxEi7PZ;;AwEx7PQ;EAOI,2BAAA;AxEq7PZ;;AwE57PQ;EAOI,0BAAA;AxEy7PZ;;AwEh8PQ;EAOI,wBAAA;AxE67PZ;;AwEp8PQ;EAOI,0BAAA;AxEi8PZ;;AwEx8PQ;EAOI,wBAAA;AxEq8PZ;;AwE58PQ;EAOI,wBAAA;AxEy8PZ;;AwEh9PQ;EAOI,8BAAA;AxE68PZ;;AwEp9PQ;EAOI,6BAAA;AxEi9PZ;;AwEx9PQ;EAOI,2BAAA;AxEq9PZ;;AwE59PQ;EAOI,6BAAA;AxEy9PZ;;AwEh+PQ;EAOI,2BAAA;AxE69PZ;;AwEp+PQ;EAOI,gDAAA;AxEi+PZ;;AwEx+PQ;EAOI,4CAAA;AxEq+PZ;;AwE5+PQ;EAOI,4CAAA;AxEy+PZ;;AwEh/PQ;EAOI,0CAAA;AxE6+PZ;;AwEp/PQ;EAOI,4CAAA;AxEi/PZ;;AwEx/PQ;EAOI,6BAAA;AxEq/PZ;;AwE5/PQ;EAOI,0BAAA;AxEy/PZ;;AwEhgQQ;EAOI,6BAAA;AxE6/PZ;;AwEpgQQ;EAOI,6BAAA;AxEigQZ;;AwExgQQ;EAOI,+BAAA;AxEqgQZ;;AwE5gQQ;EAOI,2BAAA;AxEygQZ;;AwEhhQQ;EAOI,2BAAA;AxE6gQZ;;AwEphQQ;EAOI,2BAAA;AxEihQZ;;AwExhQQ;EAOI,2BAAA;AxEqhQZ;;AwE5hQQ;EAOI,2BAAA;AxEyhQZ;;AwEhiQQ;EAOI,8BAAA;AxE6hQZ;;AwEpiQQ;EAOI,yBAAA;AxEiiQZ;;AwExiQQ;EAOI,4BAAA;AxEqiQZ;;AwE5iQQ;EAOI,2BAAA;AxEyiQZ;;AwEhjQQ;EAOI,yBAAA;AxE6iQZ;;AwEpjQQ;EAOI,2BAAA;AxEijQZ;;AwExjQQ;EAOI,4BAAA;AxEqjQZ;;AwE5jQQ;EAOI,6BAAA;AxEyjQZ;;AwEhkQQ;EAOI,gCAAA;AxE6jQZ;;AwEpkQQ;EAOI,qCAAA;AxEikQZ;;AwExkQQ;EAOI,wCAAA;AxEqkQZ;;AwE5kQQ;EAOI,oCAAA;AxEykQZ;;AwEhlQQ;EAOI,oCAAA;AxE6kQZ;;AwEplQQ;EAOI,qCAAA;AxEilQZ;;AwExlQQ;EAOI,8BAAA;AxEqlQZ;;AwE5lQQ;EAOI,8BAAA;AxEylQZ;;AwE9mQQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxE+lQZ;;AwE5kQQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AxEqmQZ;;AwE5mQQ;EAIQ,oBAAA;EAGJ,uEAAA;AxE0mQZ;;AwEjnQQ;EAIQ,oBAAA;EAGJ,qEAAA;AxE+mQZ;;AwEtnQQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEonQZ;;AwE3nQQ;EAIQ,oBAAA;EAGJ,qEAAA;AxEynQZ;;AwEhoQQ;EAIQ,oBAAA;EAGJ,oEAAA;AxE8nQZ;;AwEroQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEmoQZ;;AwE1oQQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEwoQZ;;AwE/oQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxE6oQZ;;AwEppQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEkpQZ;;AwEzpQQ;EAIQ,oBAAA;EAGJ,wEAAA;AxEupQZ;;AwE9pQQ;EAIQ,oBAAA;EAGJ,2CAAA;AxE4pQZ;;AwEnqQQ;EAIQ,oBAAA;EAGJ,oCAAA;AxEiqQZ;;AwExqQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEsqQZ;;AwE7qQQ;EAIQ,oBAAA;EAGJ,2CAAA;AxE2qQZ;;AwElrQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEgrQZ;;AwEvrQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEqrQZ;;AwE5rQQ;EAIQ,oBAAA;EAGJ,yBAAA;AxE0rQZ;;AwE3sQQ;EACE,uBAAA;AxE8sQV;;AwE/sQQ;EACE,sBAAA;AxEktQV;;AwEntQQ;EACE,uBAAA;AxEstQV;;AwEvtQQ;EACE,oBAAA;AxE0tQV;;AwEjtQQ;EAOI,iDAAA;AxE8sQZ;;AwErtQQ;EAOI,mDAAA;AxEktQZ;;AwEztQQ;EAOI,iDAAA;AxEstQZ;;AwE7tQQ;EAOI,8CAAA;AxE0tQZ;;AwEjuQQ;EAOI,iDAAA;AxE8tQZ;;AwEruQQ;EAOI,gDAAA;AxEkuQZ;;AwEzuQQ;EAOI,+CAAA;AxEsuQZ;;AwE7uQQ;EAOI,8CAAA;AxE0uQZ;;AwE3vQQ;EACE,sBAAA;AxE8vQV;;AwE1vQU;EACE,sBAAA;AxE6vQZ;;AwEnwQQ;EACE,uBAAA;AxEswQV;;AwElwQU;EACE,uBAAA;AxEqwQZ;;AwE3wQQ;EACE,sBAAA;AxE8wQV;;AwE1wQU;EACE,sBAAA;AxE6wQZ;;AwEnxQQ;EACE,uBAAA;AxEsxQV;;AwElxQU;EACE,uBAAA;AxEqxQZ;;AwE3xQQ;EACE,oBAAA;AxE8xQV;;AwE1xQU;EACE,oBAAA;AxE6xQZ;;AwEzxQQ;EAOI,yCAAA;AxEsxQZ;;AwEjxQU;EAOI,yCAAA;AxE8wQd;;AwEjyQQ;EAOI,wCAAA;AxE8xQZ;;AwEzxQU;EAOI,wCAAA;AxEsxQd;;AwEzyQQ;EAOI,yCAAA;AxEsyQZ;;AwEjyQU;EAOI,yCAAA;AxE8xQd;;AwEjzQQ;EAIQ,8BAAA;EAGJ,+FAAA;AxE+yQZ;;AwEtzQQ;EAIQ,8BAAA;EAGJ,iGAAA;AxEozQZ;;AwE3zQQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEyzQZ;;AwEh0QQ;EAIQ,8BAAA;EAGJ,4FAAA;AxE8zQZ;;AwEr0QQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEm0QZ;;AwE10QQ;EAIQ,8BAAA;EAGJ,8FAAA;AxEw0QZ;;AwE/0QQ;EAIQ,8BAAA;EAGJ,6FAAA;AxE60QZ;;AwEp1QQ;EAIQ,8BAAA;EAGJ,4FAAA;AxEk1QZ;;AwEz1QQ;EAIQ,8BAAA;EAGJ,qGAAA;AxEu1QZ;;AwEx2QQ;EACE,8BAAA;AxE22QV;;AwEv2QU;EACE,8BAAA;AxE02QZ;;AwEh3QQ;EACE,gCAAA;AxEm3QV;;AwE/2QU;EACE,gCAAA;AxEk3QZ;;AwEx3QQ;EACE,iCAAA;AxE23QV;;AwEv3QU;EACE,iCAAA;AxE03QZ;;AwEh4QQ;EACE,gCAAA;AxEm4QV;;AwE/3QU;EACE,gCAAA;AxEk4QZ;;AwEx4QQ;EACE,iCAAA;AxE24QV;;AwEv4QU;EACE,iCAAA;AxE04QZ;;AwEh5QQ;EACE,8BAAA;AxEm5QV;;AwE/4QU;EACE,8BAAA;AxEk5QZ;;AwE94QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE44QZ;;AwEn5QQ;EAIQ,kBAAA;EAGJ,gFAAA;AxEi5QZ;;AwEx5QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEs5QZ;;AwE75QQ;EAIQ,kBAAA;EAGJ,2EAAA;AxE25QZ;;AwEl6QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEg6QZ;;AwEv6QQ;EAIQ,kBAAA;EAGJ,6EAAA;AxEq6QZ;;AwE56QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxE06QZ;;AwEj7QQ;EAIQ,kBAAA;EAGJ,2EAAA;AxE+6QZ;;AwEt7QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEo7QZ;;AwE37QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEy7QZ;;AwEh8QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE87QZ;;AwEr8QQ;EAIQ,kBAAA;EAGJ,wCAAA;AxEm8QZ;;AwE18QQ;EAIQ,kBAAA;EAGJ,mFAAA;AxEw8QZ;;AwE/8QQ;EAIQ,kBAAA;EAGJ,kFAAA;AxE68QZ;;AwE99QQ;EACE,oBAAA;AxEi+QV;;AwEl+QQ;EACE,qBAAA;AxEq+QV;;AwEt+QQ;EACE,oBAAA;AxEy+QV;;AwE1+QQ;EACE,qBAAA;AxE6+QV;;AwE9+QQ;EACE,kBAAA;AxEi/QV;;AwEx+QQ;EAOI,wDAAA;AxEq+QZ;;AwE5+QQ;EAOI,0DAAA;AxEy+QZ;;AwEh/QQ;EAOI,wDAAA;AxE6+QZ;;AwEp/QQ;EAOI,qDAAA;AxEi/QZ;;AwEx/QQ;EAOI,wDAAA;AxEq/QZ;;AwE5/QQ;EAOI,uDAAA;AxEy/QZ;;AwEhgRQ;EAOI,sDAAA;AxE6/QZ;;AwEpgRQ;EAOI,qDAAA;AxEigRZ;;AwExgRQ;EAOI,+CAAA;AxEqgRZ;;AwE5gRQ;EAOI,mCAAA;UAAA,2BAAA;AxEygRZ;;AwEhhRQ;EAOI,oCAAA;UAAA,4BAAA;AxE6gRZ;;AwEphRQ;EAOI,oCAAA;UAAA,4BAAA;AxEihRZ;;AwExhRQ;EAOI,+BAAA;AxEqhRZ;;AwE5hRQ;EAOI,+BAAA;AxEyhRZ;;AwEhiRQ;EAOI,iDAAA;AxE6hRZ;;AwEpiRQ;EAOI,2BAAA;AxEiiRZ;;AwExiRQ;EAOI,oDAAA;AxEqiRZ;;AwE5iRQ;EAOI,iDAAA;AxEyiRZ;;AwEhjRQ;EAOI,oDAAA;AxE6iRZ;;AwEpjRQ;EAOI,oDAAA;AxEijRZ;;AwExjRQ;EAOI,qDAAA;AxEqjRZ;;AwE5jRQ;EAOI,6BAAA;AxEyjRZ;;AwEhkRQ;EAOI,sDAAA;AxE6jRZ;;AwEpkRQ;EAOI,0DAAA;EAAA,2DAAA;AxEkkRZ;;AwEzkRQ;EAOI,oCAAA;EAAA,qCAAA;AxEukRZ;;AwE9kRQ;EAOI,6DAAA;EAAA,8DAAA;AxE4kRZ;;AwEnlRQ;EAOI,0DAAA;EAAA,2DAAA;AxEilRZ;;AwExlRQ;EAOI,6DAAA;EAAA,8DAAA;AxEslRZ;;AwE7lRQ;EAOI,6DAAA;EAAA,8DAAA;AxE2lRZ;;AwElmRQ;EAOI,8DAAA;EAAA,+DAAA;AxEgmRZ;;AwEvmRQ;EAOI,sCAAA;EAAA,uCAAA;AxEqmRZ;;AwE5mRQ;EAOI,+DAAA;EAAA,gEAAA;AxE0mRZ;;AwEjnRQ;EAOI,2DAAA;EAAA,8DAAA;AxE+mRZ;;AwEtnRQ;EAOI,qCAAA;EAAA,wCAAA;AxEonRZ;;AwE3nRQ;EAOI,8DAAA;EAAA,iEAAA;AxEynRZ;;AwEhoRQ;EAOI,2DAAA;EAAA,8DAAA;AxE8nRZ;;AwEroRQ;EAOI,8DAAA;EAAA,iEAAA;AxEmoRZ;;AwE1oRQ;EAOI,8DAAA;EAAA,iEAAA;AxEwoRZ;;AwE/oRQ;EAOI,+DAAA;EAAA,kEAAA;AxE6oRZ;;AwEppRQ;EAOI,uCAAA;EAAA,0CAAA;AxEkpRZ;;AwEzpRQ;EAOI,gEAAA;EAAA,mEAAA;AxEupRZ;;AwE9pRQ;EAOI,8DAAA;EAAA,6DAAA;AxE4pRZ;;AwEnqRQ;EAOI,wCAAA;EAAA,uCAAA;AxEiqRZ;;AwExqRQ;EAOI,iEAAA;EAAA,gEAAA;AxEsqRZ;;AwE7qRQ;EAOI,8DAAA;EAAA,6DAAA;AxE2qRZ;;AwElrRQ;EAOI,iEAAA;EAAA,gEAAA;AxEgrRZ;;AwEvrRQ;EAOI,iEAAA;EAAA,gEAAA;AxEqrRZ;;AwE5rRQ;EAOI,kEAAA;EAAA,iEAAA;AxE0rRZ;;AwEjsRQ;EAOI,0CAAA;EAAA,yCAAA;AxE+rRZ;;AwEtsRQ;EAOI,mEAAA;EAAA,kEAAA;AxEosRZ;;AwE3sRQ;EAOI,6DAAA;EAAA,0DAAA;AxEysRZ;;AwEhtRQ;EAOI,uCAAA;EAAA,oCAAA;AxE8sRZ;;AwErtRQ;EAOI,gEAAA;EAAA,6DAAA;AxEmtRZ;;AwE1tRQ;EAOI,6DAAA;EAAA,0DAAA;AxEwtRZ;;AwE/tRQ;EAOI,gEAAA;EAAA,6DAAA;AxE6tRZ;;AwEpuRQ;EAOI,gEAAA;EAAA,6DAAA;AxEkuRZ;;AwEzuRQ;EAOI,iEAAA;EAAA,8DAAA;AxEuuRZ;;AwE9uRQ;EAOI,yCAAA;EAAA,sCAAA;AxE4uRZ;;AwEnvRQ;EAOI,kEAAA;EAAA,+DAAA;AxEivRZ;;AwExvRQ;EAOI,8BAAA;AxEqvRZ;;AwE5vRQ;EAOI,6BAAA;AxEyvRZ;;AwEhwRQ;EAOI,sBAAA;AxE6vRZ;;AwEpwRQ;EAOI,qBAAA;AxEiwRZ;;AwExwRQ;EAOI,qBAAA;AxEqwRZ;;AwE5wRQ;EAOI,qBAAA;AxEywRZ;;AwEhxRQ;EAOI,qBAAA;AxE6wRZ;;AcvxRI;E0DGI;IAOI,sBAAA;ExEkxRV;EwEzxRM;IAOI,uBAAA;ExEqxRV;EwE5xRM;IAOI,sBAAA;ExEwxRV;EwE/xRM;IAOI,8BAAA;ExE2xRV;EwElyRM;IAOI,4BAAA;ExE8xRV;EwEryRM;IAOI,2BAAA;ExEiyRV;EwExyRM;IAOI,iCAAA;ExEoyRV;EwE3yRM;IAOI,2BAAA;ExEuyRV;EwE9yRM;IAOI,0BAAA;ExE0yRV;EwEjzRM;IAOI,gCAAA;ExE6yRV;EwEpzRM;IAOI,yBAAA;ExEgzRV;EwEvzRM;IAOI,wBAAA;ExEmzRV;EwE1zRM;IAOI,+BAAA;ExEszRV;EwE7zRM;IAOI,yBAAA;ExEyzRV;EwEh0RM;IAOI,6BAAA;ExE4zRV;EwEn0RM;IAOI,8BAAA;ExE+zRV;EwEt0RM;IAOI,wBAAA;ExEk0RV;EwEz0RM;IAOI,+BAAA;ExEq0RV;EwE50RM;IAOI,wBAAA;ExEw0RV;EwE/0RM;IAOI,yBAAA;ExE20RV;EwEl1RM;IAOI,8BAAA;ExE80RV;EwEr1RM;IAOI,iCAAA;ExEi1RV;EwEx1RM;IAOI,sCAAA;ExEo1RV;EwE31RM;IAOI,yCAAA;ExEu1RV;EwE91RM;IAOI,uBAAA;ExE01RV;EwEj2RM;IAOI,uBAAA;ExE61RV;EwEp2RM;IAOI,yBAAA;ExEg2RV;EwEv2RM;IAOI,yBAAA;ExEm2RV;EwE12RM;IAOI,0BAAA;ExEs2RV;EwE72RM;IAOI,4BAAA;ExEy2RV;EwEh3RM;IAOI,kCAAA;ExE42RV;EwEn3RM;IAOI,sCAAA;ExE+2RV;EwEt3RM;IAOI,oCAAA;ExEk3RV;EwEz3RM;IAOI,kCAAA;ExEq3RV;EwE53RM;IAOI,yCAAA;ExEw3RV;EwE/3RM;IAOI,wCAAA;ExE23RV;EwEl4RM;IAOI,wCAAA;ExE83RV;EwEr4RM;IAOI,kCAAA;ExEi4RV;EwEx4RM;IAOI,gCAAA;ExEo4RV;EwE34RM;IAOI,8BAAA;ExEu4RV;EwE94RM;IAOI,gCAAA;ExE04RV;EwEj5RM;IAOI,+BAAA;ExE64RV;EwEp5RM;IAOI,oCAAA;ExEg5RV;EwEv5RM;IAOI,kCAAA;ExEm5RV;EwE15RM;IAOI,gCAAA;ExEs5RV;EwE75RM;IAOI,uCAAA;ExEy5RV;EwEh6RM;IAOI,sCAAA;ExE45RV;EwEn6RM;IAOI,iCAAA;ExE+5RV;EwEt6RM;IAOI,2BAAA;ExEk6RV;EwEz6RM;IAOI,iCAAA;ExEq6RV;EwE56RM;IAOI,+BAAA;ExEw6RV;EwE/6RM;IAOI,6BAAA;ExE26RV;EwEl7RM;IAOI,+BAAA;ExE86RV;EwEr7RM;IAOI,8BAAA;ExEi7RV;EwEx7RM;IAOI,oBAAA;ExEo7RV;EwE37RM;IAOI,mBAAA;ExEu7RV;EwE97RM;IAOI,mBAAA;ExE07RV;EwEj8RM;IAOI,mBAAA;ExE67RV;EwEp8RM;IAOI,mBAAA;ExEg8RV;EwEv8RM;IAOI,mBAAA;ExEm8RV;EwE18RM;IAOI,mBAAA;ExEs8RV;EwE78RM;IAOI,mBAAA;ExEy8RV;EwEh9RM;IAOI,oBAAA;ExE48RV;EwEn9RM;IAOI,0BAAA;ExE+8RV;EwEt9RM;IAOI,yBAAA;ExEk9RV;EwEz9RM;IAOI,uBAAA;ExEq9RV;EwE59RM;IAOI,yBAAA;ExEw9RV;EwE/9RM;IAOI,uBAAA;ExE29RV;EwEl+RM;IAOI,uBAAA;ExE89RV;EwEr+RM;IAOI,0BAAA;IAAA,yBAAA;ExEk+RV;EwEz+RM;IAOI,gCAAA;IAAA,+BAAA;ExEs+RV;EwE7+RM;IAOI,+BAAA;IAAA,8BAAA;ExE0+RV;EwEj/RM;IAOI,6BAAA;IAAA,4BAAA;ExE8+RV;EwEr/RM;IAOI,+BAAA;IAAA,8BAAA;ExEk/RV;EwEz/RM;IAOI,6BAAA;IAAA,4BAAA;ExEs/RV;EwE7/RM;IAOI,6BAAA;IAAA,4BAAA;ExE0/RV;EwEjgSM;IAOI,wBAAA;IAAA,2BAAA;ExE8/RV;EwErgSM;IAOI,8BAAA;IAAA,iCAAA;ExEkgSV;EwEzgSM;IAOI,6BAAA;IAAA,gCAAA;ExEsgSV;EwE7gSM;IAOI,2BAAA;IAAA,8BAAA;ExE0gSV;EwEjhSM;IAOI,6BAAA;IAAA,gCAAA;ExE8gSV;EwErhSM;IAOI,2BAAA;IAAA,8BAAA;ExEkhSV;EwEzhSM;IAOI,2BAAA;IAAA,8BAAA;ExEshSV;EwE7hSM;IAOI,wBAAA;ExEyhSV;EwEhiSM;IAOI,8BAAA;ExE4hSV;EwEniSM;IAOI,6BAAA;ExE+hSV;EwEtiSM;IAOI,2BAAA;ExEkiSV;EwEziSM;IAOI,6BAAA;ExEqiSV;EwE5iSM;IAOI,2BAAA;ExEwiSV;EwE/iSM;IAOI,2BAAA;ExE2iSV;EwEljSM;IAOI,0BAAA;ExE8iSV;EwErjSM;IAOI,gCAAA;ExEijSV;EwExjSM;IAOI,+BAAA;ExEojSV;EwE3jSM;IAOI,6BAAA;ExEujSV;EwE9jSM;IAOI,+BAAA;ExE0jSV;EwEjkSM;IAOI,6BAAA;ExE6jSV;EwEpkSM;IAOI,6BAAA;ExEgkSV;EwEvkSM;IAOI,2BAAA;ExEmkSV;EwE1kSM;IAOI,iCAAA;ExEskSV;EwE7kSM;IAOI,gCAAA;ExEykSV;EwEhlSM;IAOI,8BAAA;ExE4kSV;EwEnlSM;IAOI,gCAAA;ExE+kSV;EwEtlSM;IAOI,8BAAA;ExEklSV;EwEzlSM;IAOI,8BAAA;ExEqlSV;EwE5lSM;IAOI,yBAAA;ExEwlSV;EwE/lSM;IAOI,+BAAA;ExE2lSV;EwElmSM;IAOI,8BAAA;ExE8lSV;EwErmSM;IAOI,4BAAA;ExEimSV;EwExmSM;IAOI,8BAAA;ExEomSV;EwE3mSM;IAOI,4BAAA;ExEumSV;EwE9mSM;IAOI,4BAAA;ExE0mSV;EwEjnSM;IAOI,qBAAA;ExE6mSV;EwEpnSM;IAOI,2BAAA;ExEgnSV;EwEvnSM;IAOI,0BAAA;ExEmnSV;EwE1nSM;IAOI,wBAAA;ExEsnSV;EwE7nSM;IAOI,0BAAA;ExEynSV;EwEhoSM;IAOI,wBAAA;ExE4nSV;EwEnoSM;IAOI,2BAAA;IAAA,0BAAA;ExEgoSV;EwEvoSM;IAOI,iCAAA;IAAA,gCAAA;ExEooSV;EwE3oSM;IAOI,gCAAA;IAAA,+BAAA;ExEwoSV;EwE/oSM;IAOI,8BAAA;IAAA,6BAAA;ExE4oSV;EwEnpSM;IAOI,gCAAA;IAAA,+BAAA;ExEgpSV;EwEvpSM;IAOI,8BAAA;IAAA,6BAAA;ExEopSV;EwE3pSM;IAOI,yBAAA;IAAA,4BAAA;ExEwpSV;EwE/pSM;IAOI,+BAAA;IAAA,kCAAA;ExE4pSV;EwEnqSM;IAOI,8BAAA;IAAA,iCAAA;ExEgqSV;EwEvqSM;IAOI,4BAAA;IAAA,+BAAA;ExEoqSV;EwE3qSM;IAOI,8BAAA;IAAA,iCAAA;ExEwqSV;EwE/qSM;IAOI,4BAAA;IAAA,+BAAA;ExE4qSV;EwEnrSM;IAOI,yBAAA;ExE+qSV;EwEtrSM;IAOI,+BAAA;ExEkrSV;EwEzrSM;IAOI,8BAAA;ExEqrSV;EwE5rSM;IAOI,4BAAA;ExEwrSV;EwE/rSM;IAOI,8BAAA;ExE2rSV;EwElsSM;IAOI,4BAAA;ExE8rSV;EwErsSM;IAOI,2BAAA;ExEisSV;EwExsSM;IAOI,iCAAA;ExEosSV;EwE3sSM;IAOI,gCAAA;ExEusSV;EwE9sSM;IAOI,8BAAA;ExE0sSV;EwEjtSM;IAOI,gCAAA;ExE6sSV;EwEptSM;IAOI,8BAAA;ExEgtSV;EwEvtSM;IAOI,4BAAA;ExEmtSV;EwE1tSM;IAOI,kCAAA;ExEstSV;EwE7tSM;IAOI,iCAAA;ExEytSV;EwEhuSM;IAOI,+BAAA;ExE4tSV;EwEnuSM;IAOI,iCAAA;ExE+tSV;EwEtuSM;IAOI,+BAAA;ExEkuSV;EwEzuSM;IAOI,0BAAA;ExEquSV;EwE5uSM;IAOI,gCAAA;ExEwuSV;EwE/uSM;IAOI,+BAAA;ExE2uSV;EwElvSM;IAOI,6BAAA;ExE8uSV;EwErvSM;IAOI,+BAAA;ExEivSV;EwExvSM;IAOI,6BAAA;ExEovSV;EwE3vSM;IAOI,iBAAA;ExEuvSV;EwE9vSM;IAOI,uBAAA;ExE0vSV;EwEjwSM;IAOI,sBAAA;ExE6vSV;EwEpwSM;IAOI,oBAAA;ExEgwSV;EwEvwSM;IAOI,sBAAA;ExEmwSV;EwE1wSM;IAOI,oBAAA;ExEswSV;EwE7wSM;IAOI,qBAAA;ExEywSV;EwEhxSM;IAOI,2BAAA;ExE4wSV;EwEnxSM;IAOI,0BAAA;ExE+wSV;EwEtxSM;IAOI,wBAAA;ExEkxSV;EwEzxSM;IAOI,0BAAA;ExEqxSV;EwE5xSM;IAOI,wBAAA;ExEwxSV;EwE/xSM;IAOI,wBAAA;ExE2xSV;EwElySM;IAOI,8BAAA;ExE8xSV;EwErySM;IAOI,6BAAA;ExEiySV;EwExySM;IAOI,2BAAA;ExEoySV;EwE3ySM;IAOI,6BAAA;ExEuySV;EwE9ySM;IAOI,2BAAA;ExE0ySV;EwEjzSM;IAOI,2BAAA;ExE6ySV;EwEpzSM;IAOI,4BAAA;ExEgzSV;EwEvzSM;IAOI,6BAAA;ExEmzSV;AACF;Ac9zSI;E0DGI;IAOI,sBAAA;ExEwzSV;EwE/zSM;IAOI,uBAAA;ExE2zSV;EwEl0SM;IAOI,sBAAA;ExE8zSV;EwEr0SM;IAOI,8BAAA;ExEi0SV;EwEx0SM;IAOI,4BAAA;ExEo0SV;EwE30SM;IAOI,2BAAA;ExEu0SV;EwE90SM;IAOI,iCAAA;ExE00SV;EwEj1SM;IAOI,2BAAA;ExE60SV;EwEp1SM;IAOI,0BAAA;ExEg1SV;EwEv1SM;IAOI,gCAAA;ExEm1SV;EwE11SM;IAOI,yBAAA;ExEs1SV;EwE71SM;IAOI,wBAAA;ExEy1SV;EwEh2SM;IAOI,+BAAA;ExE41SV;EwEn2SM;IAOI,yBAAA;ExE+1SV;EwEt2SM;IAOI,6BAAA;ExEk2SV;EwEz2SM;IAOI,8BAAA;ExEq2SV;EwE52SM;IAOI,wBAAA;ExEw2SV;EwE/2SM;IAOI,+BAAA;ExE22SV;EwEl3SM;IAOI,wBAAA;ExE82SV;EwEr3SM;IAOI,yBAAA;ExEi3SV;EwEx3SM;IAOI,8BAAA;ExEo3SV;EwE33SM;IAOI,iCAAA;ExEu3SV;EwE93SM;IAOI,sCAAA;ExE03SV;EwEj4SM;IAOI,yCAAA;ExE63SV;EwEp4SM;IAOI,uBAAA;ExEg4SV;EwEv4SM;IAOI,uBAAA;ExEm4SV;EwE14SM;IAOI,yBAAA;ExEs4SV;EwE74SM;IAOI,yBAAA;ExEy4SV;EwEh5SM;IAOI,0BAAA;ExE44SV;EwEn5SM;IAOI,4BAAA;ExE+4SV;EwEt5SM;IAOI,kCAAA;ExEk5SV;EwEz5SM;IAOI,sCAAA;ExEq5SV;EwE55SM;IAOI,oCAAA;ExEw5SV;EwE/5SM;IAOI,kCAAA;ExE25SV;EwEl6SM;IAOI,yCAAA;ExE85SV;EwEr6SM;IAOI,wCAAA;ExEi6SV;EwEx6SM;IAOI,wCAAA;ExEo6SV;EwE36SM;IAOI,kCAAA;ExEu6SV;EwE96SM;IAOI,gCAAA;ExE06SV;EwEj7SM;IAOI,8BAAA;ExE66SV;EwEp7SM;IAOI,gCAAA;ExEg7SV;EwEv7SM;IAOI,+BAAA;ExEm7SV;EwE17SM;IAOI,oCAAA;ExEs7SV;EwE77SM;IAOI,kCAAA;ExEy7SV;EwEh8SM;IAOI,gCAAA;ExE47SV;EwEn8SM;IAOI,uCAAA;ExE+7SV;EwEt8SM;IAOI,sCAAA;ExEk8SV;EwEz8SM;IAOI,iCAAA;ExEq8SV;EwE58SM;IAOI,2BAAA;ExEw8SV;EwE/8SM;IAOI,iCAAA;ExE28SV;EwEl9SM;IAOI,+BAAA;ExE88SV;EwEr9SM;IAOI,6BAAA;ExEi9SV;EwEx9SM;IAOI,+BAAA;ExEo9SV;EwE39SM;IAOI,8BAAA;ExEu9SV;EwE99SM;IAOI,oBAAA;ExE09SV;EwEj+SM;IAOI,mBAAA;ExE69SV;EwEp+SM;IAOI,mBAAA;ExEg+SV;EwEv+SM;IAOI,mBAAA;ExEm+SV;EwE1+SM;IAOI,mBAAA;ExEs+SV;EwE7+SM;IAOI,mBAAA;ExEy+SV;EwEh/SM;IAOI,mBAAA;ExE4+SV;EwEn/SM;IAOI,mBAAA;ExE++SV;EwEt/SM;IAOI,oBAAA;ExEk/SV;EwEz/SM;IAOI,0BAAA;ExEq/SV;EwE5/SM;IAOI,yBAAA;ExEw/SV;EwE//SM;IAOI,uBAAA;ExE2/SV;EwElgTM;IAOI,yBAAA;ExE8/SV;EwErgTM;IAOI,uBAAA;ExEigTV;EwExgTM;IAOI,uBAAA;ExEogTV;EwE3gTM;IAOI,0BAAA;IAAA,yBAAA;ExEwgTV;EwE/gTM;IAOI,gCAAA;IAAA,+BAAA;ExE4gTV;EwEnhTM;IAOI,+BAAA;IAAA,8BAAA;ExEghTV;EwEvhTM;IAOI,6BAAA;IAAA,4BAAA;ExEohTV;EwE3hTM;IAOI,+BAAA;IAAA,8BAAA;ExEwhTV;EwE/hTM;IAOI,6BAAA;IAAA,4BAAA;ExE4hTV;EwEniTM;IAOI,6BAAA;IAAA,4BAAA;ExEgiTV;EwEviTM;IAOI,wBAAA;IAAA,2BAAA;ExEoiTV;EwE3iTM;IAOI,8BAAA;IAAA,iCAAA;ExEwiTV;EwE/iTM;IAOI,6BAAA;IAAA,gCAAA;ExE4iTV;EwEnjTM;IAOI,2BAAA;IAAA,8BAAA;ExEgjTV;EwEvjTM;IAOI,6BAAA;IAAA,gCAAA;ExEojTV;EwE3jTM;IAOI,2BAAA;IAAA,8BAAA;ExEwjTV;EwE/jTM;IAOI,2BAAA;IAAA,8BAAA;ExE4jTV;EwEnkTM;IAOI,wBAAA;ExE+jTV;EwEtkTM;IAOI,8BAAA;ExEkkTV;EwEzkTM;IAOI,6BAAA;ExEqkTV;EwE5kTM;IAOI,2BAAA;ExEwkTV;EwE/kTM;IAOI,6BAAA;ExE2kTV;EwEllTM;IAOI,2BAAA;ExE8kTV;EwErlTM;IAOI,2BAAA;ExEilTV;EwExlTM;IAOI,0BAAA;ExEolTV;EwE3lTM;IAOI,gCAAA;ExEulTV;EwE9lTM;IAOI,+BAAA;ExE0lTV;EwEjmTM;IAOI,6BAAA;ExE6lTV;EwEpmTM;IAOI,+BAAA;ExEgmTV;EwEvmTM;IAOI,6BAAA;ExEmmTV;EwE1mTM;IAOI,6BAAA;ExEsmTV;EwE7mTM;IAOI,2BAAA;ExEymTV;EwEhnTM;IAOI,iCAAA;ExE4mTV;EwEnnTM;IAOI,gCAAA;ExE+mTV;EwEtnTM;IAOI,8BAAA;ExEknTV;EwEznTM;IAOI,gCAAA;ExEqnTV;EwE5nTM;IAOI,8BAAA;ExEwnTV;EwE/nTM;IAOI,8BAAA;ExE2nTV;EwEloTM;IAOI,yBAAA;ExE8nTV;EwEroTM;IAOI,+BAAA;ExEioTV;EwExoTM;IAOI,8BAAA;ExEooTV;EwE3oTM;IAOI,4BAAA;ExEuoTV;EwE9oTM;IAOI,8BAAA;ExE0oTV;EwEjpTM;IAOI,4BAAA;ExE6oTV;EwEppTM;IAOI,4BAAA;ExEgpTV;EwEvpTM;IAOI,qBAAA;ExEmpTV;EwE1pTM;IAOI,2BAAA;ExEspTV;EwE7pTM;IAOI,0BAAA;ExEypTV;EwEhqTM;IAOI,wBAAA;ExE4pTV;EwEnqTM;IAOI,0BAAA;ExE+pTV;EwEtqTM;IAOI,wBAAA;ExEkqTV;EwEzqTM;IAOI,2BAAA;IAAA,0BAAA;ExEsqTV;EwE7qTM;IAOI,iCAAA;IAAA,gCAAA;ExE0qTV;EwEjrTM;IAOI,gCAAA;IAAA,+BAAA;ExE8qTV;EwErrTM;IAOI,8BAAA;IAAA,6BAAA;ExEkrTV;EwEzrTM;IAOI,gCAAA;IAAA,+BAAA;ExEsrTV;EwE7rTM;IAOI,8BAAA;IAAA,6BAAA;ExE0rTV;EwEjsTM;IAOI,yBAAA;IAAA,4BAAA;ExE8rTV;EwErsTM;IAOI,+BAAA;IAAA,kCAAA;ExEksTV;EwEzsTM;IAOI,8BAAA;IAAA,iCAAA;ExEssTV;EwE7sTM;IAOI,4BAAA;IAAA,+BAAA;ExE0sTV;EwEjtTM;IAOI,8BAAA;IAAA,iCAAA;ExE8sTV;EwErtTM;IAOI,4BAAA;IAAA,+BAAA;ExEktTV;EwEztTM;IAOI,yBAAA;ExEqtTV;EwE5tTM;IAOI,+BAAA;ExEwtTV;EwE/tTM;IAOI,8BAAA;ExE2tTV;EwEluTM;IAOI,4BAAA;ExE8tTV;EwEruTM;IAOI,8BAAA;ExEiuTV;EwExuTM;IAOI,4BAAA;ExEouTV;EwE3uTM;IAOI,2BAAA;ExEuuTV;EwE9uTM;IAOI,iCAAA;ExE0uTV;EwEjvTM;IAOI,gCAAA;ExE6uTV;EwEpvTM;IAOI,8BAAA;ExEgvTV;EwEvvTM;IAOI,gCAAA;ExEmvTV;EwE1vTM;IAOI,8BAAA;ExEsvTV;EwE7vTM;IAOI,4BAAA;ExEyvTV;EwEhwTM;IAOI,kCAAA;ExE4vTV;EwEnwTM;IAOI,iCAAA;ExE+vTV;EwEtwTM;IAOI,+BAAA;ExEkwTV;EwEzwTM;IAOI,iCAAA;ExEqwTV;EwE5wTM;IAOI,+BAAA;ExEwwTV;EwE/wTM;IAOI,0BAAA;ExE2wTV;EwElxTM;IAOI,gCAAA;ExE8wTV;EwErxTM;IAOI,+BAAA;ExEixTV;EwExxTM;IAOI,6BAAA;ExEoxTV;EwE3xTM;IAOI,+BAAA;ExEuxTV;EwE9xTM;IAOI,6BAAA;ExE0xTV;EwEjyTM;IAOI,iBAAA;ExE6xTV;EwEpyTM;IAOI,uBAAA;ExEgyTV;EwEvyTM;IAOI,sBAAA;ExEmyTV;EwE1yTM;IAOI,oBAAA;ExEsyTV;EwE7yTM;IAOI,sBAAA;ExEyyTV;EwEhzTM;IAOI,oBAAA;ExE4yTV;EwEnzTM;IAOI,qBAAA;ExE+yTV;EwEtzTM;IAOI,2BAAA;ExEkzTV;EwEzzTM;IAOI,0BAAA;ExEqzTV;EwE5zTM;IAOI,wBAAA;ExEwzTV;EwE/zTM;IAOI,0BAAA;ExE2zTV;EwEl0TM;IAOI,wBAAA;ExE8zTV;EwEr0TM;IAOI,wBAAA;ExEi0TV;EwEx0TM;IAOI,8BAAA;ExEo0TV;EwE30TM;IAOI,6BAAA;ExEu0TV;EwE90TM;IAOI,2BAAA;ExE00TV;EwEj1TM;IAOI,6BAAA;ExE60TV;EwEp1TM;IAOI,2BAAA;ExEg1TV;EwEv1TM;IAOI,2BAAA;ExEm1TV;EwE11TM;IAOI,4BAAA;ExEs1TV;EwE71TM;IAOI,6BAAA;ExEy1TV;AACF;Acp2TI;E0DGI;IAOI,sBAAA;ExE81TV;EwEr2TM;IAOI,uBAAA;ExEi2TV;EwEx2TM;IAOI,sBAAA;ExEo2TV;EwE32TM;IAOI,8BAAA;ExEu2TV;EwE92TM;IAOI,4BAAA;ExE02TV;EwEj3TM;IAOI,2BAAA;ExE62TV;EwEp3TM;IAOI,iCAAA;ExEg3TV;EwEv3TM;IAOI,2BAAA;ExEm3TV;EwE13TM;IAOI,0BAAA;ExEs3TV;EwE73TM;IAOI,gCAAA;ExEy3TV;EwEh4TM;IAOI,yBAAA;ExE43TV;EwEn4TM;IAOI,wBAAA;ExE+3TV;EwEt4TM;IAOI,+BAAA;ExEk4TV;EwEz4TM;IAOI,yBAAA;ExEq4TV;EwE54TM;IAOI,6BAAA;ExEw4TV;EwE/4TM;IAOI,8BAAA;ExE24TV;EwEl5TM;IAOI,wBAAA;ExE84TV;EwEr5TM;IAOI,+BAAA;ExEi5TV;EwEx5TM;IAOI,wBAAA;ExEo5TV;EwE35TM;IAOI,yBAAA;ExEu5TV;EwE95TM;IAOI,8BAAA;ExE05TV;EwEj6TM;IAOI,iCAAA;ExE65TV;EwEp6TM;IAOI,sCAAA;ExEg6TV;EwEv6TM;IAOI,yCAAA;ExEm6TV;EwE16TM;IAOI,uBAAA;ExEs6TV;EwE76TM;IAOI,uBAAA;ExEy6TV;EwEh7TM;IAOI,yBAAA;ExE46TV;EwEn7TM;IAOI,yBAAA;ExE+6TV;EwEt7TM;IAOI,0BAAA;ExEk7TV;EwEz7TM;IAOI,4BAAA;ExEq7TV;EwE57TM;IAOI,kCAAA;ExEw7TV;EwE/7TM;IAOI,sCAAA;ExE27TV;EwEl8TM;IAOI,oCAAA;ExE87TV;EwEr8TM;IAOI,kCAAA;ExEi8TV;EwEx8TM;IAOI,yCAAA;ExEo8TV;EwE38TM;IAOI,wCAAA;ExEu8TV;EwE98TM;IAOI,wCAAA;ExE08TV;EwEj9TM;IAOI,kCAAA;ExE68TV;EwEp9TM;IAOI,gCAAA;ExEg9TV;EwEv9TM;IAOI,8BAAA;ExEm9TV;EwE19TM;IAOI,gCAAA;ExEs9TV;EwE79TM;IAOI,+BAAA;ExEy9TV;EwEh+TM;IAOI,oCAAA;ExE49TV;EwEn+TM;IAOI,kCAAA;ExE+9TV;EwEt+TM;IAOI,gCAAA;ExEk+TV;EwEz+TM;IAOI,uCAAA;ExEq+TV;EwE5+TM;IAOI,sCAAA;ExEw+TV;EwE/+TM;IAOI,iCAAA;ExE2+TV;EwEl/TM;IAOI,2BAAA;ExE8+TV;EwEr/TM;IAOI,iCAAA;ExEi/TV;EwEx/TM;IAOI,+BAAA;ExEo/TV;EwE3/TM;IAOI,6BAAA;ExEu/TV;EwE9/TM;IAOI,+BAAA;ExE0/TV;EwEjgUM;IAOI,8BAAA;ExE6/TV;EwEpgUM;IAOI,oBAAA;ExEggUV;EwEvgUM;IAOI,mBAAA;ExEmgUV;EwE1gUM;IAOI,mBAAA;ExEsgUV;EwE7gUM;IAOI,mBAAA;ExEygUV;EwEhhUM;IAOI,mBAAA;ExE4gUV;EwEnhUM;IAOI,mBAAA;ExE+gUV;EwEthUM;IAOI,mBAAA;ExEkhUV;EwEzhUM;IAOI,mBAAA;ExEqhUV;EwE5hUM;IAOI,oBAAA;ExEwhUV;EwE/hUM;IAOI,0BAAA;ExE2hUV;EwEliUM;IAOI,yBAAA;ExE8hUV;EwEriUM;IAOI,uBAAA;ExEiiUV;EwExiUM;IAOI,yBAAA;ExEoiUV;EwE3iUM;IAOI,uBAAA;ExEuiUV;EwE9iUM;IAOI,uBAAA;ExE0iUV;EwEjjUM;IAOI,0BAAA;IAAA,yBAAA;ExE8iUV;EwErjUM;IAOI,gCAAA;IAAA,+BAAA;ExEkjUV;EwEzjUM;IAOI,+BAAA;IAAA,8BAAA;ExEsjUV;EwE7jUM;IAOI,6BAAA;IAAA,4BAAA;ExE0jUV;EwEjkUM;IAOI,+BAAA;IAAA,8BAAA;ExE8jUV;EwErkUM;IAOI,6BAAA;IAAA,4BAAA;ExEkkUV;EwEzkUM;IAOI,6BAAA;IAAA,4BAAA;ExEskUV;EwE7kUM;IAOI,wBAAA;IAAA,2BAAA;ExE0kUV;EwEjlUM;IAOI,8BAAA;IAAA,iCAAA;ExE8kUV;EwErlUM;IAOI,6BAAA;IAAA,gCAAA;ExEklUV;EwEzlUM;IAOI,2BAAA;IAAA,8BAAA;ExEslUV;EwE7lUM;IAOI,6BAAA;IAAA,gCAAA;ExE0lUV;EwEjmUM;IAOI,2BAAA;IAAA,8BAAA;ExE8lUV;EwErmUM;IAOI,2BAAA;IAAA,8BAAA;ExEkmUV;EwEzmUM;IAOI,wBAAA;ExEqmUV;EwE5mUM;IAOI,8BAAA;ExEwmUV;EwE/mUM;IAOI,6BAAA;ExE2mUV;EwElnUM;IAOI,2BAAA;ExE8mUV;EwErnUM;IAOI,6BAAA;ExEinUV;EwExnUM;IAOI,2BAAA;ExEonUV;EwE3nUM;IAOI,2BAAA;ExEunUV;EwE9nUM;IAOI,0BAAA;ExE0nUV;EwEjoUM;IAOI,gCAAA;ExE6nUV;EwEpoUM;IAOI,+BAAA;ExEgoUV;EwEvoUM;IAOI,6BAAA;ExEmoUV;EwE1oUM;IAOI,+BAAA;ExEsoUV;EwE7oUM;IAOI,6BAAA;ExEyoUV;EwEhpUM;IAOI,6BAAA;ExE4oUV;EwEnpUM;IAOI,2BAAA;ExE+oUV;EwEtpUM;IAOI,iCAAA;ExEkpUV;EwEzpUM;IAOI,gCAAA;ExEqpUV;EwE5pUM;IAOI,8BAAA;ExEwpUV;EwE/pUM;IAOI,gCAAA;ExE2pUV;EwElqUM;IAOI,8BAAA;ExE8pUV;EwErqUM;IAOI,8BAAA;ExEiqUV;EwExqUM;IAOI,yBAAA;ExEoqUV;EwE3qUM;IAOI,+BAAA;ExEuqUV;EwE9qUM;IAOI,8BAAA;ExE0qUV;EwEjrUM;IAOI,4BAAA;ExE6qUV;EwEprUM;IAOI,8BAAA;ExEgrUV;EwEvrUM;IAOI,4BAAA;ExEmrUV;EwE1rUM;IAOI,4BAAA;ExEsrUV;EwE7rUM;IAOI,qBAAA;ExEyrUV;EwEhsUM;IAOI,2BAAA;ExE4rUV;EwEnsUM;IAOI,0BAAA;ExE+rUV;EwEtsUM;IAOI,wBAAA;ExEksUV;EwEzsUM;IAOI,0BAAA;ExEqsUV;EwE5sUM;IAOI,wBAAA;ExEwsUV;EwE/sUM;IAOI,2BAAA;IAAA,0BAAA;ExE4sUV;EwEntUM;IAOI,iCAAA;IAAA,gCAAA;ExEgtUV;EwEvtUM;IAOI,gCAAA;IAAA,+BAAA;ExEotUV;EwE3tUM;IAOI,8BAAA;IAAA,6BAAA;ExEwtUV;EwE/tUM;IAOI,gCAAA;IAAA,+BAAA;ExE4tUV;EwEnuUM;IAOI,8BAAA;IAAA,6BAAA;ExEguUV;EwEvuUM;IAOI,yBAAA;IAAA,4BAAA;ExEouUV;EwE3uUM;IAOI,+BAAA;IAAA,kCAAA;ExEwuUV;EwE/uUM;IAOI,8BAAA;IAAA,iCAAA;ExE4uUV;EwEnvUM;IAOI,4BAAA;IAAA,+BAAA;ExEgvUV;EwEvvUM;IAOI,8BAAA;IAAA,iCAAA;ExEovUV;EwE3vUM;IAOI,4BAAA;IAAA,+BAAA;ExEwvUV;EwE/vUM;IAOI,yBAAA;ExE2vUV;EwElwUM;IAOI,+BAAA;ExE8vUV;EwErwUM;IAOI,8BAAA;ExEiwUV;EwExwUM;IAOI,4BAAA;ExEowUV;EwE3wUM;IAOI,8BAAA;ExEuwUV;EwE9wUM;IAOI,4BAAA;ExE0wUV;EwEjxUM;IAOI,2BAAA;ExE6wUV;EwEpxUM;IAOI,iCAAA;ExEgxUV;EwEvxUM;IAOI,gCAAA;ExEmxUV;EwE1xUM;IAOI,8BAAA;ExEsxUV;EwE7xUM;IAOI,gCAAA;ExEyxUV;EwEhyUM;IAOI,8BAAA;ExE4xUV;EwEnyUM;IAOI,4BAAA;ExE+xUV;EwEtyUM;IAOI,kCAAA;ExEkyUV;EwEzyUM;IAOI,iCAAA;ExEqyUV;EwE5yUM;IAOI,+BAAA;ExEwyUV;EwE/yUM;IAOI,iCAAA;ExE2yUV;EwElzUM;IAOI,+BAAA;ExE8yUV;EwErzUM;IAOI,0BAAA;ExEizUV;EwExzUM;IAOI,gCAAA;ExEozUV;EwE3zUM;IAOI,+BAAA;ExEuzUV;EwE9zUM;IAOI,6BAAA;ExE0zUV;EwEj0UM;IAOI,+BAAA;ExE6zUV;EwEp0UM;IAOI,6BAAA;ExEg0UV;EwEv0UM;IAOI,iBAAA;ExEm0UV;EwE10UM;IAOI,uBAAA;ExEs0UV;EwE70UM;IAOI,sBAAA;ExEy0UV;EwEh1UM;IAOI,oBAAA;ExE40UV;EwEn1UM;IAOI,sBAAA;ExE+0UV;EwEt1UM;IAOI,oBAAA;ExEk1UV;EwEz1UM;IAOI,qBAAA;ExEq1UV;EwE51UM;IAOI,2BAAA;ExEw1UV;EwE/1UM;IAOI,0BAAA;ExE21UV;EwEl2UM;IAOI,wBAAA;ExE81UV;EwEr2UM;IAOI,0BAAA;ExEi2UV;EwEx2UM;IAOI,wBAAA;ExEo2UV;EwE32UM;IAOI,wBAAA;ExEu2UV;EwE92UM;IAOI,8BAAA;ExE02UV;EwEj3UM;IAOI,6BAAA;ExE62UV;EwEp3UM;IAOI,2BAAA;ExEg3UV;EwEv3UM;IAOI,6BAAA;ExEm3UV;EwE13UM;IAOI,2BAAA;ExEs3UV;EwE73UM;IAOI,2BAAA;ExEy3UV;EwEh4UM;IAOI,4BAAA;ExE43UV;EwEn4UM;IAOI,6BAAA;ExE+3UV;AACF;Ac14UI;E0DGI;IAOI,sBAAA;ExEo4UV;EwE34UM;IAOI,uBAAA;ExEu4UV;EwE94UM;IAOI,sBAAA;ExE04UV;EwEj5UM;IAOI,8BAAA;ExE64UV;EwEp5UM;IAOI,4BAAA;ExEg5UV;EwEv5UM;IAOI,2BAAA;ExEm5UV;EwE15UM;IAOI,iCAAA;ExEs5UV;EwE75UM;IAOI,2BAAA;ExEy5UV;EwEh6UM;IAOI,0BAAA;ExE45UV;EwEn6UM;IAOI,gCAAA;ExE+5UV;EwEt6UM;IAOI,yBAAA;ExEk6UV;EwEz6UM;IAOI,wBAAA;ExEq6UV;EwE56UM;IAOI,+BAAA;ExEw6UV;EwE/6UM;IAOI,yBAAA;ExE26UV;EwEl7UM;IAOI,6BAAA;ExE86UV;EwEr7UM;IAOI,8BAAA;ExEi7UV;EwEx7UM;IAOI,wBAAA;ExEo7UV;EwE37UM;IAOI,+BAAA;ExEu7UV;EwE97UM;IAOI,wBAAA;ExE07UV;EwEj8UM;IAOI,yBAAA;ExE67UV;EwEp8UM;IAOI,8BAAA;ExEg8UV;EwEv8UM;IAOI,iCAAA;ExEm8UV;EwE18UM;IAOI,sCAAA;ExEs8UV;EwE78UM;IAOI,yCAAA;ExEy8UV;EwEh9UM;IAOI,uBAAA;ExE48UV;EwEn9UM;IAOI,uBAAA;ExE+8UV;EwEt9UM;IAOI,yBAAA;ExEk9UV;EwEz9UM;IAOI,yBAAA;ExEq9UV;EwE59UM;IAOI,0BAAA;ExEw9UV;EwE/9UM;IAOI,4BAAA;ExE29UV;EwEl+UM;IAOI,kCAAA;ExE89UV;EwEr+UM;IAOI,sCAAA;ExEi+UV;EwEx+UM;IAOI,oCAAA;ExEo+UV;EwE3+UM;IAOI,kCAAA;ExEu+UV;EwE9+UM;IAOI,yCAAA;ExE0+UV;EwEj/UM;IAOI,wCAAA;ExE6+UV;EwEp/UM;IAOI,wCAAA;ExEg/UV;EwEv/UM;IAOI,kCAAA;ExEm/UV;EwE1/UM;IAOI,gCAAA;ExEs/UV;EwE7/UM;IAOI,8BAAA;ExEy/UV;EwEhgVM;IAOI,gCAAA;ExE4/UV;EwEngVM;IAOI,+BAAA;ExE+/UV;EwEtgVM;IAOI,oCAAA;ExEkgVV;EwEzgVM;IAOI,kCAAA;ExEqgVV;EwE5gVM;IAOI,gCAAA;ExEwgVV;EwE/gVM;IAOI,uCAAA;ExE2gVV;EwElhVM;IAOI,sCAAA;ExE8gVV;EwErhVM;IAOI,iCAAA;ExEihVV;EwExhVM;IAOI,2BAAA;ExEohVV;EwE3hVM;IAOI,iCAAA;ExEuhVV;EwE9hVM;IAOI,+BAAA;ExE0hVV;EwEjiVM;IAOI,6BAAA;ExE6hVV;EwEpiVM;IAOI,+BAAA;ExEgiVV;EwEviVM;IAOI,8BAAA;ExEmiVV;EwE1iVM;IAOI,oBAAA;ExEsiVV;EwE7iVM;IAOI,mBAAA;ExEyiVV;EwEhjVM;IAOI,mBAAA;ExE4iVV;EwEnjVM;IAOI,mBAAA;ExE+iVV;EwEtjVM;IAOI,mBAAA;ExEkjVV;EwEzjVM;IAOI,mBAAA;ExEqjVV;EwE5jVM;IAOI,mBAAA;ExEwjVV;EwE/jVM;IAOI,mBAAA;ExE2jVV;EwElkVM;IAOI,oBAAA;ExE8jVV;EwErkVM;IAOI,0BAAA;ExEikVV;EwExkVM;IAOI,yBAAA;ExEokVV;EwE3kVM;IAOI,uBAAA;ExEukVV;EwE9kVM;IAOI,yBAAA;ExE0kVV;EwEjlVM;IAOI,uBAAA;ExE6kVV;EwEplVM;IAOI,uBAAA;ExEglVV;EwEvlVM;IAOI,0BAAA;IAAA,yBAAA;ExEolVV;EwE3lVM;IAOI,gCAAA;IAAA,+BAAA;ExEwlVV;EwE/lVM;IAOI,+BAAA;IAAA,8BAAA;ExE4lVV;EwEnmVM;IAOI,6BAAA;IAAA,4BAAA;ExEgmVV;EwEvmVM;IAOI,+BAAA;IAAA,8BAAA;ExEomVV;EwE3mVM;IAOI,6BAAA;IAAA,4BAAA;ExEwmVV;EwE/mVM;IAOI,6BAAA;IAAA,4BAAA;ExE4mVV;EwEnnVM;IAOI,wBAAA;IAAA,2BAAA;ExEgnVV;EwEvnVM;IAOI,8BAAA;IAAA,iCAAA;ExEonVV;EwE3nVM;IAOI,6BAAA;IAAA,gCAAA;ExEwnVV;EwE/nVM;IAOI,2BAAA;IAAA,8BAAA;ExE4nVV;EwEnoVM;IAOI,6BAAA;IAAA,gCAAA;ExEgoVV;EwEvoVM;IAOI,2BAAA;IAAA,8BAAA;ExEooVV;EwE3oVM;IAOI,2BAAA;IAAA,8BAAA;ExEwoVV;EwE/oVM;IAOI,wBAAA;ExE2oVV;EwElpVM;IAOI,8BAAA;ExE8oVV;EwErpVM;IAOI,6BAAA;ExEipVV;EwExpVM;IAOI,2BAAA;ExEopVV;EwE3pVM;IAOI,6BAAA;ExEupVV;EwE9pVM;IAOI,2BAAA;ExE0pVV;EwEjqVM;IAOI,2BAAA;ExE6pVV;EwEpqVM;IAOI,0BAAA;ExEgqVV;EwEvqVM;IAOI,gCAAA;ExEmqVV;EwE1qVM;IAOI,+BAAA;ExEsqVV;EwE7qVM;IAOI,6BAAA;ExEyqVV;EwEhrVM;IAOI,+BAAA;ExE4qVV;EwEnrVM;IAOI,6BAAA;ExE+qVV;EwEtrVM;IAOI,6BAAA;ExEkrVV;EwEzrVM;IAOI,2BAAA;ExEqrVV;EwE5rVM;IAOI,iCAAA;ExEwrVV;EwE/rVM;IAOI,gCAAA;ExE2rVV;EwElsVM;IAOI,8BAAA;ExE8rVV;EwErsVM;IAOI,gCAAA;ExEisVV;EwExsVM;IAOI,8BAAA;ExEosVV;EwE3sVM;IAOI,8BAAA;ExEusVV;EwE9sVM;IAOI,yBAAA;ExE0sVV;EwEjtVM;IAOI,+BAAA;ExE6sVV;EwEptVM;IAOI,8BAAA;ExEgtVV;EwEvtVM;IAOI,4BAAA;ExEmtVV;EwE1tVM;IAOI,8BAAA;ExEstVV;EwE7tVM;IAOI,4BAAA;ExEytVV;EwEhuVM;IAOI,4BAAA;ExE4tVV;EwEnuVM;IAOI,qBAAA;ExE+tVV;EwEtuVM;IAOI,2BAAA;ExEkuVV;EwEzuVM;IAOI,0BAAA;ExEquVV;EwE5uVM;IAOI,wBAAA;ExEwuVV;EwE/uVM;IAOI,0BAAA;ExE2uVV;EwElvVM;IAOI,wBAAA;ExE8uVV;EwErvVM;IAOI,2BAAA;IAAA,0BAAA;ExEkvVV;EwEzvVM;IAOI,iCAAA;IAAA,gCAAA;ExEsvVV;EwE7vVM;IAOI,gCAAA;IAAA,+BAAA;ExE0vVV;EwEjwVM;IAOI,8BAAA;IAAA,6BAAA;ExE8vVV;EwErwVM;IAOI,gCAAA;IAAA,+BAAA;ExEkwVV;EwEzwVM;IAOI,8BAAA;IAAA,6BAAA;ExEswVV;EwE7wVM;IAOI,yBAAA;IAAA,4BAAA;ExE0wVV;EwEjxVM;IAOI,+BAAA;IAAA,kCAAA;ExE8wVV;EwErxVM;IAOI,8BAAA;IAAA,iCAAA;ExEkxVV;EwEzxVM;IAOI,4BAAA;IAAA,+BAAA;ExEsxVV;EwE7xVM;IAOI,8BAAA;IAAA,iCAAA;ExE0xVV;EwEjyVM;IAOI,4BAAA;IAAA,+BAAA;ExE8xVV;EwEryVM;IAOI,yBAAA;ExEiyVV;EwExyVM;IAOI,+BAAA;ExEoyVV;EwE3yVM;IAOI,8BAAA;ExEuyVV;EwE9yVM;IAOI,4BAAA;ExE0yVV;EwEjzVM;IAOI,8BAAA;ExE6yVV;EwEpzVM;IAOI,4BAAA;ExEgzVV;EwEvzVM;IAOI,2BAAA;ExEmzVV;EwE1zVM;IAOI,iCAAA;ExEszVV;EwE7zVM;IAOI,gCAAA;ExEyzVV;EwEh0VM;IAOI,8BAAA;ExE4zVV;EwEn0VM;IAOI,gCAAA;ExE+zVV;EwEt0VM;IAOI,8BAAA;ExEk0VV;EwEz0VM;IAOI,4BAAA;ExEq0VV;EwE50VM;IAOI,kCAAA;ExEw0VV;EwE/0VM;IAOI,iCAAA;ExE20VV;EwEl1VM;IAOI,+BAAA;ExE80VV;EwEr1VM;IAOI,iCAAA;ExEi1VV;EwEx1VM;IAOI,+BAAA;ExEo1VV;EwE31VM;IAOI,0BAAA;ExEu1VV;EwE91VM;IAOI,gCAAA;ExE01VV;EwEj2VM;IAOI,+BAAA;ExE61VV;EwEp2VM;IAOI,6BAAA;ExEg2VV;EwEv2VM;IAOI,+BAAA;ExEm2VV;EwE12VM;IAOI,6BAAA;ExEs2VV;EwE72VM;IAOI,iBAAA;ExEy2VV;EwEh3VM;IAOI,uBAAA;ExE42VV;EwEn3VM;IAOI,sBAAA;ExE+2VV;EwEt3VM;IAOI,oBAAA;ExEk3VV;EwEz3VM;IAOI,sBAAA;ExEq3VV;EwE53VM;IAOI,oBAAA;ExEw3VV;EwE/3VM;IAOI,qBAAA;ExE23VV;EwEl4VM;IAOI,2BAAA;ExE83VV;EwEr4VM;IAOI,0BAAA;ExEi4VV;EwEx4VM;IAOI,wBAAA;ExEo4VV;EwE34VM;IAOI,0BAAA;ExEu4VV;EwE94VM;IAOI,wBAAA;ExE04VV;EwEj5VM;IAOI,wBAAA;ExE64VV;EwEp5VM;IAOI,8BAAA;ExEg5VV;EwEv5VM;IAOI,6BAAA;ExEm5VV;EwE15VM;IAOI,2BAAA;ExEs5VV;EwE75VM;IAOI,6BAAA;ExEy5VV;EwEh6VM;IAOI,2BAAA;ExE45VV;EwEn6VM;IAOI,2BAAA;ExE+5VV;EwEt6VM;IAOI,4BAAA;ExEk6VV;EwEz6VM;IAOI,6BAAA;ExEq6VV;AACF;Ach7VI;E0DGI;IAOI,sBAAA;ExE06VV;EwEj7VM;IAOI,uBAAA;ExE66VV;EwEp7VM;IAOI,sBAAA;ExEg7VV;EwEv7VM;IAOI,8BAAA;ExEm7VV;EwE17VM;IAOI,4BAAA;ExEs7VV;EwE77VM;IAOI,2BAAA;ExEy7VV;EwEh8VM;IAOI,iCAAA;ExE47VV;EwEn8VM;IAOI,2BAAA;ExE+7VV;EwEt8VM;IAOI,0BAAA;ExEk8VV;EwEz8VM;IAOI,gCAAA;ExEq8VV;EwE58VM;IAOI,yBAAA;ExEw8VV;EwE/8VM;IAOI,wBAAA;ExE28VV;EwEl9VM;IAOI,+BAAA;ExE88VV;EwEr9VM;IAOI,yBAAA;ExEi9VV;EwEx9VM;IAOI,6BAAA;ExEo9VV;EwE39VM;IAOI,8BAAA;ExEu9VV;EwE99VM;IAOI,wBAAA;ExE09VV;EwEj+VM;IAOI,+BAAA;ExE69VV;EwEp+VM;IAOI,wBAAA;ExEg+VV;EwEv+VM;IAOI,yBAAA;ExEm+VV;EwE1+VM;IAOI,8BAAA;ExEs+VV;EwE7+VM;IAOI,iCAAA;ExEy+VV;EwEh/VM;IAOI,sCAAA;ExE4+VV;EwEn/VM;IAOI,yCAAA;ExE++VV;EwEt/VM;IAOI,uBAAA;ExEk/VV;EwEz/VM;IAOI,uBAAA;ExEq/VV;EwE5/VM;IAOI,yBAAA;ExEw/VV;EwE//VM;IAOI,yBAAA;ExE2/VV;EwElgWM;IAOI,0BAAA;ExE8/VV;EwErgWM;IAOI,4BAAA;ExEigWV;EwExgWM;IAOI,kCAAA;ExEogWV;EwE3gWM;IAOI,sCAAA;ExEugWV;EwE9gWM;IAOI,oCAAA;ExE0gWV;EwEjhWM;IAOI,kCAAA;ExE6gWV;EwEphWM;IAOI,yCAAA;ExEghWV;EwEvhWM;IAOI,wCAAA;ExEmhWV;EwE1hWM;IAOI,wCAAA;ExEshWV;EwE7hWM;IAOI,kCAAA;ExEyhWV;EwEhiWM;IAOI,gCAAA;ExE4hWV;EwEniWM;IAOI,8BAAA;ExE+hWV;EwEtiWM;IAOI,gCAAA;ExEkiWV;EwEziWM;IAOI,+BAAA;ExEqiWV;EwE5iWM;IAOI,oCAAA;ExEwiWV;EwE/iWM;IAOI,kCAAA;ExE2iWV;EwEljWM;IAOI,gCAAA;ExE8iWV;EwErjWM;IAOI,uCAAA;ExEijWV;EwExjWM;IAOI,sCAAA;ExEojWV;EwE3jWM;IAOI,iCAAA;ExEujWV;EwE9jWM;IAOI,2BAAA;ExE0jWV;EwEjkWM;IAOI,iCAAA;ExE6jWV;EwEpkWM;IAOI,+BAAA;ExEgkWV;EwEvkWM;IAOI,6BAAA;ExEmkWV;EwE1kWM;IAOI,+BAAA;ExEskWV;EwE7kWM;IAOI,8BAAA;ExEykWV;EwEhlWM;IAOI,oBAAA;ExE4kWV;EwEnlWM;IAOI,mBAAA;ExE+kWV;EwEtlWM;IAOI,mBAAA;ExEklWV;EwEzlWM;IAOI,mBAAA;ExEqlWV;EwE5lWM;IAOI,mBAAA;ExEwlWV;EwE/lWM;IAOI,mBAAA;ExE2lWV;EwElmWM;IAOI,mBAAA;ExE8lWV;EwErmWM;IAOI,mBAAA;ExEimWV;EwExmWM;IAOI,oBAAA;ExEomWV;EwE3mWM;IAOI,0BAAA;ExEumWV;EwE9mWM;IAOI,yBAAA;ExE0mWV;EwEjnWM;IAOI,uBAAA;ExE6mWV;EwEpnWM;IAOI,yBAAA;ExEgnWV;EwEvnWM;IAOI,uBAAA;ExEmnWV;EwE1nWM;IAOI,uBAAA;ExEsnWV;EwE7nWM;IAOI,0BAAA;IAAA,yBAAA;ExE0nWV;EwEjoWM;IAOI,gCAAA;IAAA,+BAAA;ExE8nWV;EwEroWM;IAOI,+BAAA;IAAA,8BAAA;ExEkoWV;EwEzoWM;IAOI,6BAAA;IAAA,4BAAA;ExEsoWV;EwE7oWM;IAOI,+BAAA;IAAA,8BAAA;ExE0oWV;EwEjpWM;IAOI,6BAAA;IAAA,4BAAA;ExE8oWV;EwErpWM;IAOI,6BAAA;IAAA,4BAAA;ExEkpWV;EwEzpWM;IAOI,wBAAA;IAAA,2BAAA;ExEspWV;EwE7pWM;IAOI,8BAAA;IAAA,iCAAA;ExE0pWV;EwEjqWM;IAOI,6BAAA;IAAA,gCAAA;ExE8pWV;EwErqWM;IAOI,2BAAA;IAAA,8BAAA;ExEkqWV;EwEzqWM;IAOI,6BAAA;IAAA,gCAAA;ExEsqWV;EwE7qWM;IAOI,2BAAA;IAAA,8BAAA;ExE0qWV;EwEjrWM;IAOI,2BAAA;IAAA,8BAAA;ExE8qWV;EwErrWM;IAOI,wBAAA;ExEirWV;EwExrWM;IAOI,8BAAA;ExEorWV;EwE3rWM;IAOI,6BAAA;ExEurWV;EwE9rWM;IAOI,2BAAA;ExE0rWV;EwEjsWM;IAOI,6BAAA;ExE6rWV;EwEpsWM;IAOI,2BAAA;ExEgsWV;EwEvsWM;IAOI,2BAAA;ExEmsWV;EwE1sWM;IAOI,0BAAA;ExEssWV;EwE7sWM;IAOI,gCAAA;ExEysWV;EwEhtWM;IAOI,+BAAA;ExE4sWV;EwEntWM;IAOI,6BAAA;ExE+sWV;EwEttWM;IAOI,+BAAA;ExEktWV;EwEztWM;IAOI,6BAAA;ExEqtWV;EwE5tWM;IAOI,6BAAA;ExEwtWV;EwE/tWM;IAOI,2BAAA;ExE2tWV;EwEluWM;IAOI,iCAAA;ExE8tWV;EwEruWM;IAOI,gCAAA;ExEiuWV;EwExuWM;IAOI,8BAAA;ExEouWV;EwE3uWM;IAOI,gCAAA;ExEuuWV;EwE9uWM;IAOI,8BAAA;ExE0uWV;EwEjvWM;IAOI,8BAAA;ExE6uWV;EwEpvWM;IAOI,yBAAA;ExEgvWV;EwEvvWM;IAOI,+BAAA;ExEmvWV;EwE1vWM;IAOI,8BAAA;ExEsvWV;EwE7vWM;IAOI,4BAAA;ExEyvWV;EwEhwWM;IAOI,8BAAA;ExE4vWV;EwEnwWM;IAOI,4BAAA;ExE+vWV;EwEtwWM;IAOI,4BAAA;ExEkwWV;EwEzwWM;IAOI,qBAAA;ExEqwWV;EwE5wWM;IAOI,2BAAA;ExEwwWV;EwE/wWM;IAOI,0BAAA;ExE2wWV;EwElxWM;IAOI,wBAAA;ExE8wWV;EwErxWM;IAOI,0BAAA;ExEixWV;EwExxWM;IAOI,wBAAA;ExEoxWV;EwE3xWM;IAOI,2BAAA;IAAA,0BAAA;ExEwxWV;EwE/xWM;IAOI,iCAAA;IAAA,gCAAA;ExE4xWV;EwEnyWM;IAOI,gCAAA;IAAA,+BAAA;ExEgyWV;EwEvyWM;IAOI,8BAAA;IAAA,6BAAA;ExEoyWV;EwE3yWM;IAOI,gCAAA;IAAA,+BAAA;ExEwyWV;EwE/yWM;IAOI,8BAAA;IAAA,6BAAA;ExE4yWV;EwEnzWM;IAOI,yBAAA;IAAA,4BAAA;ExEgzWV;EwEvzWM;IAOI,+BAAA;IAAA,kCAAA;ExEozWV;EwE3zWM;IAOI,8BAAA;IAAA,iCAAA;ExEwzWV;EwE/zWM;IAOI,4BAAA;IAAA,+BAAA;ExE4zWV;EwEn0WM;IAOI,8BAAA;IAAA,iCAAA;ExEg0WV;EwEv0WM;IAOI,4BAAA;IAAA,+BAAA;ExEo0WV;EwE30WM;IAOI,yBAAA;ExEu0WV;EwE90WM;IAOI,+BAAA;ExE00WV;EwEj1WM;IAOI,8BAAA;ExE60WV;EwEp1WM;IAOI,4BAAA;ExEg1WV;EwEv1WM;IAOI,8BAAA;ExEm1WV;EwE11WM;IAOI,4BAAA;ExEs1WV;EwE71WM;IAOI,2BAAA;ExEy1WV;EwEh2WM;IAOI,iCAAA;ExE41WV;EwEn2WM;IAOI,gCAAA;ExE+1WV;EwEt2WM;IAOI,8BAAA;ExEk2WV;EwEz2WM;IAOI,gCAAA;ExEq2WV;EwE52WM;IAOI,8BAAA;ExEw2WV;EwE/2WM;IAOI,4BAAA;ExE22WV;EwEl3WM;IAOI,kCAAA;ExE82WV;EwEr3WM;IAOI,iCAAA;ExEi3WV;EwEx3WM;IAOI,+BAAA;ExEo3WV;EwE33WM;IAOI,iCAAA;ExEu3WV;EwE93WM;IAOI,+BAAA;ExE03WV;EwEj4WM;IAOI,0BAAA;ExE63WV;EwEp4WM;IAOI,gCAAA;ExEg4WV;EwEv4WM;IAOI,+BAAA;ExEm4WV;EwE14WM;IAOI,6BAAA;ExEs4WV;EwE74WM;IAOI,+BAAA;ExEy4WV;EwEh5WM;IAOI,6BAAA;ExE44WV;EwEn5WM;IAOI,iBAAA;ExE+4WV;EwEt5WM;IAOI,uBAAA;ExEk5WV;EwEz5WM;IAOI,sBAAA;ExEq5WV;EwE55WM;IAOI,oBAAA;ExEw5WV;EwE/5WM;IAOI,sBAAA;ExE25WV;EwEl6WM;IAOI,oBAAA;ExE85WV;EwEr6WM;IAOI,qBAAA;ExEi6WV;EwEx6WM;IAOI,2BAAA;ExEo6WV;EwE36WM;IAOI,0BAAA;ExEu6WV;EwE96WM;IAOI,wBAAA;ExE06WV;EwEj7WM;IAOI,0BAAA;ExE66WV;EwEp7WM;IAOI,wBAAA;ExEg7WV;EwEv7WM;IAOI,wBAAA;ExEm7WV;EwE17WM;IAOI,8BAAA;ExEs7WV;EwE77WM;IAOI,6BAAA;ExEy7WV;EwEh8WM;IAOI,2BAAA;ExE47WV;EwEn8WM;IAOI,6BAAA;ExE+7WV;EwEt8WM;IAOI,2BAAA;ExEk8WV;EwEz8WM;IAOI,2BAAA;ExEq8WV;EwE58WM;IAOI,4BAAA;ExEw8WV;EwE/8WM;IAOI,6BAAA;ExE28WV;AACF;AyElgXA;ED+CQ;IAOI,4BAAA;ExEg9WV;EwEv9WM;IAOI,0BAAA;ExEm9WV;EwE19WM;IAOI,6BAAA;ExEs9WV;EwE79WM;IAOI,4BAAA;ExEy9WV;AACF;AyE7/WA;ED4BQ;IAOI,0BAAA;ExE89WV;EwEr+WM;IAOI,gCAAA;ExEi+WV;EwEx+WM;IAOI,yBAAA;ExEo+WV;EwE3+WM;IAOI,wBAAA;ExEu+WV;EwE9+WM;IAOI,+BAAA;ExE0+WV;EwEj/WM;IAOI,yBAAA;ExE6+WV;EwEp/WM;IAOI,6BAAA;ExEg/WV;EwEv/WM;IAOI,8BAAA;ExEm/WV;EwE1/WM;IAOI,wBAAA;ExEs/WV;EwE7/WM;IAOI,+BAAA;ExEy/WV;EwEhgXM;IAOI,wBAAA;ExE4/WV;AACF;AA9iXA;EACI,gCAVe;EAWf,eANa;EAOb,WAAA;AAgjXJ;;AA7iXA;EACI,aAAA;EACA,YAAA;EACA,eAAA;AAgjXJ;;AA7iXA;EACI,WAAA;AAgjXJ;;AA7iXA;EACI,qBAAA;AAgjXJ;;AA5iXI;EACI,aAAA;AA+iXR;;AA3iXA;EACI,gBAAA;AA8iXJ;AA5iXI;EAHJ;IAIQ,gBAAA;EA+iXN;AACF;AA7iXI;EAPJ;IAQQ,gBAAA;EAgjXN;AACF;;AA7iXA;EACI,mBAAA;AAgjXJ;AA9iXI;EAHJ;IAIQ,mBAAA;EAijXN;AACF;AA/iXI;EAPJ;IAQQ,mBAAA;EAkjXN;AACF;;AAjhXA;EACI,qBAAA;EACA,mBAAA;EACA,WAAA;AAohXJ;;AAjhXA;EACI,SAAA;AAohXJ;AAlhXI;EAHJ;IAIQ,SAAA;EAqhXN;AACF;AAnhXI;EAPJ;IAQQ,QAAA;IACA,2CAAA;EAshXN;AACF;AArhXI;EACI,WMxGG;AN+nXX;AArhXQ;EAHJ;IAIQ,wCAAA;IACA,iBAAA;EAwhXV;AACF;;AAphXA;EACI,mBAnHQ;EAoHR,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AAuhXJ;AArhXI;EAVJ;IAWQ,eAAA;IACA,iBAAA;EAwhXN;AACF;AArhXI;EAhBJ;IAiBQ,eAAA;EAwhXN;AACF;AArhXQ;EADJ;IAEQ,WAAA;EAwhXV;AACF;AArhXI;EACI,gBM5IG;ANmqXX;AAphXI;EACI,2BAAA;AAshXR;;AAlhXA;EACI,YAAA;AAqhXJ;AAnhXI;EAHJ;IAIQ,kBAAA;IACA,YAAA;IACA,2CAAA;EAshXN;AACF;AAlhXY;EACI,cAjKJ;AAqrXZ;AA/gXQ;EACI,gBAAA;AAihXZ;;AA5gXA;EACI,iFAAA;AA+gXJ;AA9gXI;EACG,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAghXP;AA9gXQ;EANJ;IAOQ,eAAA;EAihXV;AACF;AA/gXQ;EAVJ;IAWQ,oBAAA;IACA,eAAA;EAkhXV;AACF;AAhhXQ;EAfJ;IAgBQ,gBAAA;EAmhXV;AACF;AAjhXO;EACC,cAlMI;AAqtXZ;AAhhXI;EACI,eAAA;EACA,cAtME;EAuMF,gBAAA;EACA,iBAAA;EACA,cAAA;AAkhXR;AAhhXQ;EAPJ;IAQQ,eAAA;EAmhXV;AACF;AAjhXQ;EAXJ;IAYQ,eAAA;IACA,cAAA;IACA,eAAA;EAohXV;AACF;AAlhXI;EACI,iBAAA;AAohXR;AAlhXQ;EAHJ;IAIQ,gBAAA;EAqhXV;AACF;AAnhXQ;EAPJ;IAQQ,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,cAAA;EAshXV;AACF;;AAjhXA;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WM1OO;AN8vXX;AAlhXI;EANJ;IAOQ,eAAA;EAqhXN;AACF;AAnhXI;EAVJ;IAWQ,eAAA;EAshXN;AACF;AAphXI;EACI,cAtPI;AA4wXZ;;AAlhXA;EACI,kBAAA;AAqhXJ;AAnhXI;EAHJ;IAIQ,mBAAA;EAshXN;AACF;AAphXI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,gBMpQG;AN0xXX;AAphXQ;EANJ;IAOQ,WAAA;EAuhXV;AACF;AArhXI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,gBM9QG;ANqyXX;AArhXQ;EANJ;IAOQ,WAAA;EAwhXV;AACF;AAthXI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAzRI;EA0RJ,aAAA;AAwhXR;;AAphXA;EACI,mBA/RQ;EAgSR,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAuhXJ;AArhXI;EAPJ;IAQQ,WAAA;IACA,YAAA;IACA,YAAA;EAwhXN;AACF;AAthXI;EAbJ;IAcQ,WAAA;IACA,YAAA;EAyhXN;AACF;;AAnhXQ;EADJ;IAEQ,kBAAA;EAuhXV;AACF;AAnhXQ;EADJ;IAEQ,QAAA;EAshXV;AACF;AAnhXY;EADJ;IAEQ,cAAA;IACA,mBAAA;EAshXd;AACF;AAlhXI;EACI,gBAAA;EACA,kBAAA;EACA,kBAAA;AAohXR;AAlhXQ;EALJ;IAMQ,eAAA;EAqhXV;AACF;AAnhXQ;EACI,WAAA;EACA,oDAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAqhXZ;AAnhXY;EATJ;IAUQ,aAAA;EAshXd;AACF;AAphXQ;EACI,WAAA;EACA,oDAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;AAshXZ;AAphXY;EATJ;IAUQ,aAAA;EAuhXd;AACF;AAphXI;EACI,WAAA;AAshXR;AAphXI;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAshXR;AAphXQ;EANJ;IAOQ,oBAAA;IACA,2CAAA;IACA,mBAAA;EAuhXV;AACF;AArhXQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,oDAAA;EACA,UAAA;AAuhXZ;AArhXY;EARJ;IASQ,aAAA;EAwhXd;AACF;AArhXQ;EACI,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAuhXZ;AArhXY;EACI,WM7YL;ANo6XX;AAphXY;EACI,WAAA;EACA,4BAAA;EACA,0DAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;AAshXhB;AAnhXgB;EAXJ;IAYQ,kBAAA;EAshXlB;AACF;AAlhXgB;EACI,WAAA;EACA,0DAAA;AAohXpB;AAhhXY;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;AAkhXhB;AAhhXgB;EALJ;IAMQ,yBAAA;IACA,iBAAA;EAmhXlB;AACF;AAjhXgB;EAVJ;IAWQ,yBAAA;IACA,eAAA;IACA,iBAAA;EAohXlB;AACF;AAlhXgB;EAhBJ;IAiBQ,eAAA;EAqhXlB;AACF;AAlhXY;EACI,cA9bJ;EA+bI,eAAA;AAohXhB;AAjhXQ;EACI,uBAAA;EACA,kBAAA;AAmhXZ;AAjhXY;EAJJ;IAKQ,sBAAA;EAohXd;AACF;AAlhXY;EARJ;IASQ,sBAAA;IACA,eAAA;EAqhXd;AACF;AAnhXY;EAbJ;IAcQ,eAAA;EAshXd;AACF;AAnhXI;EACI,WAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AAqhXR;AAnhXQ;EATJ;IAUQ,gBAAA;IACA,mBAAA;EAshXV;AACF;;AAlhXA;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,WMveO;AN4/XX;;AAlhXA;EACI,mBA1eQ;EA2eR,eAAA;AAqhXJ;AAnhXI;EAJJ;IAKQ,iBAAA;EAshXN;AACF;AAphXI;EACI,mBAAA;AAshXR;AAphXQ;EAHJ;IAIQ,mBAAA;EAuhXV;AACF;;AAnhXA;EACI,mBA7fQ;EA8fR,kBAAA;EACA,YAAA;EACA,aAAA;EACA,2CAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAshXJ;AAphXI;EAbJ;IAcQ,WAAA;IACA,YAAA;EAuhXN;AACF;AArhXI;EACI,gBAAA;EACA,yBAAA;AAuhXR;AArhXQ;EAJJ;IAKQ,gBAAA;EAwhXV;AACF;;AArhXA;EACI,aAAA;AAwhXJ;AAthXI;EAHJ;IAIQ,aAAA;EAyhXN;AACF;;AAvhXA;EACI,gBAAA;EACA,mBAAA;EACA,uCAAA;EACA,wBAAA;EACA,yBAAA;AA0hXJ;AAxhXI;EAPJ;IAQQ,uBAAA;IACA,yBAAA;EA2hXN;AACF;AAzhXI;EACI,gBAAA;AA2hXR;AAxhXI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA0hXR;AAxhXQ;EANJ;IAOQ,eAAA;EA2hXV;AACF;AAxhXI;EACI,iBAAA;EACA,gBAAA;AA0hXR;AAxhXQ;EAJJ;IAKQ,eAAA;EA2hXV;AACF;;AAxhXA;EACI,cAnkBQ;EAokBR,eAAA;AA2hXJ;AAzhXI;EAJJ;IAKQ,eAAA;EA4hXN;AACF;AA1hXI;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AA4hXR;AA1hXQ;EALJ;IAMQ,WAAA;EA6hXV;AACF;AA1hXI;EACI,WMplBG;ANgnYX;AA1hXQ;EACI,UMvlBD;ANmnYX;;AAvhXA;EACI,oBAAA;EACA,gBAAA;AA0hXJ;;AAxhXA;EACI,SAAA;AA2hXJ;AAzhXI;EACI,YAAA;EACA,WAAA;AA2hXR;AAzhXI;EACI,WAAA;EACA,mBAAA;EACA,kBAAA;AA2hXR;AAzhXI;EACI,mBAAA;EACA,eAAA;AA2hXR;AAzhXI;EACI,gBAAA;AA2hXR;;AAthXI;EACI,mBAAA;AAyhXR;AAvhXQ;EAHJ;IAIQ,mBAAA;EA0hXV;AACF;AAxhXI;EACI,gBAAA;AA0hXR;AAxhXQ;EAHJ;IAIQ,SAAA;IACA,eAAA;EA2hXV;AACF;AAvhXY;EADJ;IAEQ,qBAAA;IACA,cAAA;EA0hXd;AACF;;AArhXA;EACI,SAAA;EACA,oBAAA;AAwhXJ;AAthXI;EAJJ;IAKQ,SAAA;EAyhXN;AACF;AAvhXI;EARJ;IASQ,gBAAA;EA0hXN;AACF;AAxhXI;EAZJ;IAaQ,SAAA;EA2hXN;AACF;AAzhXI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA2hXR;AAzhXQ;EANJ;IAOQ,gBAAA;EA4hXV;AACF;AA1hXQ;EAVJ;IAWQ,eAAA;EA6hXV;AACF;AA1hXY;EADJ;IAEQ,gBAAA;IACA,iBAAA;EA6hXd;AACF;AA3hXY;EANJ;IAOQ,eAAA;IACA,gBAAA;EA8hXd;AACF;AA3hXQ;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA6hXZ;AA3hXY;EARJ;IASQ,yBAAA;EA8hXd;AACF;AA5hXY;EACI,eAAA;AA8hXhB;AA5hXgB;EAHJ;IAIQ,eAAA;EA+hXlB;AACF;AA3hXI;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;AA6hXR;AA3hXQ;EALJ;IAMQ,eAAA;IACA,eAAA;EA8hXV;AACF;AA5hXQ;EAVJ;IAWQ,eAAA;EA+hXV;AACF;;AA1hXI;EACI,gBAAA;EACA,mBAAA;AA6hXR;;AAvhXQ;EACI,gBAAA;EACA,gBAAA;AA0hXZ;AAxhXY;EAJJ;IAKQ,gBAAA;EA2hXd;AACF;AAzhXQ;EACI,gBAAA;AA2hXZ;AAzhXY;EAHJ;IAIQ,gBAAA;EA4hXd;AACF;AAzhXI;EACI,aAAA;AA2hXR;AAzhXI;EACI,eAAA;AA2hXR;AAzhXI;EACI,eAAA;EACA,aAAA;EACA,aAAA;AA2hXR;AAzhXI;EACI,mBAlwBI;EAmwBJ,mBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AA2hXR;AAzhXQ;EAPJ;IAQQ,aAAA;EA4hXV;AACF;AA1hXQ;EAXJ;IAYQ,iBAAA;EA6hXV;AACF;AA3hXQ;EACI,iBAAA;EACA,mBAAA;AA6hXZ;AA3hXY;EAJJ;IAKQ,eAAA;EA8hXd;AACF;AA3hXI;EACI,gBAAA;AA6hXR;AA3hXI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AA6hXR;AA5hXQ;EACI,mBAAA;AA8hXZ;AA3hXI;EACI,wBAAA;EACA,kBAAA;AA6hXR;AA5hXQ;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,WM7yBD;EN8yBC,iBAAA;AA8hXZ;AA5hXY;EARJ;IASQ,eAAA;EA+hXd;AACF;AA7hXY;EAZJ;IAaQ,eAAA;EAgiXd;AACF;AA9hXQ;EACI,iBAAA;EACA,cAAA;AAgiXZ;AA9hXY;EAJJ;IAKQ,eAAA;EAiiXd;AACF;AA9hXI;EACI,aAAA;EACA,YAAA;AAgiXR;AA9hXQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAgiXZ;AA9hXY;EACI,mBA/0BJ;AA+2YZ;AA7hXY;EACI,WAAA;EACA,YAAA;EACA,YAAA;AA+hXhB;AA7hXgB;EACI,aAAA;AA+hXpB;;AAzhXA;EACI,iFAAA;EACA,iBAAA;EACA,gBAAA;AA4hXJ;AA1hXI;EACI,mBAAA;AA4hXR;AA1hXQ;EAHJ;IAIQ,mBAAA;EA6hXV;AACF;AA1hXI;EACI,kBAAA;AA4hXR;AA1hXQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,oBAAA;EACA,WM93BD;EN+3BC,oBAAA;AA4hXZ;AA1hXY;EAVJ;IAWQ,oBAAA;EA6hXd;AACF;AA3hXY;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;AA6hXhB;AA1hXY;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AA4hXhB;AA1hXgB;EAPJ;IAQQ,eAAA;IACA,iBAAA;EA6hXlB;AACF;AA3hXgB;EAZJ;IAaQ,eAAA;EA8hXlB;AACF;AA3hXY;EACI,WM95BL;AN27YX;AA3hXgB;EACI,cAx5BR;AAq7YZ;AA3hXoB;EACI,aA35BZ;AAw7YZ;AAxhXQ;EACI,aAAA;AA0hXZ;AAxhXY;EAHJ;IAIQ,YAAA;EA2hXd;AACF;AAzhXY;EACI,YAAA;EACA,WAAA;EACA,iBAAA;AA2hXhB;AAthXI;EACI,gBAAA;AAwhXR;AAthXQ;EAHJ;IAIQ,cAAA;IACA,eAAA;EAyhXV;AACF;AArhXQ;EAFJ;IAGQ,gBAAA;EAwhXV;AACF;AAthXQ;EACI,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAwhXZ;AAthXY;EATJ;IAUQ,eAAA;EAyhXd;AACF;AAthXI;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAwhXR;AAthXQ;EAPJ;IAQQ,kBAAA;EAyhXV;AACF;AAvhXQ;EACI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAyhXZ;AAthXQ;EACI,eAAA;EACA,iBAAA;EACA,WM/9BD;ENg+BC,gBAAA;EACA,mBAAA;EACA,gBAAA;AAwhXZ;AAthXY;EARJ;IASQ,eAAA;EAyhXd;AACF;AAvhXY;EAZJ;IAaQ,gBAAA;EA0hXd;AACF;AAxhXY;EAhBJ;IAiBQ,eAAA;IACA,mBAAA;EA2hXd;AACF;AAzhXY;EArBJ;IAsBQ,eAAA;EA4hXd;AACF;AAxhXY;EACI,cAz/BJ;AAmhZZ;AAxhXgB;EACI,aA5/BR;AAshZZ;AArhXI;EACI,YAAA;EACA,WAAA;AAuhXR;AArhXQ;EAJJ;IAKQ,YAAA;EAwhXV;AACF;AAthXQ;EARJ;IASQ,YAAA;EAyhXV;AACF;AAthXI;EACI,WM9gCG;ANsiZX;AAthXI;EACI,mBAAA;AAwhXR;AAthXQ;EAHJ;IAIQ,kBAAA;EAyhXV;AACF;;AArhXA;EACI,mBAAA;EACA,iBAAA;AAwhXJ;AAthXI;EACI,WMxiCG;ANgkZX;AAthXI;EACI,WM3iCG;EN4iCH,mBAAA;AAwhXR;AAthXQ;EAJJ;IAKQ,mBAAA;EAyhXV;AACF;AAthXI;EACI,gBAAA;EACA,gBAAA;AAwhXR;AAthXI;EACI,WAAA;EACA,WAAA;AAwhXR;AAthXQ;EAJJ;IAKQ,WAAA;EAyhXV;AACF;AAvhXQ;EACI,WAAA;AAyhXZ;AAlhXI;EACI,wBAAA;EACA,iBAAA;AAohXR;AAlhXQ;EAJJ;IAKQ,wBAAA;IACA,iBAAA;EAqhXV;AACF;AAnhXQ;EACI,cAAA;EACA,eAAA;AAqhXZ;AAlhXQ;EACI,WMtlCD;ENulCC,eAAA;EACA,gBAAA;AAohXZ;AAlhXY;EALJ;IAMQ,eAAA;EAqhXd;AACF;AAlhXI;EACI,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAohXR;AAlhXQ;EANJ;IAOQ,eAAA;EAqhXV;AACF;AAnhXQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAqhXZ;AAnhXY;EALJ;IAMQ,eAAA;EAshXd;AACF;AAnhXQ;EACI,WM1mCD;EN2mCC,mBAAA;AAqhXZ;AAlhXQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAohXZ;AAlhXY;EACI,kBAAA;AAohXhB;AAhhXQ;EACI,WAAA;AAkhXZ;AA/gXQ;EACI,YAAA;EACA,kBAAA;EACA,WMhoCD;ENioCC,YAAA;EACA,eAAA;EACA,kBAAA;AAihXZ;AA/gXY;EACI,qDAAA;AAihXhB;AA9gXY;EACI,gBAAA;AAghXhB;AA7gXY;EACI,cAAA;AA+gXhB;AA5gXY;EACI,cAAA;AA8gXhB;AA3gXY;EACI,cAAA;AA6gXhB;AA3gXW;EACC,YAAA;AA6gXZ;;AAvgXA;EACI,gBAAA;AA0gXJ;AAxgXI;EAHJ;IAIQ,gBAAA;EA2gXN;AACF;AAzgXI;EAPJ;IAQQ,eAAA;EA4gXN;AACF;AA1gXI;EAXJ;IAYQ,aAAA;EA6gXN;AACF;AA3gXI;EAfJ;IAgBQ,cAAA;EA8gXN;AACF;AA5gXI;EACI,gBAAA;EACA,WM9rCG;EN+rCH,iBAAA;EACA,eAAA;AA8gXR;AA5gXQ;EANJ;IAOQ,eAAA;EA+gXV;AACF;AA7gXQ;EAVJ;IAWQ,mBAAA;EAghXV;AACF;AA9gXQ;EACI,WAAA;EACA,0BAAA;AAghXZ;;AA3gXA;EACI,gBAAA;AA8gXJ;AA5gXI;EAHJ;IAIQ,eAAA;EA+gXN;AACF;AA7gXI;EAPJ;IAQQ,aAAA;EAghXN;AACF;;AA7gXA;EACI,YAAA;EACA,WAAA;AAghXJ;AA9gXI;EAJJ;IAKQ,YAAA;EAihXN;AACF;AA/gXI;EARJ;IASQ,eAAA;IACA,SAAA;IACA,WAAA;EAkhXN;AACF;AAhhXI;EAdJ;IAeQ,aAAA;EAmhXN;AACF;;AA/gXI;EACI,eAAA;EACA,gBAAA;EACA,WMpvCG;ENqvCH,gBAAA;EACA,mBAAA;AAkhXR;AAhhXQ;EAPJ;IAQQ,eAAA;EAmhXV;AACF;AAhhXI;EACI,WAAA;EACA,UAAA;AAkhXR;AAhhXQ;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;AAkhXZ;AAjhXY;EACI,WMtwCL;ANyxZX;AAjhXgB;EAHJ;IAIQ,eAAA;IACA,iBAAA;EAohXlB;AACF;;AA5gXI;EAFJ;IAGQ,eAAA;IACA,cAAA;EAghXN;AACF;AA9gXI;EACI,gBMzxCG;EN0xCH,uBAAA;EACA,mBAAA;EACA,aAAA;AAghXR;AAzuZI;EA4tCQ,gBAAA;EACA,YAAA;EACA,eAAA;AAghXZ;AA7uZQ;EACI,gBAAA;AA+uZZ;AA5uZQ;EACI,cAAA;AA8uZZ;AA3uZQ;EACI,cAAA;AA6uZZ;AA1uZQ;EACI,cAAA;AA4uZZ;AA1hXY;EAhuCR;IAiuCY,eAAA;EA6hXd;AACF;AA7uZI;EACI,YAAA;EACA,eAAA;AA+uZR;AA9uZQ;EACI,gBAAA;EACA,qBAAA;AAgvZZ;AAjiXI;EACI,YAAA;EACA,eAAA;AAmiXR;AAjiXQ;EAJJ;IAKQ,YAAA;EAoiXV;AACF;AAliXQ;EARJ;IASQ,YAAA;EAqiXV;AACF;AAniXQ;EAZJ;IAaQ,YAAA;EAsiXV;AACF;AApiXQ;EAhBJ;IAiBQ,YAAA;EAuiXV;AACF;AAriXQ;EApBJ;IAqBQ,gBAAA;IACA,WAAA;EAwiXV;AACF;AAriXQ;EACI,eAAA;EACA,gBAAA;EACA,WMt0CD;ENu0CC,gBAAA;AAuiXZ;AAriXY;EANJ;IAOQ,eAAA;EAwiXd;AACF;AAtiXQ;EACI,kBAAA;AAwiXZ;AAviXY;EAFJ;IAGQ,eAAA;IACA,aAAA;EA0iXd;AACF;AAviXI;EAaI,QAAA;AA6hXR;AAziXQ;EACI,eAAA;EACA,gBAAA;EACA,WMz1CD;EN01CC,WAAA;EACA,kBAAA;EACA,iBAAA;AA2iXZ;AAziXY;EARJ;IASQ,eAAA;EA4iXd;AACF;AAziXQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA2iXZ;AAziXY;EATJ;IAUQ,WAAA;IACA,YAAA;IACA,YAAA;EA4iXd;AACF;;AAviXA;EACI,SAAA;AA0iXJ;AAxiXI;EAHJ;IAIQ,SAAA;EA2iXN;AACF;AAziXI;EAPJ;IAQQ,QAAA;EA4iXN;AACF;;AAziXA;EACI,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;AA4iXJ;AA1iXI;EANJ;IAOQ,eAAA;IACA,iBAAA;IACA,oBAAA;EA6iXN;AACF;AA3iXI;EAZJ;IAaQ,eAAA;IACA,mBAAA;IACA,iBAAA;IACA,oBAAA;EA8iXN;AACF;AA7iXI;EACI,WAAA;EACA,0BAAA;EACA,iBAAA;AA+iXR;;AA1iXI;EADJ;IAEQ,gBAAA;IACA,kBAAA;IACA,OAAA;IACA,WAAA;IACA,SAAA;IACA,UAAA;EA8iXN;AACF;;AAziXI;EAFJ;IAGQ,gBAAA;EA6iXN;AACF;AA3iXI;EACI,gBAAA;AA6iXR;;AAziXA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AA4iXJ;AA1iXI;EANJ;IAOQ,eAAA;EA6iXN;AACF;AA3iXI;EAVJ;IAWQ,eAAA;EA8iXN;AACF;;AA3iXA;EACI,kBAAA;AA8iXJ;AA5iXI;EACI,mBAAA;EACA,WAAA;AA8iXR;AA1iXQ;EACI,iBAAA;EACA,iBAAA;AA4iXZ;AA1iXY;EAJJ;IAKQ,aAAA;IACA,iBAAA;EA6iXd;AACF;AA1iXI;EACI,kBAAA;EACA,QAAA;EACA,8BAAA;AA4iXR;AA1iXI;EACQ,WAAA;AA4iXZ;AA1iXQ;EAEI,eAAA;AA2iXZ;AAziXY;EAJJ;IAKQ,eAAA;EA4iXd;AACF;AA1iXY;EACI,aAAA;AA4iXhB;AA1iXY;EACI,eAAA;EACA,WAAA;AA4iXhB;AA1iXgB;EAJJ;IAKQ,eAAA;EA6iXlB;AACF;AA3iXgB;EACI,cAAA;AA6iXpB;AAziXY;EACI,WAAA;AA2iXhB;AAxiXQ;EACI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AA0iXZ;;AAniXQ;EADJ;IAEQ,gBAAA;EAuiXV;AACF;AAniXQ;EADJ;IAEQ,WAAA;EAsiXV;AACF;AAniXI;EACI,iBAAA;AAqiXR;AAniXQ;EAHJ;IAIQ,cAAA;EAsiXV;AACF;AApiXI;EACI,mBAAA;AAsiXR;AApiXI;EACI,iBAAA;EACA,gBAAA;AAsiXR;AApiXQ;EAJJ;IAKQ,eAAA;EAuiXV;AACF;AAniXQ;EADJ;IAEQ,SAAA;EAsiXV;AACF;;AAliXI;EACI,mBAAA;AAqiXR;AAniXQ;EAHJ;IAIQ,mBAAA;EAsiXV;AACF;AApiXQ;EAPJ;IAQQ,mBAAA;EAuiXV;AACF;AApiXI;EACI,SAAA;EACA,mBAAA;EACA,gCAAA;EACA,oBAAA;AAsiXR;AApiXQ;EANJ;IAOQ,SAAA;EAuiXV;AACF;AAriXQ;EACI,WAAA;EACA,YAAA;AAuiXZ;AAliXQ;EACI,wBAAA;AAoiXZ;AAliXY;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAoiXhB;AAliXgB;EARJ;IASQ,eAAA;EAqiXlB;AACF;AAliXgB;EADJ;IAEQ,eAAA;EAqiXlB;AACF;AAniXgB;EALJ;IAMQ,eAAA;EAsiXlB;AACF;AA9hXQ;EAFJ;IAGQ,gBAAA;EAiiXV;AACF;AA9hXY;EADJ;IAEQ,WAAA;EAiiXd;AACF;;AA5hXA;EACI,mBAAA;EACA,kBAAA;AA+hXJ;AA7hXI;EAJJ;IAKQ,iBAAA;EAgiXN;AACF;AA5hXQ;EAFJ;IAGQ,mBAAA;EA+hXV;AACF;AA7hXQ;EACI,eAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AA+hXZ;AA7hXY;EANJ;IAOQ,eAAA;EAgiXd;AACF;AA9hXQ;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAgiXZ;AA9hXY;EAPJ;IAQQ,eAAA;EAiiXd;AACF;AA/hXY;EAXJ;IAYQ,gBAAA;EAkiXd;AACF;AAhiXY;EAfJ;IAgBQ,eAAA;IACA,gBAAA;EAmiXd;AACF;AAjiXY;EApBJ;IAqBQ,eAAA;IACA,gBAAA;EAoiXd;AACF;AAjiXI;EACI,SAAA;AAmiXR;AAjiXQ;EAHJ;IAIQ,SAAA;EAoiXV;AACF;AAliXQ;EAPJ;IAQQ,SAAA;EAqiXV;AACF;AAniXQ;EAXJ;IAYQ,SAAA;EAsiXV;AACF;AApiXQ;EACI,gBAAA;EACA,gBAAA;AAsiXZ;AAniXI;EACI,mBAAA;AAqiXR;AApiXQ;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAsiXZ;AApiXY;EAPJ;IAQQ,eAAA;EAuiXd;AACF;AAriXY;EAXJ;IAYQ,eAAA;EAwiXd;AACF;AAviXY;EAdJ;IAeQ,eAAA;EA0iXd;AACF;AAxiXQ;EACI,eAAA;EACA,cAAA;AA0iXZ;AAxiXY;EAJJ;IAKQ,eAAA;EA2iXd;AACF;AAziXY;EARJ;IASQ,eAAA;EA4iXd;AACF;;AAviXA;EAEI,oBAAA;AAyiXJ;AAviXI;EAJJ;IAKQ,YAAA;EA0iXN;AACF;AAxiXI;EARJ;IASQ,oBAAA;EA2iXN;AACF;AAviXQ;EAFJ;IAGQ,cAAA;IACA,iBAAA;EA0iXV;AACF;AAviXI;EACI,mBAAA;AAyiXR;AAviXQ;EAHJ;IAIQ,mBAAA;EA0iXV;AACF;AAviXI;EACI,cAAA;EACA,4BAAA;AAyiXR;AAviXQ;EAJJ;IAKQ,cAAA;IACA,4BAAA;EA0iXV;AACF;AAxiXQ;EACI,WAAA;EACA,kBAAA;AA0iXZ;AAxiXQ;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,iBAAA;AA0iXZ;AAxiXY;EANJ;IAOQ,eAAA;IACA,gBAAA;EA2iXd;AACF;AAziXQ;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AA2iXZ;AAziXY;EANJ;IAOQ,eAAA;EA4iXd;AACF;AAxiXI;EACI,aAAA;EACA,YAAA;AA0iXR;AAxiXQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AA0iXZ;AAxiXY;EACI,YAAA;EACA,WAAA;EACA,YAAA;AA0iXhB;AAxiXgB;EACI,aAAA;AA0iXpB;AAviXY;EACI,mBAAA;AAyiXhB;;AAliXI;EACI,mBAAA;AAqiXR;AAniXQ;EAHJ;IAIQ,mBAAA;EAsiXV;AACF;AApiXQ;EAPJ;IAQQ,mBAAA;EAuiXV;AACF;AAniXQ;EACI,aAAA;AAqiXZ;AAniXY;EAHJ;IAIQ,aAAA;EAsiXd;AACF;AAliXI;EACI,uCAAA;EACA,mBAAA;AAoiXR;AAjiXI;EACI,uBAAA;AAmiXR;AAjiXQ;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAmiXZ;AAjiXY;EANJ;IAOQ,eAAA;EAoiXd;AACF;AAjiXQ;EACI,iBAAA;EACA,WAAA;AAmiXZ;AAjiXY;EAJJ;IAKQ,eAAA;EAoiXd;AACF;AAjiXQ;EACE,eAAA;EACA,cAAA;AAmiXV;AAjiXU;EACE,UAAA;AAmiXZ;;AA7hXA;EAEI,gBAAA;EACA,mBAAA;AA+hXJ;AA7hXI;EALJ;IAMQ,gBAAA;IACA,mBAAA;EAgiXN;AACF;AA9hXI;EACI,mBAAA;EACA,aAAA;AAgiXR;AA9hXQ;EAJJ;IAKQ,kBAAA;EAiiXV;AACF;AA/hXQ;EARJ;IASQ,aAAA;EAkiXV;AACF;AAhiXQ;EAZJ;IAaQ,kBAAA;EAmiXV;AACF;AAhiXQ;EACI,cAAA;EACA,kBAAA;AAkiXZ;AA9hXI;EACI,mBAAA;AAgiXR;AA9hXQ;EAHJ;IAIQ,mBAAA;EAiiXV;AACF;AA/hXQ;EACI,WAAA;AAiiXZ;AA7hXI;EACI,4BAAA;AA+hXR;AA9hXQ;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AAgiXZ;AA9hXY;EALJ;IAMQ,eAAA;EAiiXd;AACF;AA/hXQ;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAiiXZ;AA/hXY;EAPJ;IAQQ,eAAA;EAkiXd;AACF;AA9hXI;EACI,mBAAA;EACA,aAAA;AAgiXR;AA9hXQ;EAJJ;IAKQ,kBAAA;EAiiXV;AACF;AA/hXQ;EARJ;IASQ,kBAAA;EAkiXV;AACF;AAhiXQ;EAZJ;IAaQ,kBAAA;EAmiXV;AACF;AAjiXQ;EACI,SAAA;AAmiXZ;AAt6aI;EAu4DQ,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAkiXZ;AA56aQ;EACI,gBAAA;AA86aZ;AA36aQ;EACI,cAAA;AA66aZ;AA16aQ;EACI,cAAA;AA46aZ;AAz6aQ;EACI,cAAA;AA26aZ;AAv6aI;EACI,YAAA;EACA,eAAA;AAy6aR;AAx6aQ;EACI,gBAAA;EACA,qBAAA;AA06aZ;AAnjXQ;EACI,YAAA;EACA,kBAAA;AAqjXZ;AAljXQ;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;AAojXZ;;AA9iXI;EACI,mBAAA;AAijXR;AA9iXI;EACI,aAAA;AAgjXR;AA9iXQ;EAHJ;IAIQ,aAAA;EAijXV;AACF;AA9iXI;EACI,sBAAA;EACA,mBAAA;EACA,YAAA;AAgjXR;AA9iXQ;EACI,kBAAA;EACA,eAAA;AAgjXZ;AA9iXY;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAgjXhB;AA9iXgB;EAPJ;IAQQ,eAAA;IACA,mBAAA;EAijXlB;AACF;AA/iXY;EACI,iBAAA;EACA,mBAAA;AAijXhB;AA/iXgB;EAJJ;IAKQ,eAAA;IACA,iBAAA;EAkjXlB;AACF;AA9iXQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;AAgjXZ;AA5iXI;EACI,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AA8iXR;AA5iXQ;EACI,UAAA;AA8iXZ;;AAviXI;EACI,mBAAA;EACA,kBAAA;EACA,mBAAA;AA0iXR;AAxiXQ;EALJ;IAMQ,kBAAA;EA2iXV;AACF;AAziXQ;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA2iXZ;AAziXY;EAPJ;IAQQ,eAAA;IACA,gBAAA;EA4iXd;AACF;AAlibI;EA0/DQ,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AA2iXZ;AAxibQ;EACI,gBAAA;AA0ibZ;AAvibQ;EACI,cAAA;AAyibZ;AAtibQ;EACI,cAAA;AAwibZ;AAribQ;EACI,cAAA;AAuibZ;AAnibI;EACI,YAAA;EACA,eAAA;AAqibR;AApibQ;EACI,gBAAA;EACA,qBAAA;AAsibZ;AA7jXQ;EACI,2BAAA;AA+jXZ;AA7jXY;EAHJ;IAIQ,eAAA;EAgkXd;AACF;AA7jXQ;EACI,YAAA;AA+jXZ;AA5jXQ;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AA8jXZ;;AAxjXI;EACI,gBAAA;AA2jXR;AAzjXI;EACI,mBAAA;EACA,gBAAA;AA2jXR;AAzjXQ;EACI,WAAA;EACA,oCAAA;AA2jXZ;AAzjXY;EACI;IACI,+BAAA;EA2jXlB;EAxjXc;IACI,kCAAA;EA0jXlB;AACF;;AAnjXI;EACI,eAAA;EACA,kBAAA;AAsjXR;AAzmbI;EAsjEI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAsjXR;AA9mbQ;EACI,gBAAA;AAgnbZ;AA7mbQ;EACI,cAAA;AA+mbZ;AA5mbQ;EACI,cAAA;AA8mbZ;AA3mbQ;EACI,cAAA;AA6mbZ;AAjkXQ;EACI,qBAAA;AAmkXZ;AA5mbI;EACI,YAAA;EACA,eAAA;AA8mbR;AA7mbQ;EACI,gBAAA;EACA,qBAAA;AA+mbZ;AAxkXI;EACI,YAAA;EACA,eAAA;AA0kXR;AAvkXQ;EACI,YAAA;AAykXZ;;AAlkXI;EACI,mBAAA;EACA,kBAAA;AAqkXR;AAnkXQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,8CAAA;EACA,SAAA;AAqkXZ;AAlkXQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,2CAAA;AAokXZ;AA/jXY;EACI,aAAA;AAikXhB;AA5jXQ;EACI,iBAAA;EACA,cAAA;AA8jXZ;AA5jXY;EACI,aAAA;AA8jXhB;;AAtjXI;EACI,mBAAA;AAyjXR;AAtjXI;EACI,gBAAA;AAwjXR;AAtjXI;EACI,WAAA;AAwjXR;AAvjXQ;EACI,gBAAA;AAyjXZ;;AApjXA;EACI,2BAAA;EACA,iBAAA;EACA,mBAAA;AAujXJ;AArjXI;EACI,mBAAA;AAujXR;AApjXI;EACI,YAAA;EACA,uBAAA;EACA,mBAAA;AAsjXR;AApjXQ;EACI,YAAA;EACA,gBAAA;AAsjXZ;AApjXY;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;AAsjXhB;AApjXgB;EACI,mBAAA;EACA,kBAAA;AAsjXpB;AAjjXI;EACI,SAAA;EACA,uBAAA;AAmjXR;AAjjXI;EACI,0BAAA;EACA,gBAAA;AAmjXR;AAjjXQ;EACI,WAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAmjXZ;AAjjXQ;EACI,eAAA;AAmjXZ;AAjjXQ;EACI,WAAA;EACA,gBAAA;AAmjXZ;AAhjXI;EACI,gBAAA;AAkjXR;;AA7iXI;EACI,gBAAA;AAgjXR;AA9iXI;EACI,kBAAA;EACA,gBAAA;AAgjXR;AA9iXI;EACI,aAAA;EACA,SAAA;EACA,sBAAA;AAgjXR;AA/iXQ;EACI,yBAAA;EACA,mBAAA;AAijXZ;AA/iXY;EACI,mBAAA;AAijXhB;AA9iXY;EACI,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;AAgjXhB;AA9iXgB;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AAgjXpB;AA7iXgB;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AA+iXpB;AA5iXoB;EACI,cAAA;AA8iXxB;AAziXQ;EACI,aAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;AA2iXZ;AAziXY;EACI,WAAA;AA2iXhB;;AAriXA;EACI,oBAAA;AAwiXJ;;AAriXA;EACI,gBAAA;AAwiXJ;AAriXQ;EACI,mBAAA;EACA,gBAAA;AAuiXZ;AApiXI;EACI,aAAA;AAsiXR;AAriXQ;EACI,8BAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AAuiXZ;AAriXY;EACI,eAAA;EACA,cAAA;AAuiXhB;AApiXY;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAsiXhB;AAniXY;EACI,kBAAA;AAqiXhB;;AA/hXA;EACI,SAAA;EACA,gBAAA;AAkiXJ;;AA/hXA;EACI,gBAAA;EACA,iBAAA;AAkiXJ;AAhiXI;EACI,cAAA;AAkiXR;AA/hXI;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;AAiiXR;;AA9hXA;EACI,mBAAA;AAiiXJ;;AA/hXA;EACI,gBAAA;AAkiXJ;AAjiXI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAmiXR;AAjiXI;EACI,cAAA;AAmiXR;AAjiXI;EACI,aAAA;EACA,SAAA;EACA,sBAAA;EACA,SAAA;AAmiXR;AAjiXQ;EACI,cAAA;AAmiXZ;;AA/hXA;EACI,gBAAA;EACA,eAAA;AAkiXJ;;AA9hXQ;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAiiXZ;;AA3hXI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AA8hXR;AA5hXI;EACI,SAAA;EACA,2CAAA;EACA,iBAAA;AA8hXR;AA5hXQ;EACI,yBAAA;AA8hXZ;AA5hXY;EACI,eAAA;EACA,eAAA;AA8hXhB;AA1hXQ;EACI,YAAA;EACA,UAAA;AA4hXZ;AAxhXQ;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AA0hXZ;AAxhXQ;EACI,eAAA;EACA,mBAAA;EACA,eAAA;AA0hXZ;AAvhXQ;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAyhXZ;AAvhXY;EACI,gBAAA;AAyhXhB;AArhXI;EACI,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAuhXR;AAnhXQ;EACI,YAAA;EACA,YAAA;AAqhXZ;AAnhXQ;EACI,SAAA;AAqhXZ;AAnhXY;EACI,eAAA;AAqhXhB;AAlhXQ;EACI,yBAAA;AAohXZ;;AAhhXA;EACI,YAAA;EACA,aAAA;AAmhXJ;AAjhXI;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;AAmhXR;;AA/gXI;EACI,mBAAA;EACA,eAAA;AAkhXR;AAhhXI;EACI,gBAAA;AAkhXR;;AA/gXA;EACQ,mBAAA;EACA,SAAA;AAkhXR;AAjhXI;EACI,eAAA;EACA,cAAA;AAmhXR;;AA/gXA;EACI,gBAAA;AAkhXJ;AA/gXQ;EACI,eAAA;AAihXZ;;AA5gXA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;AA+gXJ;;AA7gXA;EACI,SAAA;EACA,mBAAA;EACA,gBAAA;AAghXJ;AA9gXI;EACI,yBAAA;AAghXR;;AA5gXI;EACI,mBAAA;EACA,kBAAA;AA+gXR;AA7gXI;EACI,WAAA;EACA,0BAAA;AA+gXR;;AA3gXI;EACI,gBAAA;EACA,2CAAA;EACA,aAAA;EACA,kBAAA;AA8gXR;AA5gXQ;EACI,YAAA;AA8gXZ;AA7gXY;EACI,gBAAA;EACA,qBAAA;AA+gXhB;;AA1gXA;EACI,mBAAA;AA6gXJ","sourcesContent":["// 1️⃣ Import Bootstrap's default variables (before overriding)\r\n@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\r\n@import \"bootstrap/scss/functions\";\r\n\r\n$container-max-widths: (\r\n  sm: 100%,\r\n  md: 100%,\r\n  lg: 100%,\r\n  xl: 1224px,\r\n  xxl: 1224px\r\n) !default;\r\n\r\n@import \"bootstrap/scss/variables\";\r\n@import \"bootstrap/scss/bootstrap\";\r\n\r\n$font-family-base: 'Inter', sans-serif;\r\n$primary: $black;\r\n$secondary: #FF4103;\r\n$grayish: #968C8C;\r\n$lightgray: #F8F8FA;\r\n$font-size-base: 16px;\r\n\r\n\r\n\r\nbody {\r\n    font-family: $font-family-base;\r\n    font-size: $font-size-base;\r\n    color: #000;\r\n}\r\n\r\nimg{\r\n    outline: none;\r\n    border: none;\r\n    max-width: 100%;\r\n}\r\n\r\np {\r\n    margin: 0px;\r\n}\r\n\r\na{\r\n    text-decoration: none;\r\n}\r\n\r\nbutton {\r\n    &:focus{\r\n        outline: none;\r\n    }\r\n}\r\n\r\n.margin-top-70 {\r\n    margin-top: 70px;\r\n\r\n    @media (max-width: 1024px){\r\n        margin-top: 50px;\r\n    }\r\n\r\n    @media (max-width: 767px){\r\n        margin-top: 40px;\r\n    }\r\n}\r\n\r\n.margin-bottom-70 {\r\n    margin-bottom: 70px;\r\n\r\n    @media (max-width: 1024px){\r\n        margin-bottom: 50px;\r\n    }\r\n    \r\n    @media (max-width: 767px){\r\n        margin-bottom: 40px;\r\n    }\r\n}\r\n\r\n@mixin inputplaceholder() {\r\n    .form-control{\r\n        &:focus {\r\n            box-shadow: none;\r\n        }\r\n\r\n        &::-webkit-input-placeholder{\r\n            color: #696969;\r\n        }\r\n\r\n        &::-moz-input-placeholder{\r\n            color: #696969;\r\n        }\r\n\r\n        &::-ms-input-placeholder{\r\n            color: #696969;\r\n        }\r\n        @content;\r\n    }  \r\n    .form-select{\r\n        height: 45px;\r\n        font-size: 14px;\r\n        &:focus {\r\n            box-shadow: none;\r\n            border-color: #dee2e6;\r\n        }\r\n\r\n    }\r\n}\r\n\r\n#root{\r\n    display: inline-block;\r\n    vertical-align: top;\r\n    width: 100%;\r\n}\r\n\r\n.navbar-nav{\r\n    gap: 50px;\r\n\r\n    @media (max-width: 991px) {\r\n        gap: 30px;\r\n    }\r\n\r\n    @media (max-width: 767px) {\r\n        gap: 0px;\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n    }\r\n    a{\r\n        color: $primary;\r\n\r\n        @media (max-width: 767px) {\r\n            border-top: 1px solid rgba(0, 0, 0, .1);\r\n            padding: 8px 15px;\r\n        }\r\n    }\r\n}\r\n\r\n.default-btn-style{\r\n    background: $secondary;\r\n    border-radius: 20px;\r\n    padding: 10px 20px;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 7px;\r\n\r\n    @media (max-width: 767px) {\r\n        font-size: 15px;\r\n        padding: 9px 18px;\r\n    }\r\n    \r\n\r\n    @media (max-width: 360px) {\r\n        font-size: 14px;\r\n    }\r\n\r\n    svg{\r\n        @media (max-width: 360px) {\r\n            width: 13px;\r\n        }\r\n    }\r\n\r\n    &:hover  {\r\n        background: $black;\r\n    }\r\n\r\n    &:active{\r\n        background: $black !important;\r\n    }\r\n}\r\n\r\n.menu {\r\n    height: 75px;\r\n\r\n    @media (max-width: 767px) {\r\n        position: relative;\r\n        height: 65px;\r\n        border-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n    }\r\n\r\n    .navbar-nav {\r\n        a{\r\n            &:hover{\r\n                color: $secondary;\r\n            }\r\n        }\r\n    }\r\n    .navbar-brand{\r\n        img{\r\n            max-width: 250px;\r\n        }\r\n    }\r\n}\r\n\r\n.banner{ \r\n    background: url('../../public/images/banner-shape.png') no-repeat bottom center / 100%;\r\n    h1{\r\n       font-size: 54px; \r\n       font-weight: 700;\r\n       margin: 70px 0 0;\r\n       line-height: 113.4%;\r\n\r\n        @media (max-width: 1200px) {\r\n            font-size: 40px;\r\n        }\r\n\r\n        @media (max-width: 767px) {\r\n            margin: 40px 0px 0px;\r\n            font-size: 30px;\r\n        }\r\n\r\n        @media (max-width: 575px) {\r\n            margin-top: 25px;\r\n        }\r\n\r\n       span{\r\n        color: $secondary;\r\n       }\r\n    }\r\n    p{\r\n        font-size: 20px;\r\n        color: $grayish;\r\n        max-width: 490px;\r\n        line-height: 140%;\r\n        margin: 25px 0;\r\n\r\n        @media (max-width: 1200px) {\r\n            font-size: 18px;\r\n        }\r\n\r\n        @media (max-width: 767px) {\r\n            max-width: 100%;\r\n            margin: 15px 0;\r\n            font-size: 15px;\r\n        }\r\n    }\r\n    img{\r\n        margin: 108px 0 0;\r\n\r\n        @media (max-width: 767px) {\r\n            margin-top: 30px;\r\n        }\r\n\r\n        @media (max-width: 575px) {\r\n            margin-left: auto;\r\n            margin-right: auto;\r\n            max-width: 250px;\r\n            display: block;\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.section-title{\r\n    font-size: 40px;\r\n    line-height: 113.4%;\r\n    font-weight: 600;\r\n    color: $black;\r\n\r\n    @media (max-width: 1200px) {\r\n        font-size: 32px;\r\n    }\r\n\r\n    @media (max-width: 767px) {\r\n        font-size: 25px;\r\n    }\r\n\r\n    span{\r\n        color: $secondary;\r\n    }\r\n}\r\n\r\n.section-title-mark{\r\n    margin: 3px 0 47px;\r\n    \r\n    @media (max-width: 767px) {\r\n        margin-bottom: 35px;\r\n    }\r\n\r\n    &::before{\r\n        content: \"\";\r\n        width: 64px;\r\n        height: 2px;\r\n        background: $primary;\r\n\r\n        @media (max-width: 1200px) {\r\n            width: 50px;\r\n        }\r\n    }\r\n    &::after{\r\n        content: \"\";\r\n        width: 64px;\r\n        height: 2px;\r\n        background: $primary;\r\n        \r\n        @media (max-width: 1200px) {\r\n            width: 50px;\r\n        }\r\n    }\r\n    span{\r\n        width: 10px;\r\n        height: 10px;\r\n        border-radius: 50%;\r\n        background: $secondary;\r\n        margin: 0 6px;\r\n    }\r\n}\r\n\r\n.steps-items{\r\n    background: $secondary;\r\n    width: 70px;\r\n    height: 70px;\r\n    border-radius: 50%;\r\n    flex: unset;\r\n\r\n    @media (max-width: 767px) {\r\n        width: 60px;\r\n        height: 60px;\r\n        padding: 7px;\r\n    }\r\n\r\n    @media (max-width: 767px) {\r\n        width: 50px;\r\n        height: 50px;\r\n    }\r\n}\r\n\r\n.our-process{\r\n\r\n    &.margin-bottom-70{\r\n        @media (max-width: 767px) {\r\n            margin-bottom: 0px;\r\n        }\r\n    }\r\n\r\n    .our-process-img{\r\n        @media (max-width: 767px) {\r\n            order: 2;\r\n        }\r\n\r\n        img{\r\n            @media (max-width: 767px){\r\n                display: block;\r\n                margin: 60px auto 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    .our-process-right-column{\r\n        max-width: 515px;\r\n        margin: 0 0 0 auto;\r\n        position: relative;\r\n\r\n        @media (max-width: 767px){\r\n            max-width: 100%;\r\n        }\r\n\r\n        &::before{\r\n            content: '';\r\n            background: url('../../public/images/dotted-line.png');\r\n            height: 39px;\r\n            width: 2px;\r\n            margin: 0 0 0 35px;\r\n            position: absolute;\r\n            bottom: 0;\r\n\r\n            @media (max-width: 767px) {\r\n                display: none;\r\n            }\r\n        }\r\n        &::after{\r\n            content: '';\r\n            background: url('../../public/images/horizontal-dotted-line.png');\r\n            height: 2px;\r\n            width: 108px;\r\n            margin: 37px 0 0 38px;\r\n            vertical-align: top;\r\n            display: inline-block;\r\n\r\n            @media (max-width: 767px) {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n    .accordion{\r\n        width: 100%;\r\n    }\r\n    .accordion-item{\r\n        border: none;\r\n        border-radius: 0;\r\n        position: relative;\r\n        padding: 0 0 25px;\r\n\r\n        @media (max-width: 767px) {\r\n            padding-bottom: 15px;\r\n            border-bottom: 1px solid rgba(0,0,0,.2);\r\n            margin-bottom: 15px;\r\n        }\r\n\r\n        &::before{\r\n            content: \"\";\r\n            position: absolute;\r\n            left: 35px;\r\n            height: 100%;\r\n            background: url('../../public/images/dotted-line.png'); \r\n            width: 2px;\r\n\r\n            @media (max-width: 767px) {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .accordion-button{\r\n            background: none;\r\n            box-shadow: none;\r\n            border: none;\r\n            padding: 0;\r\n            flex-wrap: wrap;\r\n\r\n            span{\r\n                color: $primary;\r\n            }\r\n\r\n            &::after{\r\n                content: \"\";\r\n                background-repeat: no-repeat;\r\n                background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='10' viewBox='0 0 16 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.82902 9.14293L0.286121 7.71436L8.00042 0.571499L15.7147 7.71439L14.1719 9.14296L8.00042 3.4287L1.82902 9.14293Z' fill='%23494949'/%3E%3C/svg%3E%0A\");\r\n                width: 15px;\r\n                height: 9px;\r\n                background-size: 100%;\r\n                margin: 0px 22px 0 0;\r\n                transform: unset;\r\n\r\n\r\n                @media (max-width: 767px) {\r\n                    margin-right: 10px;\r\n                }\r\n            }\r\n\r\n            &.collapsed{\r\n                &::after{\r\n                    content: \"\";\r\n                    background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='10' viewBox='0 0 16 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.171 0.857055L15.7139 2.28562L7.99958 9.42849L0.285278 2.2856L1.82814 0.857025L7.99958 6.57128L14.171 0.857055Z' fill='%23494949'/%3E%3C/svg%3E%0A\");\r\n                }\r\n            }\r\n\r\n            .steps-title{\r\n                width: calc(100% - 157px);\r\n                margin: 0 10px 0 40px;\r\n                flex: unset;\r\n\r\n                @media (max-width: 991px) {\r\n                    width: calc(100% - 142px);\r\n                    margin-left: 25px;\r\n                }\r\n\r\n                @media (max-width: 767px) {\r\n                    width: calc(100% - 120px);\r\n                    font-size: 15px;\r\n                    margin-left: 15px;\r\n                }\r\n\r\n                @media (max-width: 575px) {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n\r\n            label{\r\n                color: $secondary;\r\n                margin: 0 0 5px;\r\n            }\r\n        }\r\n        .accordion-collapse{\r\n            padding: 10px 0 0 110px;\r\n            position: relative;\r\n\r\n            @media (max-width: 991px) {\r\n                padding: 10px 0 0 95px;\r\n            }\r\n\r\n            @media (max-width: 767px) {\r\n                padding: 10px 0 0 75px;\r\n                font-size: 15px;\r\n            }\r\n\r\n            @media (max-width: 575px) {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n    .book-consultation{\r\n        margin: 0px;\r\n        gap: 7px;\r\n        display: flex;\r\n        align-items: center;\r\n        position: absolute;\r\n        bottom: -16px;\r\n        left: 161px;\r\n\r\n        @media (max-width: 767px) {\r\n            position: static;\r\n            margin: 20px auto 0;\r\n        }\r\n    }\r\n}\r\n\r\n.section-subtitle{\r\n    line-height: 120%;\r\n    font-size: 14px;\r\n    margin-top: 10px;\r\n    color: $black;\r\n}\r\n\r\n.expertise-our-developers{\r\n    background: $lightgray;\r\n    padding: 50px 0;\r\n\r\n    @media (max-width: 767px) {\r\n        padding: 40px 0px;\r\n    }\r\n\r\n    .section-subtitle{\r\n        margin-bottom: 84px;\r\n\r\n        @media (max-width: 991px) {\r\n            margin-bottom: 60px;\r\n        }\r\n    }\r\n}\r\n\r\n.square-shape{\r\n    background: $secondary;\r\n    border-radius: 5px;\r\n    width: 100px;\r\n    height: 100px;\r\n    transform: translate(-50%, 0) rotate(45deg);\r\n    left: 50%;\r\n    position: relative;\r\n    margin: 0 0 -50px 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    @media (max-width: 991px) {\r\n        width: 80px;\r\n        height: 80px;\r\n    }\r\n\r\n    img, svg{\r\n        max-height: 50px;\r\n        transform: rotate(-45deg);\r\n\r\n        @media (max-width: 991px) {\r\n            max-height: 42px;\r\n        }\r\n    }\r\n}\r\n.expertise-our-developers-list{\r\n    gap: 76px 0px;\r\n\r\n    @media (max-width: 991px) {\r\n        gap: 40px 0px;\r\n    }\r\n}\r\n.developers-list{\r\n    background: map-get($colors, \"white\");\r\n    border-radius: 10px;\r\n    box-shadow: 0 0 10px rgba(0,0,0,.1);\r\n    padding: 103px 20px 22px;\r\n    height: calc(100% - 50px);\r\n\r\n    @media (max-width: 991px) {\r\n        padding: 90px 15px 22px;\r\n        height: calc(100% - 30px);\r\n    }\r\n\r\n    .read-more{\r\n        margin-top: auto;\r\n    }\r\n\r\n    label {\r\n        font-size: 20px;\r\n        font-weight: 600;\r\n        line-height: 113.4%;\r\n        vertical-align: top;\r\n\r\n        @media (max-width: 991px) {\r\n            font-size: 18px;\r\n        }\r\n    }\r\n\r\n    p{\r\n        line-height: 125%;\r\n        margin: 15px 0px;\r\n\r\n        @media (max-width: 991px) {\r\n            font-size: 15px;\r\n        }\r\n    }\r\n}\r\n.read-more {\r\n    color: $secondary;\r\n    font-size: 15px;\r\n\r\n    @media (max-width: 400px) {\r\n        font-size: 14px;\r\n    }\r\n\r\n    svg{\r\n        margin: 0 0 0 7px;\r\n        width: 13px;\r\n        height: auto;\r\n\r\n        @media (max-width: 400px) {\r\n            width: 12px;\r\n        }\r\n    }\r\n\r\n    &:hover{\r\n        color: $black;\r\n\r\n        path{\r\n            fill: $black;\r\n        }\r\n    }\r\n}\r\n\r\n.hire-developer-btn{\r\n    display: inline-flex;\r\n    margin: 50px 0 0;\r\n}\r\n.home-why-choose-inner-content{\r\n    gap: 15px;\r\n\r\n    svg {\r\n        height: 70px;\r\n        width: auto;\r\n    }\r\n    strong{\r\n        width: 100%;\r\n        line-height: 113.4%;\r\n        margin: 25px 0 6px;\r\n    }\r\n    p{\r\n        line-height: 113.4%;\r\n        font-size: 14px;\r\n    }\r\n    & > div{\r\n        max-width: 245px;\r\n    }\r\n}\r\n\r\n.home-why-choose-us{\r\n    .section-subtitle{\r\n        margin-bottom: 60px;\r\n\r\n        @media (max-width: 767px) {\r\n            margin-bottom: 45px;\r\n        }\r\n    }\r\n    .home-why-choose-us-content{\r\n        max-width: 538px;\r\n\r\n        @media (max-width: 767px) {\r\n            order: -1;\r\n            max-width: 100%;\r\n        }\r\n    }\r\n    .home-why-chooseus-img{\r\n        img{\r\n            @media (max-width: 767px) {\r\n                margin: 30px auto 0px;\r\n                display: block;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.progress-container{\r\n    gap: 50px;\r\n    margin: 60px 0px 0px;\r\n\r\n    @media (max-width: 991px) {\r\n        gap: 30px;\r\n    }\r\n\r\n    @media (max-width: 450px) {\r\n        margin-top: 40px;\r\n    }\r\n\r\n    @media (max-width: 400px) {\r\n        gap: 20px;\r\n    }\r\n\r\n    .circle{\r\n        position: relative;\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n\r\n        @media (max-width: 450px) {\r\n            max-width: 100px;\r\n        }\r\n\r\n        @media (max-width: 370px) {\r\n            max-width: 80px;\r\n        }\r\n\r\n        canvas{\r\n            @media (max-width: 450px) {\r\n                max-width: 100px;\r\n                max-height: 100px;\r\n            }\r\n\r\n            @media (max-width: 370px) {\r\n                max-width: 80px;\r\n                max-height: 80px;\r\n            }\r\n        }\r\n\r\n        .items-value {\r\n            position: absolute;\r\n            width: 100%;\r\n            height: calc(100% - 36px);\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n\r\n            @media (max-width: 450px) {\r\n                height: calc(100% - 28px);\r\n            }\r\n\r\n            strong{\r\n                font-size: 20px;\r\n\r\n                @media (max-width: 400px) {\r\n                    font-size: 18px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    span{\r\n        font-weight: 600;\r\n        margin: 12px 0 0;\r\n        color: #000;\r\n\r\n        @media (max-width: 450px) {\r\n            margin: 7px 0 0;\r\n            font-size: 14px;\r\n        }\r\n\r\n        @media (max-width: 370px) {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n}\r\n\r\n.our-testimonial{\r\n    .section-subtitle{\r\n        max-width: 498px;\r\n        margin-bottom: 60px;\r\n    }\r\n}\r\n\r\n.our-testimonial {\r\n    .testimonial-top-portion{\r\n        .client-logo{\r\n            max-height: 25px;\r\n            max-width: 200px;\r\n\r\n            @media (max-width: 991px) { \r\n                max-height: 22px;\r\n            }\r\n        }\r\n        .client-quotes{\r\n            max-height: 30px;\r\n\r\n            @media (max-width: 1200px) {\r\n                max-height: 25px;\r\n            }\r\n        }\r\n    }\r\n    .slick-track{\r\n        display: flex;\r\n    }\r\n    .slick-list{\r\n        margin: 0 -12px;\r\n    }\r\n    .slick-slide{\r\n        padding: 0 12px;\r\n        height: unset;\r\n        display: flex;\r\n    }\r\n    .slide-item{\r\n        background: $lightgray;\r\n        border-radius: 20px;\r\n        padding: 20px;\r\n        height: 100%;\r\n        min-height: 350px;\r\n\r\n        @media (max-width: 991px) {\r\n            padding: 15px;\r\n        }\r\n\r\n        @media (max-width: 575px) {\r\n            min-height: 280px;\r\n        }\r\n\r\n        p{\r\n            line-height: 140%;\r\n            margin: 28px 0 15px;\r\n\r\n            @media (max-width: 1200px) {\r\n                font-size: 15px;\r\n            }\r\n        }\r\n    }\r\n    .client{\r\n        margin: auto 0 0;  \r\n    }\r\n    .client-image{\r\n        width: 49px;\r\n        height: 49px;\r\n        border-radius: 50%;\r\n        img{\r\n            border-radius: 100%;\r\n        }\r\n    }\r\n    .client-info {\r\n        width: calc(100% - 64px);\r\n        margin: 0 0 0 15px;\r\n        label{\r\n            font-size: 20px;\r\n            vertical-align: top;\r\n            font-weight: 600;\r\n            width: 100%;\r\n            color: $black;\r\n            line-height: 120%;\r\n\r\n            @media (max-width: 1200px) {\r\n                font-size: 18px;\r\n            }\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 17px;\r\n            }\r\n        }\r\n        span{\r\n            line-height: 120%;\r\n            color: #8E8E8E;\r\n\r\n            @media (max-width: 1200px) {\r\n                font-size: 15px;\r\n            }\r\n        }\r\n    }\r\n    .slick-dots {\r\n        bottom: -40px;\r\n        height: 10px;\r\n\r\n        li{\r\n            width: 10px;\r\n            height: 10px;\r\n            background: #D9D9D9;\r\n            border-radius: 50%;\r\n            margin: 0 2.5px;\r\n            vertical-align: top;\r\n\r\n            &.slick-active{\r\n                background: $secondary;\r\n            }\r\n\r\n            button {\r\n                width: 100%;\r\n                height: 100%;\r\n                padding: 0px;\r\n\r\n                &::before{\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n.home-blogbg {\r\n    background: url(\"../../public/images/home-blog-bg.png\") no-repeat center bottom / 100%;\r\n    padding: 40px 0 0;\r\n    margin: 50px 0 0;\r\n    \r\n    .section-title{\r\n        margin-bottom: 40px;\r\n\r\n        @media (max-width: 767px) {\r\n            margin-bottom: 30px;\r\n        }\r\n    }\r\n\r\n    .home-latest-blog{\r\n        position: relative;\r\n\r\n        .home-latest-blog-info{\r\n            position: absolute;\r\n            bottom: 0px;\r\n            width: 100%;\r\n            height: 100%;\r\n            background: rgba(0, 0, 0, 20%);\r\n            justify-content: end;\r\n            color: $white;\r\n            padding: 0 30px 30px;\r\n\r\n            @media (max-width: 991px) {\r\n                padding: 0 20px 20px;\r\n            }\r\n\r\n            & > span{\r\n                line-height: 140%;\r\n                display: block;\r\n                margin: 0 0 10px;\r\n                width: 100%;\r\n            }\r\n\r\n            label {\r\n                font-size: 30px;\r\n                vertical-align: top;\r\n                font-weight: 600;\r\n                line-height: 140%;\r\n                margin: 0 0 14px;\r\n\r\n                @media (max-width: 1024px) {\r\n                    font-size: 26px;\r\n                    line-height: 130%;\r\n                }\r\n\r\n                @media (max-width: 400px) {\r\n                    font-size: 20px;\r\n                }\r\n            }\r\n\r\n            .read-more{\r\n                color: $white;\r\n\r\n                &:hover{\r\n                    color: $secondary;\r\n\r\n                    path{\r\n                        fill: $secondary;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .home-latest-blog-img{\r\n            height: 536px;\r\n\r\n            @media (max-width: 767px) {\r\n                height: auto;\r\n            }\r\n\r\n            img{\r\n                height: 100%;\r\n                width: 100%;\r\n                object-fit: cover;\r\n            }\r\n        }\r\n    }\r\n\r\n    .home-latest-blog-left-column{\r\n        max-width: 524px;\r\n        \r\n        @media (max-width: 767px) {\r\n            flex: 1 0 100%;\r\n            max-width: 100%;\r\n        }\r\n    }\r\n    .home-latest-blog-right-column{\r\n\r\n        @media (max-width: 767px) {\r\n            margin-top: 40px;\r\n        }\r\n\r\n        .home-latest-blog-right-column-list {\r\n            max-width: 650px;\r\n            margin-left: auto;\r\n            border-bottom: 1px solid #D9D9D9;\r\n            padding: 0 0 25px;\r\n            margin-bottom: 25px;\r\n            flex-wrap: wrap;\r\n            flex-direction: row;\r\n\r\n            @media (max-width: 767px) {\r\n                max-width: 100%;\r\n            }\r\n        }\r\n    }\r\n    .home-latest-blog-right-column-list-content{\r\n        width: calc(100% - 220px);\r\n        align-content: flex-start;\r\n        margin-right: 20px;\r\n        flex-direction: row;\r\n        flex-wrap: wrap;\r\n\r\n        @media (max-width: 340px) {\r\n            margin-right: 10px;\r\n        }\r\n\r\n        & > span{\r\n            color: #696969;\r\n            display: block;\r\n            margin: 0 0 10px;\r\n            font-size: 14px;\r\n        }\r\n\r\n        label{\r\n            font-size: 20px;\r\n            line-height: 120%;\r\n            color: $black;\r\n            font-weight: 600;\r\n            vertical-align: top;\r\n            margin: 0 0 25px;\r\n\r\n            @media (max-width: 1024px) {\r\n                font-size: 18px;\r\n            }\r\n\r\n            @media (max-width: 767px) {\r\n                margin: 0 0 18px;\r\n            }\r\n\r\n            @media (max-width: 400px) {\r\n                font-size: 16px;\r\n                margin-bottom: 10px;\r\n            }\r\n\r\n            @media (max-width: 340px) {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n\r\n        .read-more {\r\n            &:hover{\r\n                color: $secondary;\r\n    \r\n                path{\r\n                    fill: $secondary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .home-latest-blog-right-image{\r\n        width: 200px;\r\n        flex: unset;\r\n\r\n        @media (max-width: 991px) {\r\n            width: 150px;\r\n        }\r\n\r\n        @media (max-width: 400px) {\r\n            width: 130px;\r\n        }\r\n\r\n    }\r\n    .read-more{\r\n        color: $black;\r\n    }\r\n    .home-blog-viewall{\r\n        margin: 20px 0 50px;\r\n\r\n        @media (max-width: 767px) {\r\n            margin: 0px 0 40px;\r\n        }\r\n    }\r\n}\r\n\r\n.work-enquirybg{\r\n    background: #304097;\r\n    padding: 50px 0px;\r\n\r\n    .section-title{\r\n        color: $white;\r\n    }\r\n    .section-subtitle{\r\n        color: $white;\r\n        margin-bottom: 55px;\r\n\r\n        @media (max-width: 991px) {\r\n            margin-bottom: 40px;\r\n        }\r\n    }\r\n\r\n    .work-enquiry-contact {\r\n        max-width: 300px;\r\n        margin: 0 0 30px;\r\n    }\r\n    .work-enquiry-contact-icon{\r\n        width: 28px;\r\n        flex: unset;\r\n\r\n        @media (max-width: 991px) {\r\n            width: 22px;\r\n        }\r\n    \r\n        svg{\r\n            width: 100%;\r\n        }\r\n\r\n    }\r\n\r\n    \r\n\r\n    .work-enquiry-contact-info{\r\n        width: calc(100% - 57px);\r\n        margin-left: 25px;\r\n\r\n        @media (max-width: 991px) {\r\n            width: calc(100% - 37px);\r\n            margin-left: 15px;\r\n        }\r\n\r\n        span{\r\n            display: block;\r\n            margin: 0 0 5px;\r\n        }\r\n\r\n        a{\r\n            color: $white;\r\n            font-size: 20px;\r\n            font-weight: 600;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n    }\r\n    .quiry-form-bg{\r\n        background: #EAEAEA;\r\n        border-radius: 15px;\r\n        padding: 27px 20px 20px;\r\n        max-width: 500px;\r\n\r\n        @media (max-width: 575px) {\r\n            max-width: 100%;\r\n        }\r\n\r\n        label{\r\n            font-size: 24px;\r\n            font-weight: 600;\r\n            line-height: 140%;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 20px;\r\n            }\r\n        }\r\n\r\n        .section-subtitle{\r\n            color: $black;\r\n            margin-bottom: 30px;\r\n        }\r\n\r\n        form{\r\n            display: flex;\r\n            flex-direction: row;\r\n            gap: 15px;\r\n            flex-wrap: wrap;\r\n\r\n            .btn{\r\n                border-radius: 5px;\r\n            }\r\n        }\r\n\r\n        .form-field{\r\n            width: 100%;\r\n        }\r\n\r\n        .form-control{\r\n            height: 45px;\r\n            border-radius: 5px;\r\n            color: $black;\r\n            border: none;\r\n            font-size: 15px;\r\n            padding: 10px 15px;\r\n\r\n            &.is-invalid {\r\n                border: 1px solid var(--bs-form-invalid-border-color);\r\n            }\r\n\r\n            &:focus{\r\n                box-shadow: none;\r\n            }\r\n\r\n            &::-webkit-input-placeholder{\r\n                color: #696969;\r\n            }\r\n\r\n            &::-moz-input-placeholder{\r\n                color: #696969;\r\n            }\r\n\r\n            &::-ms-input-placeholder{\r\n                color: #696969;\r\n           }\r\n           &.messge{\r\n            height: 90px;\r\n           }\r\n        }\r\n    }\r\n}\r\n\r\n.footer-column-first{\r\n    max-width: 277px;\r\n\r\n    @media (max-width: 850px) {\r\n        max-width: 170px;\r\n    }\r\n\r\n    @media (max-width: 767px) {\r\n        max-width: 100%;\r\n    }\r\n\r\n    @media (max-width: 575px) {\r\n        flex: 1 0 50%;\r\n    }\r\n\r\n    @media (max-width: 400px) {\r\n        flex: 1 0 100%;\r\n    }\r\n\r\n    p{\r\n        margin-top: 20px;\r\n        color: $white;\r\n        line-height: 120%;\r\n        font-size: 14px;\r\n\r\n        @media (max-width: 850px) {\r\n            font-size: 15px;\r\n        }\r\n\r\n        @media (max-width: 400px) {\r\n            margin-bottom: 20px;\r\n        }\r\n        \r\n        a{\r\n            color: #fff;\r\n            text-decoration: underline;\r\n        }\r\n    }\r\n}\r\n\r\n.footer-column-second {\r\n    max-width: 160px;\r\n\r\n    @media (max-width: 767px) {\r\n        max-width: 100%;\r\n    }\r\n\r\n    @media (max-width: 575px) {\r\n        flex: 1 0 50%;\r\n    }\r\n}\r\n\r\n.footer-column-third{\r\n    width: 212px;\r\n    flex: unset;\r\n\r\n    @media (max-width: 991px) {\r\n        width: 200px;\r\n    }\r\n\r\n    @media (max-width: 767px) {\r\n        max-width: 100%;\r\n        flex: 1 0;\r\n        width: auto;\r\n    }\r\n\r\n    @media (max-width: 400px) {\r\n        flex: 1 0 50%;\r\n    }\r\n}\r\n\r\n.footer-column-menu{\r\n    label{\r\n        font-size: 20px;\r\n        font-weight: 600;\r\n        color: $white;\r\n        margin: 0 0 10px;\r\n        line-height: normal;\r\n\r\n        @media (max-width: 991px) {\r\n            font-size: 18px;\r\n        }\r\n    }\r\n\r\n    ul {\r\n        margin: 0px;\r\n        padding: 0;\r\n\r\n        li{\r\n            list-style: none;\r\n            margin: 0px 0 10px;\r\n            padding: 0px;\r\n            a{\r\n                color: $white;\r\n\r\n                @media (max-width: 991px){\r\n                    font-size: 15px;\r\n                    line-height: 100%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.footer-column-four{\r\n\r\n    @media (max-width: 767px){\r\n        max-width: 100%;\r\n        flex: 1 0 100%;\r\n    }\r\n\r\n    .form-field {\r\n        background: $white;\r\n        padding: 5px 10px 5px 0;\r\n        border-radius: 10px;\r\n        display: flex;\r\n\r\n        @include inputplaceholder{\r\n            background: none;\r\n            border: none;\r\n            padding: 0 17px;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 14px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .subscribe-form{\r\n        width: 443px;\r\n        max-width: 100%;\r\n\r\n        @media (max-width: 1200px) {\r\n            width: 370px;\r\n        }\r\n\r\n        @media (max-width: 1024px) {\r\n            width: 330px;\r\n        }\r\n\r\n        @media (max-width: 991px) {\r\n            width: 280px;\r\n        }\r\n\r\n        @media (max-width: 850px) {\r\n            width: 260px;\r\n        }\r\n\r\n        @media (max-width: 767px) {\r\n            margin-top: 15px;\r\n            width: 100%;\r\n        }\r\n\r\n\r\n        label{\r\n            font-size: 20px;\r\n            font-weight: 600;\r\n            color: $white;\r\n            margin: 0 0 10px;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n        .btn{\r\n            border-radius: 5px;\r\n            @media (max-width: 991px) {\r\n                font-size: 14px;\r\n                padding: 10px;\r\n            }\r\n        }\r\n    }\r\n    .social-icons {\r\n        label{\r\n            font-size: 20px;\r\n            font-weight: 600;\r\n            color: $white;\r\n            width: 100%;\r\n            margin: 0px 0 10px;\r\n            line-height: 24px;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n        gap: 5px;\r\n        &-list{\r\n            width: 40px;\r\n            height: 40px;\r\n            border-radius: 50%;\r\n            background: #fff;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n\r\n            @media (max-width: 991px) {\r\n                width: 32px;\r\n                height: 32px;\r\n                padding: 7px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.footer-top{\r\n    gap: 36px;\r\n\r\n    @media (max-width: 1100px) {\r\n        gap: 25px;\r\n    }\r\n\r\n    @media (max-width: 991px) {\r\n        gap: 0px;\r\n    }\r\n}\r\n\r\n.footer-bottom{\r\n    background: #D9D9D9;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n    font-size: 12px;\r\n\r\n    @media (max-width: 991px) {\r\n        font-size: 15px;\r\n        padding-top: 15px;\r\n        padding-bottom: 15px;\r\n    }\r\n\r\n    @media (max-width: 400px) {\r\n        font-size: 14px;\r\n        line-height: normal;\r\n        padding-top: 12px;\r\n        padding-bottom: 12px;\r\n    }\r\n    a{\r\n        color: #000;\r\n        text-decoration: underline;\r\n        margin: 0 0 0 4px;\r\n    }\r\n}\r\n\r\n.navbar-collapse{\r\n    @media (max-width: 767px) {\r\n        background: #fff;\r\n        position: absolute;\r\n        left: 0;\r\n        width: 100%;\r\n        top: 100%;\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n.navbar-toggler{\r\n\r\n    @media (max-width: 767px) {\r\n        padding: 4px 8px;\r\n    }\r\n\r\n    &:focus{\r\n        box-shadow: none;\r\n    }\r\n}\r\n\r\n.headingone{\r\n    font-size: 54px;\r\n    font-weight: 600;\r\n    color: #000;\r\n    line-height: 100%;\r\n\r\n    @media (max-width: 1200px) {\r\n        font-size: 40px;\r\n    }\r\n    \r\n    @media (max-width: 767px) {\r\n        font-size: 30px;\r\n    }\r\n}\r\n\r\n.pageHeader{\r\n    position: relative;\r\n\r\n    .headingone{\r\n        margin-bottom: 10px;\r\n        color: #fff;\r\n    }\r\n\r\n    &-Image{\r\n        img{\r\n            max-height: 450px;\r\n            object-fit: cover;\r\n\r\n            @media (max-width: 767px) {\r\n                height: 230px;\r\n                object-fit: cover;\r\n            }\r\n        }\r\n    }\r\n    &-Bg {\r\n        position: absolute;\r\n        inset: 0;\r\n        background: rgba(0,0,0,.5);\r\n    }\r\n    .breadcrumb{\r\n            margin: 0px;\r\n\r\n        .breadcrumb-item {\r\n\r\n            font-size: 18px;\r\n\r\n            @media (max-width: 767px) {\r\n                font-size: 16px;\r\n            }\r\n\r\n            &::before{\r\n                display: none;\r\n            }\r\n            a{\r\n                font-size: 18px;\r\n                color: #fff;\r\n\r\n                @media (max-width: 767px) {\r\n                    font-size: 16px;\r\n                }\r\n\r\n                &:hover{\r\n                    color: #FF4103;\r\n                }\r\n            }\r\n\r\n            &.active{\r\n                color: #fff;\r\n            }\r\n        }\r\n        .pie {\r\n            color: #fff;\r\n            line-height: normal;\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n    }\r\n}\r\n\r\n.who-we-are{\r\n    &-img{\r\n        @media (max-width: 767px){\r\n            margin-top: 20px;\r\n        }\r\n    }\r\n\r\n    img{\r\n        @media (max-width: 767px){\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    &-content{\r\n        margin-left: 26px;\r\n\r\n        @media (max-width: 767px) {\r\n            margin-left: 0;    \r\n        }\r\n    }\r\n    .section-title{\r\n        margin-bottom: 10px;\r\n    }\r\n    p{\r\n        line-height: 160%;\r\n        margin: 0 0 15px;\r\n\r\n        @media (max-width: 991px) {\r\n            font-size: 15px;\r\n        }\r\n    }\r\n\r\n    &-column-right{\r\n        @media (max-width: 767px) {\r\n            order: -1;\r\n        }\r\n    }\r\n}\r\n.about-why-choose-us{\r\n    .section-subtitle{\r\n        margin-bottom: 70px;\r\n\r\n        @media (max-width: 1024px) {\r\n            margin-bottom: 50px;\r\n        }\r\n\r\n        @media (max-width: 767px) {\r\n            margin-bottom: 40px;\r\n        }\r\n\r\n    }\r\n    .about-why-choose-us-content {\r\n        gap: 30px;\r\n        margin-bottom: 25px;\r\n        border-bottom: 1px solid #D9D9D9;\r\n        padding-bottom: 25px;\r\n\r\n        @media (max-width: 1024px) {\r\n            gap: 20px;\r\n        }\r\n\r\n        img{\r\n            width: 40px;\r\n            height: auto;\r\n\r\n            \r\n        }\r\n\r\n        &-list{\r\n            width: calc(100% - 70px);\r\n\r\n            label{\r\n                font-size: 20px;\r\n                font-weight: 600;\r\n                color: #000;\r\n                vertical-align: top;\r\n                line-height: 120%;\r\n                margin: 0 0 10px;\r\n                \r\n                @media (max-width: 1024px) {\r\n                    font-size: 18px;\r\n                }\r\n            }\r\n            p{\r\n                @media (max-width: 1024px) {\r\n                    font-size: 15px;\r\n                }\r\n\r\n                @media (max-width: 767px) {\r\n                    font-size: 14px;\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    &-img{\r\n\r\n        @media (max-width: 767px) {\r\n            margin-top: 20px;\r\n        }\r\n\r\n        img{\r\n            @media (max-width: 767px) {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.company-fun-fact{\r\n    background: #020626;\r\n    padding: 110px 0px;\r\n\r\n    @media (max-width: 767px) {\r\n        padding: 50px 0px;\r\n    }\r\n\r\n    &-column-left{\r\n\r\n        @media (max-width: 767px) {\r\n            margin-bottom: 40px;\r\n        }\r\n\r\n        span{\r\n            font-size: 20px;\r\n            color: #FF4103;\r\n            margin-bottom: 10px;\r\n            display: block;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n        h4{\r\n            font-size: 50px;\r\n            color: #fff;\r\n            max-width: 502px;\r\n            font-weight: 700;\r\n            max-width: 500px;\r\n\r\n            @media (max-width: 1200px) {\r\n                font-size: 40px;\r\n            }\r\n\r\n            @media (max-width: 1100px) {\r\n                max-width: 380px;\r\n            }\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 35px;\r\n                max-width: 350px;\r\n            }\r\n\r\n            @media (max-width: 820px) {\r\n                font-size: 30px;\r\n                max-width: 300px;\r\n            }\r\n        }\r\n    }\r\n    &-column-right{\r\n        gap: 65px;\r\n\r\n        @media (max-width: 1200px) {\r\n            gap: 45px;\r\n        }\r\n\r\n        @media (max-width: 991px) {\r\n            gap: 30px;\r\n        }\r\n\r\n        @media (max-width: 850px) {\r\n            gap: 20px;\r\n        }\r\n\r\n        img{\r\n            max-height: 68px;\r\n            margin: 0 0 20px;\r\n        }\r\n    }\r\n    &-status{\r\n        align-items: center;\r\n        label{\r\n            font-size: 50px;\r\n            color: #fff;\r\n            font-weight: 700;\r\n            line-height: 100%;\r\n            margin: 0 0 10px;\r\n\r\n            @media (max-width: 1200px) {\r\n                font-size: 40px;\r\n            }\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 35px;\r\n            }\r\n            @media (max-width: 820px) {\r\n                font-size: 30px;\r\n            }\r\n        }\r\n        span{\r\n            font-size: 20px;\r\n            color: #8E8F8F;\r\n\r\n            @media (max-width: 1200px) {\r\n                font-size: 18px;\r\n            }\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.our-team{\r\n\r\n    margin-bottom: 122px;\r\n\r\n    @media (max-width: 1200px) {\r\n        padding: 0px;\r\n    }\r\n\r\n    @media (max-width: 767px) {\r\n        margin-bottom: 100px;\r\n    }\r\n\r\n    .row {\r\n\r\n        @media (max-width: 1200px) {\r\n            margin-left: 0;\r\n            margin-right: 0px;\r\n        }\r\n    }\r\n\r\n    .section-subtitle{\r\n        margin-bottom: 50px;\r\n\r\n        @media (max-width: 767px) {\r\n            margin-bottom: 40px;\r\n        }\r\n    }\r\n\r\n    &-list{\r\n        margin: 0 15px;\r\n        max-width: calc(100% - 30px);\r\n\r\n        @media (max-width: 767px) {\r\n            margin: 0 10px;\r\n            max-width: calc(100% - 20px);\r\n        }\r\n\r\n        img{\r\n            width: 100%;\r\n            border-radius: 5px;\r\n        }\r\n        label{\r\n            font-size: 20px;\r\n            font-weight: 600;\r\n            margin: 20px 0px 0px;\r\n            line-height: 120%;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 18px;\r\n                margin-top: 15px;\r\n            }\r\n        }\r\n        span{\r\n            display: block;\r\n            color: #000;\r\n            line-height: 120%;\r\n            margin: 10px 0 0;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 15px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .slick-dots{\r\n        bottom: -52px;\r\n        height: 10px;\r\n\r\n        li {\r\n            width: 10px;\r\n            height: 10px;\r\n            background: #D9D9D9;\r\n            border-radius: 50%;\r\n            vertical-align: top;\r\n            margin: 0 2.5px;\r\n\r\n            button {\r\n                padding: 0px;\r\n                width: 100%;\r\n                height: 100%;\r\n\r\n                &::before{\r\n                    display: none;\r\n                }\r\n            }\r\n            &.slick-active{\r\n                background: #FF4103;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.our-blog{\r\n    .section-subtitle{\r\n        margin-bottom: 50px;\r\n\r\n        @media (max-width: 991px) {\r\n            margin-bottom: 40px;\r\n        }\r\n\r\n        @media (max-width: 991px) {\r\n            margin-bottom: 30px;\r\n        }\r\n    }\r\n\r\n    & > .row{\r\n        &:nth-child(2) {\r\n            gap: 24px 0px;\r\n\r\n            @media (max-width: 767px) {\r\n                gap: 12px 0px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &-list{\r\n        box-shadow: 0 0 14px rgba(0, 0, 0, .1);\r\n        border-radius: 10px;\r\n    }\r\n\r\n    &-list-content{\r\n        padding: 15px 15px 20px;\r\n\r\n        label{\r\n            font-weight: 600;\r\n            vertical-align: top;\r\n            line-height: 120%;\r\n            margin: 0 0 10px;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 15px;\r\n            }\r\n        }\r\n\r\n        p{\r\n            line-height: 107%;\r\n            margin: 0px;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 15px;\r\n            }\r\n        }\r\n\r\n        a{\r\n          font-size: 14px;  \r\n          color: #FF4103;\r\n\r\n          svg{\r\n            width: 7px;\r\n          }\r\n        }\r\n    }\r\n}\r\n\r\n.get-in-touch{\r\n\r\n    margin-top: 80px;\r\n    margin-bottom: 80px;\r\n\r\n    @media (max-width: 991px) {\r\n        margin-top: 50px;\r\n        margin-bottom: 50px;\r\n    }\r\n\r\n    &-bg{\r\n        background: #111539;\r\n        padding: 40px;\r\n\r\n        @media (max-width: 991px) {\r\n            padding: 40px 30px;\r\n        }\r\n\r\n        @media (max-width: 767px) {\r\n            padding: 30px;\r\n        }\r\n\r\n        @media (max-width: 400px) {\r\n            padding: 30px 20px;\r\n        }\r\n\r\n        \r\n        .section-title{\r\n            color: #FF4103;\r\n            margin: 0px 0 38px;\r\n        }\r\n    }\r\n\r\n    &-list{\r\n        margin-bottom: 30px;\r\n\r\n        @media (max-width: 767px) {\r\n            margin-bottom: 20px;\r\n        }\r\n\r\n        svg{\r\n            width: 25px;\r\n        }\r\n    }\r\n\r\n    &-list-content{\r\n        max-width: calc(100% - 46px);\r\n        label{\r\n            color: #FF4103;\r\n            font-size: 20px;\r\n            line-height: 120%;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n        span{\r\n            display: block;\r\n            font-size: 18px;\r\n            line-height: 120%;\r\n            margin: 10px 0 0;\r\n            color: #fff;\r\n\r\n            @media (max-width: 991px) {\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &-formbg{\r\n        background: #E5E5E5;\r\n        padding: 50px;\r\n\r\n        @media (max-width: 991px) {\r\n            padding: 50px 30px;\r\n        }\r\n\r\n        @media (max-width: 767px) {\r\n            padding: 40px 30px;\r\n        }\r\n\r\n        @media (max-width: 400px) {\r\n            padding: 30px 20px;\r\n        }\r\n\r\n        form{\r\n            gap: 15px;\r\n        }\r\n\r\n        @include inputplaceholder {\r\n            height: 45px;\r\n            border: none;\r\n            font-size: 15px;\r\n            padding: 10px 15px;\r\n            border-radius: 4px;\r\n        }\r\n\r\n        .message{\r\n            height: 85px;\r\n            padding: 10px 15px;\r\n        }\r\n\r\n        .btn{\r\n            border-radius: 5px;\r\n            border: none;\r\n            align-self: flex-start;\r\n            font-size: 16px;\r\n        }\r\n    }\r\n}\r\n\r\n.service {\r\n    .section-subtitle{\r\n        margin-bottom: 87px;\r\n    }\r\n\r\n    &-row-bottom{\r\n        gap: 81px 0px;\r\n\r\n        @media (max-width: 767px) {\r\n            gap: 60px 0px;\r\n        }\r\n    }\r\n\r\n    &-list{\r\n        border: 1px solid #000;\r\n        border-radius: 10px;\r\n        height: 100%;\r\n    \r\n        &-content {\r\n            text-align: center;\r\n            padding: 0 20px;\r\n    \r\n            label{\r\n                font-weight: 600;\r\n                font-size: 20px;\r\n                vertical-align: top;\r\n                line-height: 120%;\r\n                margin: 0 0 20px;\r\n\r\n                @media (max-width: 991px) {\r\n                    font-size: 18px;\r\n                    margin-bottom: 15px;\r\n                }\r\n            }\r\n            p{\r\n                line-height: 160%;\r\n                margin-bottom: 20px;\r\n\r\n                @media (max-width: 991px) {\r\n                    font-size: 15px;\r\n                    line-height: 150%;\r\n                }\r\n            }\r\n        }\r\n    \r\n        &-icon{\r\n            width: 75px;\r\n            height: 75px;\r\n            border-radius: 8px;\r\n            background: #000000;\r\n            align-items: center;\r\n            justify-content: center;\r\n            margin: -37.5px auto 30px;\r\n            flex: unset;\r\n        }\r\n    }\r\n\r\n    .read-more{\r\n        margin-top: auto;\r\n        margin-bottom: 20px;\r\n        display: inline-flex;\r\n        align-items: center;\r\n\r\n        svg{\r\n            width: 8px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.service-request{\r\n    .service-form{\r\n        background: #E1E1E1;\r\n        padding: 40px 95px;\r\n        margin-bottom: 50px;\r\n\r\n        @media (max-width: 991px) {\r\n            padding: 30px 15px;\r\n        }\r\n\r\n        h2{\r\n            font-size: 30px;\r\n            color: #FF4103;\r\n            text-align: center;\r\n            font-weight: 600;\r\n            margin: 0 0 34px;\r\n\r\n            @media (max-width: 767px) {\r\n                font-size: 25px;\r\n                margin: 0 0 20px;\r\n            }\r\n        }\r\n\r\n        @include inputplaceholder {\r\n            height: 45px;\r\n            border: none;\r\n            font-size: 15px;\r\n            padding: 10px 15px;\r\n            border-radius: 6px;\r\n        }\r\n        .form-field{\r\n            max-width: calc(50% - 10px);\r\n\r\n            @media (max-width: 450px) {\r\n                max-width: 100%;\r\n            }\r\n        }\r\n\r\n        .message{\r\n            height: 85px;\r\n        }\r\n\r\n        .btn{\r\n            border-radius: 5px;\r\n            border: none;\r\n            align-self: flex-start;\r\n            font-size: 16px;\r\n            width: auto;\r\n            margin-top: 16px;\r\n        }\r\n    }\r\n}\r\n\r\n.hire-dedicated-developer{\r\n    p{\r\n        margin-top: 20px;\r\n    }\r\n    .btn {\r\n        border-radius: 30px;\r\n        margin: 20px 0 0;\r\n\r\n        svg {\r\n            width: 15px;\r\n            animation: arrowMoving 1.4s infinite;\r\n\r\n            @keyframes arrowMoving{\r\n                0% {\r\n                    transform: translate3d(0, 0, 0);\r\n                }\r\n                \r\n                100% {\r\n                    transform: translate3d(10px, 0, 0);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.get-in-touch{\r\n    .form-label {\r\n        font-size: 14px;\r\n        margin-bottom: 4px;\r\n    }\r\n    @include inputplaceholder{\r\n        height: 45px;\r\n        font-size: 14px;\r\n        padding: 10px 15px;\r\n        border-radius: 6px;\r\n        &:focus{\r\n            border-color: #dee2e6;\r\n        }\r\n    }\r\n    .form-control{\r\n        height: 45px;\r\n        font-size: 14px;\r\n    }\r\n    textarea{\r\n        &.form-control{\r\n            height: 85px;\r\n        }\r\n    }\r\n}\r\n\r\n.trusted-companies{\r\n\r\n    h2{\r\n        margin-bottom: 40px;\r\n        position: relative;\r\n\r\n        &::before {\r\n            content: \"\";\r\n            width: 100px;\r\n            height: .5px;\r\n            display: inline-block;\r\n            background: rgba(0, 0, 0, .4);\r\n            vertical-align: middle;\r\n            position: absolute;\r\n            top: 50%;\r\n            transform: translate(calc(-50% - 140px), -50%);\r\n            left: 50%;\r\n        }\r\n\r\n        &::after {\r\n            content: \"\";\r\n            width: 100px;\r\n            height: .5px;\r\n            display: inline-block;\r\n            background: rgba(0, 0, 0, .4);\r\n            vertical-align: middle;\r\n            position: absolute;\r\n            top: 50%;\r\n            transform: translate(calc(20% - 5px), -50%);\r\n        }\r\n    }\r\n    .slick-slide{\r\n        & > div{\r\n            &:focus-visible{\r\n                outline: none;\r\n            }\r\n        }\r\n    }\r\n    .partners-logo{\r\n        img{\r\n            max-height: 100px;\r\n            margin: 0 auto;\r\n\r\n            &:focus{\r\n                outline: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.why-hire-dedicated-developers{\r\n\r\n    h2{\r\n        margin-bottom: 25px;\r\n    }\r\n    \r\n    p{\r\n        margin: 0 0 25px;\r\n    }\r\n    ul {\r\n        margin: 0px;\r\n        li{\r\n            margin: 0 0 20px;\r\n        }\r\n    }\r\n}\r\n\r\n.dream-team-bg{\r\n    background: rgba(32, 47, 63, 1);\r\n    padding: 60px 0px;\r\n    margin-bottom: 50px;\r\n\r\n    p{\r\n        margin-bottom: 40px;\r\n    }\r\n\r\n    .nav-tabs{\r\n        border: none;\r\n        justify-content: center;\r\n        margin-bottom: 50px;\r\n\r\n        .nav-item {\r\n            flex-grow: 0;\r\n            flex-basis: auto;\r\n\r\n            .nav-link{\r\n                font-size: 18px;\r\n                color: #fff;\r\n                border: none;\r\n                border-radius: 0;\r\n                padding: 8px 25px;\r\n\r\n                &.active{\r\n                    background: #0b1a2b;\r\n                    border-radius: 6px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .hire-developers-teams{\r\n        gap: 15px;\r\n        justify-content: center;\r\n    }\r\n    .hire-developers-teams-list{\r\n        width: calc(25.05% - 12px);\r\n        flex-grow: unset;\r\n\r\n        a{\r\n            width: 100%;\r\n            background: rgba(11,26,43,1.0);\r\n            flex: unset;\r\n            align-items: center;\r\n            justify-content: center;\r\n            padding: 20px;\r\n            border-radius: 10px;\r\n            display: flex;\r\n            flex-direction: column;\r\n            height: 100%;\r\n        }\r\n        img{\r\n            max-width: 55px;\r\n        }\r\n        span{\r\n            color: #fff;\r\n            margin: 15px 0 0;\r\n        }\r\n    }\r\n    .default-btn-style {\r\n        margin-top: 30px;\r\n    }\r\n}\r\n\r\n.faq-section{ \r\n    h2{\r\n        font-weight: 600;\r\n    }\r\n    p{\r\n        text-align: center;\r\n        margin: 0 0 20px;\r\n    }\r\n    .accordion{\r\n        display: flex;\r\n        gap: 20px;\r\n        flex-direction: column;\r\n        .accordion-item{\r\n            border: 1px solid #e4e4e4;\r\n            border-radius: 10px;\r\n\r\n            &:first-of-type{\r\n                border-radius: 10px;\r\n            }\r\n\r\n            .accordion-button{\r\n                border-radius: 10px 10px 0 0;\r\n                font-weight: 600;\r\n                font-size: 20px;\r\n                box-shadow: none;\r\n                background: none;\r\n                color: #000;\r\n                padding: 20px;\r\n\r\n                &::before{\r\n                    content: \"\";\r\n                    clear: both;\r\n                    display: block;\r\n                    background: #FF4103;\r\n                    height: 3px;\r\n                    width: 18px;\r\n                    border-radius: 3px;\r\n                    position: absolute;\r\n                    right: 20px;\r\n                }\r\n\r\n                &::after{\r\n                    content: \"\";\r\n                    clear: both;\r\n                    display: block;\r\n                    background: #FF4103;\r\n                    height: 18px;\r\n                    width: 3px;\r\n                    border-radius: 3px;\r\n                    position: absolute;\r\n                    right: 27px;\r\n                    display: none;\r\n                }\r\n                &.collapsed{\r\n                    &::after{\r\n                        display: block;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        .accordion-body{\r\n            padding: 20px;\r\n            font-size: 16px;\r\n            line-height: 160%;\r\n            margin: 0 20px;\r\n            border-top: 1px solid #e4e4e4;\r\n\r\n            ul {\r\n                margin: 0px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.our-testimonial-gap{\r\n    margin-bottom: 120px;\r\n}\r\n\r\n.expertise-angular-developer{\r\n    margin-top: 50px;\r\n\r\n    &-top-portion{\r\n        p {\r\n            margin: 0 auto 50px;\r\n            max-width: 800px;\r\n        }\r\n    }\r\n    &-bottom-portion {\r\n        gap: 24px 0px;\r\n        &-list{\r\n            background: rgba(255,255,255,1.0);\r\n            border: 1px solid rgb(0 0 0 / 10%);\r\n            padding: 20px;\r\n            border-radius: 10px;\r\n            height: 100%;\r\n\r\n            img{\r\n                max-width: 50px;\r\n                margin: 0 auto;\r\n            }\r\n\r\n            label {\r\n                font-size: 20px;\r\n                font-weight: 600;\r\n                text-align: center;\r\n                margin: 20px 0 10px;\r\n            }\r\n\r\n            p{\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.back-to-site{\r\n    gap: 15px;\r\n    margin: 25px 0 0;\r\n}\r\n\r\n.notfound{\r\n    max-width: 600px;\r\n    margin: 50px auto;\r\n\r\n    img{\r\n        margin: 0 auto;\r\n    }\r\n\r\n    h1{\r\n        font-size: 30px;\r\n        margin: 20px 0 15px;\r\n        font-weight: 600;\r\n    }\r\n}\r\n.hire-content-container {\r\n    margin-bottom: 70px;\r\n}\r\n.hire-content-info {\r\n    margin-top: 30px;\r\n    h2 {\r\n        font-size: 30px;\r\n        font-weight: 600;\r\n        margin: 0 0 10px;\r\n    }\r\n    p {\r\n        color: #645a5a;\r\n    }\r\n    ul {\r\n        display: flex;\r\n        gap: 10px;\r\n        flex-direction: column;\r\n        margin: 0;\r\n\r\n        li{\r\n            color: #645a5a;\r\n        }\r\n    }\r\n}\r\n.footer-top-bg{\r\n    background: #000;\r\n    padding: 50px 0;\r\n}\r\n.modal-content {\r\n    .modal-header {\r\n        .btn-close{\r\n            box-shadow: none;\r\n            padding: 0px;\r\n            border-radius: 0;\r\n            margin: 0 0 0 auto;\r\n        }\r\n    }\r\n    \r\n}\r\n.our-blog-post {\r\n    h2 {\r\n        font-size: 26px;\r\n        font-weight: 600;\r\n        margin: 30px 0 20px;\r\n    }\r\n    &-list{\r\n        gap: 20px;\r\n        border-bottom: 1px solid rgba(0, 0, 0, .1);\r\n        padding: 0 0 20px;\r\n\r\n        &-content{\r\n            width: calc(100% - 220px);\r\n            \r\n            span{\r\n                font-size: 14px;\r\n                margin: 0 0 7px;\r\n            }\r\n        }\r\n\r\n        &:last-child{\r\n            border: none;\r\n            padding: 0;\r\n        }\r\n        \r\n\r\n        label {\r\n            font-weight: 600;\r\n            font-size: 18px;\r\n            margin: 0px;\r\n            line-height: normal;\r\n        }\r\n        p{\r\n            font-size: 15px;\r\n            line-height: normal;\r\n            margin: 0 0 5px;\r\n        }\r\n\r\n        a{\r\n            margin-right: auto;\r\n            color: #FF4103;\r\n            font-size: 14px;\r\n            margin-top: auto;\r\n\r\n            svg{\r\n                margin-left: 5px;\r\n            }\r\n        }\r\n    }\r\n    &-column{\r\n        padding: 15px;\r\n        border: 1px solid rgba(0, 0, 0, .1);\r\n        border-radius: 10px;\r\n        gap: 20px;\r\n        margin: 0 0 40px;\r\n    }\r\n\r\n    &-right-column{\r\n        .blog-post-img{\r\n            width: 100px;\r\n            height: 80px;\r\n        }\r\n        .our-blog-post-list{\r\n            gap: 12px;\r\n\r\n            label{\r\n                font-size: 16px;\r\n            }\r\n        }\r\n        .our-blog-post-list-content {\r\n            width: calc(100% - 120px);\r\n        }\r\n    }\r\n}\r\n.blog-post-img {\r\n    width: 200px;\r\n    height: 130px;\r\n\r\n    img {\r\n        border-radius: 5px;\r\n        height: 100%;\r\n        object-fit: cover;\r\n    }\r\n}\r\n.our-blog-post-right-column{\r\n    h2 {\r\n        margin: 81px 0 20px;\r\n        font-size: 20px;\r\n    }\r\n    .our-blog-post-list{\r\n        margin: 0 0 20px;\r\n    }\r\n}\r\n.blog-detail-content{\r\n        margin: 20px 0 50px;\r\n        gap: 20px;\r\n    p{\r\n        font-size: 15px;\r\n        color: #696969;\r\n    }\r\n}\r\n\r\n.our-blog-post-detail {\r\n    margin-top: 60px;\r\n\r\n    .our-blog-post-right-column {\r\n        h2 {\r\n            margin-top: 0px;\r\n        }\r\n    }\r\n}\r\n\r\n.contact-items-img {\r\n    width: 50px;\r\n    height: 50px;\r\n    background: #fff;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, .2);\r\n    border-radius: 50%;\r\n    padding: 12px;\r\n    flex: unset;\r\n}\r\n.contact-items {\r\n    gap: 15px;\r\n    align-items: center;\r\n    margin: 0 0 20px;\r\n\r\n    span{\r\n        width: calc(100% - 100px);\r\n    }\r\n}\r\n.contact-content{\r\n    h2 {\r\n        margin: 50px 0 20px;\r\n        text-align: center;\r\n    }\r\n    a {\r\n        color: #000;\r\n        text-decoration: underline;\r\n    }\r\n}\r\n.contact-content{\r\n    .form-container{\r\n        background: #fff;\r\n        box-shadow: 0 0 20px hsla(0, 0%, 62%, .16);\r\n        padding: 30px;\r\n        margin: 0px 0 50px;\r\n        \r\n        .form-control{\r\n            height: 45px;\r\n            &:focus{\r\n                box-shadow: none;\r\n                border-color: #dee2e6;\r\n            }\r\n        }\r\n    }\r\n}\r\n.contactmap{\r\n    vertical-align: top;\r\n}","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
